/* Clean-injectie voor de echte Rip Studio-pagina (versie-b-clean.html).
   Hoort bij clean-inject.css en maak-clean-preview.sh. Vijf ingrepen, alleen desktop (vanaf 1100 px):
   1. Mandje als lade: de rechterkolom (.col-r) schuift als lade van rechts in beeld; in de header komt een pil
      "Mandje · EUR X · N"; CARDIX krijgt een ronde zwevende knop rechtsonder die het echte CARDIX-paneel opent.
   2. Focus-header: een dunne balk (logo, zoekbalk, LIVE, mandje-pil, account); de tweede navigatiebalk is weg, een
      hamburger opent de links als dropdown (de bestaande #navMenu van de pagina).
   3. De linker streamkolom blijft ongemoeid.
   4. Een filterlaag: begroeting + wissel Shop (voorheen Bladeren) / Samenstellen / Chase zoeken op een regel, franchise enkel in de budgetkaart
      (logica uit topbalk concept 1, hier gekopieerd en hernoemd, topbalk-inject.js blijft ongemoeid).
   5. Minder kaders: enkel CSS (clean-inject.css).
   Preview-schakelaars linksonder: Layout (Origineel/Clean), Filters (A tot E) en Categorie (1 tot 5: de bediening van de categorie in de
   filterregel van E, zie CAT_PROD en catSlotHTML).

   Koppeling aan de echte logica: de pagina is een IIFE, dus alles loopt via programmatische klikken op de (verborgen)
   originelen (display:none-elementen accepteren click() en dispatchEvent). Waarden komen uit de echte DOM.
   Synchronisatie: een lichte poll (setInterval 250 ms) leest de echte toestand en werkt enkel
   de eigen elementen bij; de poll blijft lopen omdat de budgetkaart bij taal- of categoriewissel opnieuw wordt opgebouwd.
   Daarnaast een MutationObserver enkel op de kinderlijst van #gGrid: hij styleert en verbergt lui bijgeladen tegels vlak voor de
   paint. Hij wijzigt alleen de tegels zelf (nooit die kinderlijst), dus hij jaagt zichzelf niet op. Verder geen observers. */
(function () {
  'use strict';
  /* Productiemodus (maak-clean-prod.sh zet dit op true): Clean altijd aan, filtervariant vast op E, geen schakelpaneel,
     geen console-uitvoer. In deze bronversie false, zodat de preview het schakelpaneel houdt. */
  var CLEAN_PROD = true;
  if (window.__clInject) return;
  window.__clInject = true;

  var KEY = 'cwCleanVariant';
  var S = { texts: [], on: false, timer: null, t2: null, autoT: null, units: null, pillH: '', greet: '', menuTxt: null,
            fr: 'all', grp: '', sub: '', lang: '', P: undefined, labels: {}, hiding: false,
            q: '', qt: [], v: 'E', cv: '1', kies: true, imgs: {}, pop: null, popA: null, M: null, ft: 'lab' };
  var VKEY = 'cwCleanFilterVariantV3', CKEY = 'cwCleanCatVariant', KKEY = 'cwCleanKies';
  /* Categorie-bediening in filtervariant E (body.cl-c1 .. cl-c5), schakelaar "Categorie 1 2 3 4 5" in het paneel linksonder:
     1 label CATEGORIE + een tekst-tab "Alle" met onderlijn (zoals TAAL), 2 groepen als tekst-tabs (terugval op 1 als de rij niet past),
     3 de bestaande knop zonder rand (ghost, ook Filters en Aanbevolen), 4 kruimel in de kop boven de filterregel, 5 kruimel in kaartstijl
     (bolletje in de franchisekleur). Gedeelde toestand (groep, subtype, tellingen, hash, Wis filters, sticky balk) is voor alle vijf gelijk.
     In productie geldt CAT_PROD (keuze Andrea 2026-10-07: 5, kaartstijl-kruimel). */
  var CAT_PROD = '5';
  /* KIES (body.cl-kies, schakelaar "Kies aan/uit"): zolang er niets gekozen is tonen categorie en taal een gestippelde placeholder
     "Kies categorie..." / "Kies taal..." (zoals de originele pagina); gekozen wordt het de waarde in de stijl van de variant, met kruisje.
     Geldt bovenop C1, C3, C4 en C5; in C2 (groepen als tabs) niet. In productie KIES_PROD. */
  var KIES_PROD = true;
  /* MODUS (body en html .cl-m1 .. .cl-m5, schakelaar "Modus 0 1 2 3 4 5" in het paneel linksonder): de plaats en uitstraling van de wissel Shop, Rip Lab.
     0 = het huidige kleine segment rechtsboven. 1 grote keuzekaarten boven de inhoud, 2 hoofdnavigatie in de donkere header (tekst met gouden onderlijn),
     3 titel-tabs in Anton met de begroeting als eyebrow, 4 groot gecentreerd segment met gevulde pil, 5 zwevend dock onderaan. De logica (wissel, hash, sticky segment,
     indicator) is voor alle gelijk. In productie geldt MODUS_PROD.
     6 mappen: drie even brede maptabs, gecentreerd en zonder tussenruimte, die vergroeien met de kaart eronder (de actieve tab is het deksel van de inhoud); bij scrollen in Shop worden
       de tabs compact en hangt de sticky filterbalk er direct onder, zodat de keuze altijd leesbaar blijft.
     7 keuzestrip met voorproef: een balk in drie vakken in vaste volgorde; het actieve vak schuift breed open als donkere heroband (waar je bent),
       de andere twee tonen een voorproef van wat erachter zit (echte uitsneden, je budget, het product dat in je feed klaarstaat); bij scrollen in
       Shop wijkt de strip en toont de sticky balk een compacte wissel met labels.
     8 schakelaar "drie manieren om te shoppen" (redesign-skill, 10 okt): het witte segment naast de begroeting, groter, met werkwoord plus korte uitleg
       per manier en een glijdende indicator; onder 1100 px een vaste balk bovenaan, net onder de kopbalk (.cl-mbar). Dit is de productiemodus. */
  var MODUS_PROD = '8';
  var MKEY = 'cwCleanModus';
  /* MAP (body en html .cl-m6a .. .cl-m6c, schakelaar "Map A B C", enkel zichtbaar in modus 6): verfijning van de maptabs.
     A zwevende tabs met lucht (8 px tussenruimte, inactief een zacht lavendel blok, enkel de actieve tab met voetjes),
     B zachte mappen (4 px, bovenhoeken 24, voetjes 14, inactief lager en lichter, schaduw enkel op de actieve tab),
     C segment-map (een container met 6 px binnenpadding, de actieve tab een witte pil die via voetjes in de kaart loopt). In productie MAP_PROD. */
  var MAP_PROD = 'A';
  var MAPKEY = 'cwCleanMap';

  /* ---------- naam van het derde segment (AI-builder): HIER aanpassen ---------- */
  var BUILDER_NAAM = 'Rip Lab';
  /* 3D bij hover op de rastertegels (en het 3D-labeltje): voorlopig uit. Op true zetten om terug aan te zetten. */
  var HOVER_3D = false;
  /* korte namen voor subtypes (sleutel = de naam zoals de pagina hem toont) */
  var SHORT = { 'Booster Bundles': 'Bundles' };
  /* enkel in het megamenu ingekort (volledige naam in title) */
  var MSHORT = { 'Elite Trainer Boxen (ETB)': 'ETB', 'Ultra Premium Collection': 'Ultra Premium' };
  /* interne categorieen: niet in het menu en niet in de tellingen van de groepen; de producten blijven bij "Alles" zichtbaar */
  var HIDE_CATS = ['Livestream'];
  var hiddenCat = function (c) { var n = String(c == null ? '' : c).toLowerCase().trim(); return HIDE_CATS.some(function (x) { return x.toLowerCase() === n; }); };

  /* ---------- productgroepen in Alle producten: HIER aanpassen ----------
     cats: de echte category-waarden van de pagina (hoofdletters en spaties maken niet uit).
     rest: categorieen die in geen enkele lijst staan vallen automatisch in de groep met rest:true. */
  /* 10 okt: categorieen exact zoals cardworld.be (category:-tags, elk telt mee); Spel = de spelcategorieen van Andere TCG.
     l = de NL-naam; grpLabel vertaalt via window.CW_RS_CATLBL (app.js, tabel van cw-shop.liquid). */
  var GROUPS = [
    { k: 'packs', l: 'Packs', cats: ['Booster Packs', 'Booster Bundles', 'Blisters', 'Blister Packs', 'Double Packs', 'Sleeved Boosters', 'Mystery Packs'] },
    { k: 'boxes', l: 'Boxen', cats: ['Booster Boxen', 'Elite Trainer Boxen (ETB)', 'Collection Boxen', 'Ultra Premium Collection', 'Mystery Boxes'] },
    { k: 'tins', l: 'Tins', cats: ['Tins'] },
    { k: 'game', l: 'Spel', cats: ['Disney Lorcana', 'Yu-Gi-Oh', 'Dragon Ball Super', 'Riftbound'] },
    { k: 'special', l: 'Speciaal', cats: ['Vintage', 'Mystery Slabs', 'Devil Fruits', 'Livestream'], rest: true }
  ];

  /* ---------- hulpjes ---------- */
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  /* 18 okt (perf, Samenstellen op gsm): de pollers (400 ms en 300 ms) zochten telkens het hele document af; deze lijsten veranderen zelden, dus even bewaren */
  var QC = {};
  var $$c = function (s, ms) { var c = QC[s], n = Date.now(); if (c && n - c.t < ms && c.l.every(function (e) { return e.isConnected; })) return c.l; c = QC[s] = { t: n, l: $$(s) }; return c.l; };
  var txt = function (el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; };
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var desk = function () { return window.matchMedia && window.matchMedia('(min-width:1100px)').matches; };
  var mode = function () { return document.body.classList.contains('mode-grid') ? 'all' : 'feed'; };
  /* doorlopende pagina (html.cl-flow, 11 okt, Andrea: "ik wil dat de pagina doorloopt"): zolang Clean aan staat is in Bladeren en Chase zoeken
     (en op gsm ook in Samenstellen) het venster de scroller, niet meer #gScroll of de host. Deze hulpjes lezen en zetten de scrollpositie van
     het raster in beide werelden; zonder cl-flow (Clean uit) blijft alles op #gScroll zoals voorheen. Zie het blok DOORLOPENDE PAGINA in de css. */
  var flowOn = function () { return document.documentElement.classList.contains('cl-flow'); };
  var winY = function () { return window.pageYOffset || document.documentElement.scrollTop || 0; };
  function cssPx(name) { var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue(name)); return isFinite(v) ? v : 0; }
  function gsTop() { if (flowOn()) return winY(); var sc = $('#gScroll'); return sc ? sc.scrollTop : 0; }
  function gsSet(y) {
    if (flowOn()) { if (document.body.classList.contains('mode-grid') && Math.abs(winY() - y) > 1) window.scrollTo(0, y); return; }
    var sc = $('#gScroll'); if (sc) sc.scrollTop = y;
  }
  function gsBy(d) { if (flowOn()) window.scrollBy(0, d); else { var sc = $('#gScroll'); if (sc) sc.scrollTop += d; } }
  /* scrollevent van het raster: het venster (doel document) met cl-flow, anders #gScroll */
  function gsEvt(e) { var t = e && e.target; if (!t) return false; return flowOn() ? (t === document || t === document.documentElement || t === document.body) : t.id === 'gScroll'; }
  /* bovenrand van het zichtbare rastervlak in het venster: de kopbalk met cl-flow, anders de bovenrand van #gScroll */
  function gsRootTop() { var sc = $('#gScroll'); return flowOn() ? cssPx('--hdr') : (sc ? sc.getBoundingClientRect().top : 0); }
  /* de gekozen manier: grid (Bladeren), lab (Samenstellen) of chase (Chase zoeken); lab en chase delen de feedweergave van de pagina (S.ft).
     In Bladeren valt S.ft terug op lab: een pad van de pagina zelf naar de feed (CARDIX, een product in de feed, een deeplink) toont dan nooit Chase zoeken */
  var curView = function () { if (mode() === 'all') { S.ft = 'lab'; return 'grid'; } return S.ft === 'chase' ? 'chase' : 'lab'; };
  /* 16 okt (Andrea): bij een productlink (#p=) staat de pagina eronder nog in Samenstellen tot het product sluit (fgSync); de balk toont dan al Shop */
  var shownView = function () { return S.fgGrid ? 'grid' : curView(); };
  /* 16 okt (audit): vaste labels van de Shop per taal (nl, fr, en; dezelfde taalbepaling als lang()). Mystery blijft een merknaam */
  var LBL = {
    all: { nl: 'Alles', fr: 'Tout', en: 'All' }, alle: { nl: 'Alle', fr: 'Toutes', en: 'All' },
    oth: { nl: 'Andere TCG', fr: 'Autres TCG', en: 'Other TCG' },
    kcat: { nl: 'Kies categorie...', fr: 'Choisir une cat\u00e9gorie...', en: 'Choose category...' },
    klang: { nl: 'Kies taal...', fr: 'Choisir une langue...', en: 'Choose language...' },
    cat: { nl: 'Categorie', fr: 'Cat\u00e9gorie', en: 'Category' }, lang: { nl: 'Taal', fr: 'Langue', en: 'Language' },
    allcat: { nl: 'Alle categorie\u00ebn', fr: 'Toutes les cat\u00e9gories', en: 'All categories' },
    alllang: { nl: 'Alle talen', fr: 'Toutes les langues', en: 'All languages' },
    clrcat: { nl: 'Categorie wissen', fr: 'Effacer la cat\u00e9gorie', en: 'Clear category' },
    clrlang: { nl: 'Taal wissen', fr: 'Effacer la langue', en: 'Clear language' },
    wisf: { nl: 'Wis filters', fr: 'Effacer les filtres', en: 'Clear filters' },
    zoek: { nl: 'Zoek ', fr: 'Rechercher ', en: 'Search ' }
  };
  var LB = function (k) { return LBL[k][lang()]; };
  /* franchisenamen zoals de winkel ze toont: Other TCG (of een eerder vertaald label) in de taal van de pagina, Pokemon altijd met accent (16 okt) */
  var andere = function (s) { return String(s).replace(/Other TCG|Andere TCG|Autres TCG/gi, LB('oth')).replace(/\bPokemon\b/g, 'Pok\u00e9mon'); };
  var lang = function () { var l = (document.documentElement.lang || 'nl').slice(0, 2); return l === 'fr' || l === 'en' ? l : 'nl'; };
  var T = {
    cart: { nl: 'Mandje', fr: 'Panier', en: 'Cart' },
    empty: { nl: 'leeg', fr: 'vide', en: 'empty' },
    title: { nl: 'Jouw mandje', fr: 'Ton panier', en: 'Your cart' },
    close: { nl: 'Sluiten', fr: 'Fermer', en: 'Close' },
    cdx: { nl: 'Vraag het CARDIX', fr: 'Demande à CARDIX', en: 'Ask CARDIX' }
  };
  var tt = function (k) { return T[k][lang()]; };
  var shopPh = function () { return { nl: 'Zoek in de shop', fr: 'Rechercher dans la boutique', en: 'Search the shop' }[lang()]; };
  var shopL = function () { return { nl: 'Shop', fr: 'Boutique', en: 'Shop' }[lang()]; };
  /* modus 8: naam plus korte uitleg per manier (sleutel: grid = Shop, lab = Rip Lab, chase = Chase zoeken; lab en chase leven allebei in de feedweergave van de pagina) */
  var MODI = {
    grid: { n: { nl: 'Shop', fr: 'Boutique', en: 'Shop' }, s: { nl: 'Alles bekijken', fr: 'Tout voir', en: 'Browse everything' } },
    lab: { n: { nl: 'Samenstellen', fr: 'Composer', en: 'Build' }, s: { nl: 'Pakket op jouw budget', fr: 'Un colis selon ton budget', en: 'A package for your budget' } },
    chase: { n: { nl: 'Chase zoeken', fr: 'Trouver une chase', en: 'Find a chase' }, s: { nl: 'Vind je kaart', fr: 'Trouve ta carte', en: 'Find your card' }, k: { nl: 'Chase zoeken', fr: 'Chase', en: 'Find a chase' } },
    live: { n: { nl: 'Live', fr: 'En direct', en: 'Live' }, s: { nl: 'Shop mee', fr: 'Shoppe avec nous', en: 'Shop along' }, m: { nl: 'Nu live', fr: 'En direct', en: 'Live now' }, b: { nl: 'Nu live', fr: 'En direct', en: 'Live now' }, a: { nl: 'Nu live: open de livestream', fr: 'En direct, ouvre le live', en: 'Live now: open the livestream' } },
    group: { nl: 'Hoe wil je shoppen?', fr: 'Comment veux-tu shopper ?', en: 'How do you want to shop?' }
  };
  var modiN = function (v) { return MODI[v].n[lang()]; };
  var modiS = function (v) { return MODI[v].s[lang()]; };
  var modiG = function () { return MODI.group[lang()]; };
  /* naam in de gsm-balk (.cl-mbar): "Trouver une chase" past daar niet, dus in het Frans enkel Chase; de volle naam blijft het aria-label van de knop */
  var modiK = function (v) { return MODI[v].k ? MODI[v].k[lang()] : modiN(v); };
  var ICONS = {
    /* Chase zoeken: een kaart met een fonkel erin en een vergrootglas ernaast (lijnen raken elkaar niet) */
    chase: '<rect x="3" y="3" width="10.5" height="14.5" rx="2"/><path d="M8.25 6.6l.85 2.05 2.05.85-2.05.85-.85 2.05-.85-2.05-2.05-.85 2.05-.85z"/><circle cx="17" cy="16" r="3.3"/><path d="M19.4 18.4l2.1 2.1"/>',
    layers: '<path d="M12 3l8.5 4.5L12 12 3.5 7.5z"/><path d="M3.5 12L12 16.5 20.5 12"/><path d="M3.5 16.5L12 21l8.5-4.5"/>',
    bot: '<rect x="5" y="8" width="14" height="11" rx="3.5"/><path d="M12 4v4M9.5 13v1.5M14.5 13v1.5M3 12.5v3M21 12.5v3"/>',
    sliders: '<path d="M4 7h9M17 7h3M4 17h3M11 17h9"/><circle cx="15" cy="7" r="2"/><circle cx="9" cy="17" r="2"/>',
    grid: '<rect x="4" y="4" width="6.5" height="6.5" rx="1.5"/><rect x="13.5" y="4" width="6.5" height="6.5" rx="1.5"/><rect x="4" y="13.5" width="6.5" height="6.5" rx="1.5"/><rect x="13.5" y="13.5" width="6.5" height="6.5" rx="1.5"/>',
    play: '<rect x="4" y="4" width="16" height="16" rx="3"/><path d="M10 9l5 3-5 3z"/>',
    x: '<path d="M6 6l12 12M18 6L6 18"/>',
    chev: '<path d="M6 9l6 6 6-6"/>',
    back: '<path d="M15 6l-6 6 6 6"/>',
    plus: '<path d="M12 5v14M5 12h14"/>',
    check: '<path d="M5 12.5l4.5 4.5L19 7.5"/>',
    sort: '<path d="M8 4v16M4 8l4-4 4 4M16 20V4M12 16l4 4 4-4"/>',
    spark: '<path d="M12 3c.6 4.2 2.8 6.4 7 7-4.2.6-6.4 2.8-7 7-.6-4.2-2.8-6.4-7-7 4.2-.6 6.4-2.8 7-7z"/><path d="M19 16.5c.2 1.4.9 2.1 2.3 2.3-1.4.2-2.1.9-2.3 2.3-.2-1.4-.9-2.1-2.3-2.3 1.4-.2 2.1-.9 2.3-2.3z"/>',
    bag: '<path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 01-8 0"/>'
  };
  var ic = function (n, c) { return '<svg class="cl-ic' + (c ? ' ' + c : '') + '" viewBox="0 0 24 24" aria-hidden="true">' + ICONS[n] + '</svg>'; };
  function getSaved() { if (CLEAN_PROD) return 1; try { return localStorage.getItem(KEY) === '0' ? 0 : 1; } catch (e) { return 1; } }
  function getV() { if (CLEAN_PROD) return 'E'; try { var n = localStorage.getItem(VKEY); return /^[A-E]$/.test(n) ? n : 'E'; } catch (e) { return 'E'; } }
  function getCV() { if (CLEAN_PROD) return CAT_PROD; try { var n = localStorage.getItem(CKEY); return /^[1-5]$/.test(n) ? n : '1'; } catch (e) { return '1'; } }
  function getM() { if (CLEAN_PROD) return MODUS_PROD; try { var n = localStorage.getItem(MKEY); return /^[0-7]$/.test(n) ? n : '0'; } catch (e) { return '0'; } }
  function getMap() { if (CLEAN_PROD) return MAP_PROD; try { var n = localStorage.getItem(MAPKEY); return /^[ABC]$/.test(n) ? n : 'A'; } catch (e) { return 'A'; } }
  function getKies() { if (CLEAN_PROD) return KIES_PROD; try { return localStorage.getItem(KKEY) !== '0'; } catch (e) { return true; } }
  var kiesOn = function () { return S.kies && S.v === 'E' && S.cv !== '2'; };
  /* sleutel van de opbouw van het filterblok: filtervariant plus (in E) de categorievariant; verandert hij, dan wordt het blok herbouwd */
  function vKey() { return S.v === 'E' ? 'E/' + S.cv : String(S.v); }
  function save(v) { if (CLEAN_PROD) return; try { localStorage.setItem(KEY, v ? '1' : '0'); } catch (e) { /* negeren */ } }

  /* ---------- echte toestand lezen (uit topbalk concept 1) ---------- */
  var feedSeg = function () { return $('#feed .cws-seg-franchise3'); };
  function feedFrItems() {
    var seg = feedSeg(); if (!seg) return null;
    return $$('button', seg).map(function (b) {
      var k = b.getAttribute('data-franchise3') || '';
      return { k: k, l: k === '' ? LB('oth') : andere(txt(b)), on: b.classList.contains('cws-on') };
    });
  }
  function feedBadge() { var b = $('#feed [data-cws-prefs-badge]'); return b ? txt(b) : ''; }
  /* welke bouwer staat in de feed: 'old' = start-scene.js (.cws-in, [data-cws-prefs-panel], .cws-stack-item), 'rl' = Rip Lab 2.0 (.cws.rl, .rl-item),
     '' = nog geen. Clean past enkel de hooks van de actieve bouwer toe (body.cl-bold of body.cl-brl), zodat een wissel niets breekt. */
  function builderKind() { if ($('#feed .cws.rl')) return 'rl'; if ($('#feed [data-cws-prefs-panel], #feed .cws-stack-item, #feed .cws-in')) return 'old'; return ''; }
  function readGrid() {
    var pills = $$('#gFr .g-pill').map(function (p) {
      var c = p.firstChild;
      return { k: p.getAttribute('data-gfr'), l: andere((c && c.nodeType === 3 ? c.textContent : txt(p)).trim()), n: +txt($('.n', p)) || 0, on: p.classList.contains('on') };
    });
    var total = pills.reduce(function (a, p) { return a + p.n; }, 0);
    var fr = [{ k: 'all', l: LB('all'), n: total, on: !pills.some(function (p) { return p.on; }) }].concat(pills);
    var chain = $('#gChain'), has = chain && !chain.hidden;
    var opt = function (attr) {
      return has ? $$('#gChain [' + attr + ']').filter(function (b) { return b.getAttribute('role') === 'option'; }).map(function (b) {
        var c = b.firstChild;
        return { k: b.getAttribute(attr), l: andere((c && c.nodeType === 3 ? c.textContent : txt(b)).trim()), n: +txt($('span', b)) || 0, on: b.getAttribute('aria-selected') === 'true' };
      }) : [];
    };
    var qs = $$('#gFr .g-q').map(function (q, i) { return { l: txt(q), i: i }; });
    return { fr: fr, cats: opt('data-gcat'), langs: opt('data-glang'), qs: qs };
  }

  /* ---------- lijst met knoppen bijwerken zonder te herbouwen als de sleutels gelijk blijven ---------- */
  function syncList(host, items, cls, attr, withInd, withNew) {
    if (!host) return;
    var keys = items.map(function (i) { return i.k + (i.n === 0 ? '~' : ''); }).join('\u0001');
    if (host._keys !== keys) {
      var prev = host._prevSet || {}, next = {};
      host.innerHTML = (withInd ? '<span class="cl-ind"></span>' : '') + items.map(function (i) {
        next[i.k] = 1;
        return '<button type="button" class="' + cls + (i.n === 0 ? ' cl-z' : '') + (withNew && !prev[i.k] && host._keys !== undefined ? ' cl-new' : '') + '" ' + attr + '="' + esc(i.k) + '"><span class="cl-t">' + esc(i.l) + '</span>' + (i.n != null ? '<span class="cl-n">' + i.n + '</span>' : '') + '</button>';
      }).join('');
      host._keys = keys; host._prevSet = next;
      /* herbouw van de rij: de indicator start op de vorige plek en schuift vanaf daar (geen sprong) */
      var ni = $('.cl-ind', host);
      if (ni && host._ind) { ni.style.transition = 'none'; ni.style.width = host._ind.w + 'px'; ni.style.transform = 'translateX(' + host._ind.x + 'px)'; void ni.offsetWidth; ni.style.transition = ''; host._indReady = true; }
      else host._indReady = false;
    }
    var bs = $$('button', host);
    items.forEach(function (it, i) {
      var b = bs[i]; if (!b) return;
      b.classList.toggle('on', !!it.on);
      b.setAttribute('aria-pressed', it.on ? 'true' : 'false');
      var t = $('.cl-t', b); if (t && t.textContent !== it.l) t.textContent = it.l;
      var n = $('.cl-n', b); if (n && n.textContent !== String(it.n)) n.textContent = it.n;
    });
    if (withInd) placeInd(host);
  }
  function placeInd(host) {
    var ind = $('.cl-ind', host), a = $('button.on', host);
    if (!ind || !a || !a.offsetWidth) return;
    var first = !host._indReady;
    if (first) ind.style.transition = 'none';
    ind.style.width = a.offsetWidth + 'px';
    ind.style.transform = 'translateX(' + a.offsetLeft + 'px)';
    host._ind = { x: a.offsetLeft, w: a.offsetWidth };
    if (first) { void ind.offsetWidth; ind.style.transition = ''; host._indReady = true; }
  }

  /* ---------- begroeting ---------- */
  function brusselsHour() {
    try { return +new Intl.DateTimeFormat('en-GB', { hour: 'numeric', hour12: false, timeZone: 'Europe/Brussels' }).format(new Date()) % 24; } catch (e) { return new Date().getHours(); }
  }
  /* begroeting: bij de oude bouwer (start-scene.js) de tekst die hij zelf bouwt (.cws-eyebrow-greet of .cws-greeting, taal en naam van de
     pagina), zijn eigen regel is dan via CSS verborgen (body.cl-bold). Anders (Rip Lab 2.0): dagdeel in de paginataal met de naam uit
     window.CW_RS_CUSTOMER (firstName of name), lokaal de demonaam uit de kop. Bij 2.0 toont de bouwer zelf zijn klantregel en is de eigen
     begroeting in Rip Lab verborgen (body.cl-brl). */
  function custName() {
    var c = null; try { c = window.CW_RS_CUSTOMER && typeof window.CW_RS_CUSTOMER === 'object' ? window.CW_RS_CUSTOMER : null; } catch (e) { c = null; }
    if (c) return String(c.firstName || c.name || '').trim().split(/\s+/)[0] || '';
    /* op de shop zonder klantobject = gast: geen naam (de kop bevat enkel de demonaam van de mockup) */
    if (window.CW_RS_CARDIX || /(^|\.)cardworld\.be$/.test(location.hostname)) return '';
    return txt($('.hdr .who b'));
  }
  function greetText() {
    if (builderKind() === 'old' && S.m !== '8') {
      var g = $('.cws-eyebrow-greet') || $('.cws-greeting');
      var s = txt(g).replace(/\s*[·•]\s*$/, '');
      if (s) S.greet = s;
      if (S.greet) return S.greet;
    }
    var h = brusselsHour(), l = lang();
    var w = { nl: ['Goedemorgen', 'Goedemiddag', 'Goedenavond'], fr: ['Bonjour', 'Bon après-midi', 'Bonsoir'], en: ['Good morning', 'Good afternoon', 'Good evening'] }[l];
    var nm = custName();
    return (h >= 5 && h < 12 ? w[0] : h >= 12 && h < 18 ? w[1] : w[2]) + (nm ? ', ' + nm : '');
  }

  /* ---------- opbouw ---------- */
  function buildBar() {
    var cats = $('.cats'); if (!cats) return;
    var old = $('.cl-bar', cats); if (old) old.remove();
    var bar = document.createElement('div');
    bar.className = 'cl-bar cl-scope';
    var mb = function (v, icn, extra) {
      return '<button type="button"' + (extra ? ' class="' + extra + '"' : '') + ' data-cl-view="' + v + '" title="' + esc(modiN(v)) + '"><span class="cl-in"><span class="cl-it" aria-hidden="true">' + ic(icn) + '</span>' +
        '<span class="cl-tx"><span class="cl-t">' + esc(modiN(v)) + '</span><span class="cl-md">' + esc(modiS(v)) + '</span></span></span></button>';
    };
    /* 12 okt (Andrea: "nu links lijkt het alsof die bij de tabbladen hoort terwijl de ux erachter anders is"): de live-knop staat niet meer in het
       tabspoor maar als eigen knop rechts in dezelfde rij (wit, rode rand, rode stip, vergroot-icoon); enkel tijdens een stream (liveSync); klik = de
       zelfde als voorheen (desktop: de streamkolom open of dicht, gsm: naar de stream) */
    bar.innerHTML = '<p class="cl-greet" data-cl-greet></p>' +
      '<div class="cl-mwrap cl-scope"><div class="cl-mseg" role="group" aria-label="' + esc(modiG()) + '"><span class="cl-ind"></span>' +
      mb('grid', 'grid') + mb('lab', 'layers', 'cl-labb') + mb('chase', 'chase') + '</div></div>' +
      '<button type="button" class="cl-lc cl-lcx" data-cl-live hidden aria-label="' + esc(MODI.live.a[lang()]) + '" title="' + esc(MODI.live.a[lang()]) + '"><i aria-hidden="true"></i><span class="cl-t">' + esc(MODI.live.b[lang()]) + '</span>' +
      '<svg class="cl-lcz" viewBox="0 0 24 24" aria-hidden="true"><path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';
    cats.appendChild(bar);
  }
  /* modus 7: voorproef per vak (enkel opgebouwd in modus 7, een keer per bron; zichtbaar op de vakken waar je niet bent). Shop = drie echte
     uitsneden (pack, ETB, booster box), Rip Lab = het budget van de bouwer op een mini-schaal (25 tot 1.000, logaritmisch zoals de slider),
     Alles decoratief (aria-hidden); zonder data blijft het vak leeg en werkt de wissel gewoon. */
  function pvSync(tg) {
    var P = loadP(), gs = $('[data-cl-pv="grid"]', tg), ls = $('[data-cl-pv="lab"]', tg);
    if (gs && !gs._done && P) {
      var pick = [/^Booster Pack$/, /^Elite Trainer Box$/, /^Booster Box$/].map(function (re) {
        var e = P.filter(function (x) { return x.nm === 'CATALOG' && x.av && re.test(x.c.kind || ''); })[0]; return e ? cutUrl(e.c.h) : null;
      }).filter(Boolean);
      if (pick.length === 3) { gs.innerHTML = pick.map(function (u, i) { return '<img class="cl-pv-i' + i + '" src="' + esc(u) + '" alt="" width="40" height="44" loading="lazy" decoding="async">'; }).join(''); gs._done = true; }
    }
    if (ls) {
      var bv = $('#feed [data-cws-val]'), v = bv ? parseInt(txt(bv).replace(/[^0-9]/g, ''), 10) : NaN;
      if (!(v > 0)) v = 75;
      if (ls._v !== v) {
        var pct = Math.max(0, Math.min(1, (Math.log(v) - Math.log(25)) / (Math.log(1000) - Math.log(25))));
        ls.innerHTML = '<b class="cl-pv-eur"><i>\u20ac</i>' + v + '</b><span class="cl-pv-tr"><span style="width:' + Math.round(pct * 100) + '%"></span><em style="left:' + Math.round(pct * 100) + '%"></em></span>';
        ls._v = v;
      }
    }
  }
  function buildChrome() {
    /* kopbalk: lokaal de nagebouwde (#cwhIcons), op Shopify de echte header van het thema (.cwh-icons). De Mandje-pil komt op de plek van
       het mandje-icoon van de echte header (open-minicart / #cwh-cart-btn); dat icoon zelf is op deze pagina verborgen (zie css). */
    var icons = $('#cwhIcons') || $('.cwh-icons'), av = $('#hdrAv');
    if (icons && !$('.cl-pill', icons)) {
      var pill = document.createElement('button');
      pill.type = 'button'; pill.className = 'cl-pill'; pill.setAttribute('data-cl-pill', '');
      pill.setAttribute('aria-haspopup', 'dialog'); pill.setAttribute('aria-expanded', 'false');
      var cartBtn = $('#cwh-cart-btn', icons), host = cartBtn ? (cartBtn.closest('open-minicart') || cartBtn) : null;
      if (host && host.parentNode !== icons) host = null;
      if (!host) { var ca = $('a[href$="/cart"]', icons); host = ca && ca.parentNode === icons ? ca : (ca && ca.parentNode && ca.parentNode.parentNode === icons ? ca.parentNode : null); }
      icons.insertBefore(pill, host || (av && av.parentNode === icons ? av : null));
    }
    if (!$('.cl-fab')) {
      var fab = document.createElement('button');
      fab.type = 'button'; fab.className = 'cl-fab'; fab.setAttribute('data-cl-fab', '');
      fab.setAttribute('aria-label', tt('cdx')); fab.title = tt('cdx'); fab.setAttribute('aria-expanded', 'false');
      var src = $('#cdkTabR .cdx-av') || $('.cdx-av[data-cdx]');
      fab.innerHTML = '<span class="cdx-av">' + (src ? src.innerHTML : '') + '</span>';
      document.body.appendChild(fab);
      var fx = document.createElement('button'); fx.type = 'button'; fx.className = 'cl-fabx cl-scope'; fx.setAttribute('data-cl-fabx', ''); fx.setAttribute('aria-label', 'CARDIX verbergen'); fx.innerHTML = ic('x', 'xs');
      document.body.appendChild(fx);
      var ft = document.createElement('button'); ft.type = 'button'; ft.className = 'cl-fabtab cl-scope'; ft.setAttribute('data-cl-fabtab', ''); ft.setAttribute('aria-label', 'CARDIX tonen'); ft.title = 'CARDIX tonen'; ft.innerHTML = ic('spark');
      document.body.appendChild(ft);
      if (fabGet()) document.body.classList.add('cl-fabhid');
    }
    if (!$('.cl-scrim')) {
      var sc = document.createElement('div'); sc.className = 'cl-scrim'; sc.setAttribute('data-cl-scrim', '');
      document.body.appendChild(sc);
    }
    var cc = $('#conc');
    if (cc && !$('.cl-cdx', cc)) {
      var xb = document.createElement('button'); xb.type = 'button'; xb.className = 'cl-cdx cl-scope'; xb.setAttribute('data-cl-cdxclose', ''); xb.setAttribute('aria-label', tt('close'));
      xb.innerHTML = ic('x'); cc.appendChild(xb);
    }
    if (!$('.cl-stk')) {
      var stk = document.createElement('div'); stk.className = 'cl-stk cl-scope'; stk.setAttribute('role', 'toolbar'); stk.setAttribute('aria-label', 'Filters');
      var sdw = function (kind, t) { return '<span class="cl-ddw" data-cl-ddw="' + kind + '"><button type="button" class="cl-dd" data-cl-ddbtn="' + kind + '" aria-haspopup="menu" aria-expanded="false"><span class="cl-ddt" data-cl-ddt="' + kind + '">' + t + '</span>' + ic('chev', 'xs') + '</button><button type="button" class="cl-ddx" data-cl-rm="' + (kind === 'cat' ? 'grp' : 'lang') + '" aria-label="Wissen" hidden>' + ic('x', 'xs') + '</button></span>'; };
      stk.innerHTML = '<div class="cl-utabs" data-cl-list="gfr"></div>' + sdw('fr', LB('all')).replace('class="cl-ddw"', 'class="cl-ddw cl-stk-frdd"').replace(/<button type="button" class="cl-ddx"[^>]*>.*?<\/button>/, '') + sdw('cat', LB('cat')) + sdw('lang', LB('lang')) + '<span class="cl-stk-sp"></span>' +
        '<div class="cl-stk-s"><button type="button" class="cl-stk-sb" data-cl-stks aria-label="Zoeken" aria-expanded="false"><svg class="cl-ic" viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg></button>' +
        '<div class="cl-swrap cl-swc"><div class="cl-sinner"><svg class="cl-sic" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>' +
        '<input type="search" data-cl-q class="cl-sinput" placeholder="' + esc(shopPh()) + '" autocomplete="off" aria-label="' + esc(shopPh()) + '">' +
        '<button type="button" class="cl-sclear" data-cl-sclear aria-label="Zoekopdracht wissen"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg></button></div></div></div>' +
        '<span class="cl-stk-seg"><button type="button" class="g-filters-btn cl-stk-f" data-cl-stkf aria-haspopup="true" aria-expanded="false">' + ic('sliders', 'sm') + '<span>Filters</span><span class="cl-badge" data-cl-stkb hidden></span></button>' +
        '<button type="button" class="g-filters-btn cl-sortbtn" data-cl-sortbtn aria-haspopup="menu" aria-expanded="false"></button></span>' +
        '<button type="button" class="cl-link cl-wis" data-cl-rm="all" hidden>Wis filters</button>' +
        '<span class="cl-vsep" aria-hidden="true"></span><div class="cl-stk-v" role="group" aria-label="Weergave"><span class="cl-ind"></span><button type="button" class="cl-tipb" data-cl-view="grid" data-tip="' + esc(modiN('grid')) + '" aria-label="' + esc(modiN('grid')) + '">' + ic('grid', 'sm') + '<span class="cl-stk-vl" aria-hidden="true">' + esc(modiN('grid')) + '</span></button><button type="button" class="cl-tipb cl-labb" data-cl-view="lab" data-tip="' + esc(modiN('lab')) + '" aria-label="' + esc(modiN('lab')) + '">' + ic('layers', 'sm') + '<span class="cl-stk-vl" aria-hidden="true">' + esc(modiN('lab')) + '</span></button><button type="button" class="cl-tipb" data-cl-view="chase" data-tip="' + esc(modiN('chase')) + '" aria-label="' + esc(modiN('chase')) + '">' + ic('chase', 'sm') + '<span class="cl-stk-vl" aria-hidden="true">' + esc(modiN('chase')) + '</span></button></div>';
      document.body.appendChild(stk);
      var cov = document.createElement('div'); cov.className = 'cl-stkcov'; cov.setAttribute('aria-hidden', 'true'); document.body.appendChild(cov);
    }
    var ci = $('#cin2');
    if (ci && !$('#clTa')) {
      var ta = document.createElement('textarea');
      ta.id = 'clTa'; ta.className = 'cl-ta'; ta.rows = 1; ta.maxLength = 500; ta.setAttribute('aria-label', tt('cdx'));
      ta.autocomplete = 'off'; ta.spellcheck = true;
      /* de voorbeeldvragen staan als overlay boven het veld (geen placeholder-attribuut): typemachine, zie twCheck */
      var wrap = document.createElement('div'); wrap.className = 'cl-tawrap';
      var ov = document.createElement('span'); ov.className = 'cl-ph'; ov.setAttribute('aria-hidden', 'true'); ov.hidden = true;
      ov.innerHTML = '<span class="cl-pht"></span><i class="cl-caret"></i>';
      wrap.appendChild(ta); wrap.appendChild(ov);
      ci.parentNode.insertBefore(wrap, ci); ci.tabIndex = -1; ci.setAttribute('aria-hidden', 'true');
    }
    var col = $('.col-r');
    if (col && !$('.cl-dhead', col)) {
      var h = document.createElement('div'); h.className = 'cl-dhead cl-scope';
      h.innerHTML = '<h2 data-cl-dt></h2><button type="button" class="cl-dx" data-cl-close aria-label="">' + ic('x') + '</button>';
      col.insertBefore(h, col.firstChild);
      col.setAttribute('role', 'dialog'); col.setAttribute('aria-label', tt('title'));
    }
    /* menu: "Other TCG" wordt overal "Andere TCG" */
    $$('#navMenu a').forEach(function (a) {
      if (/Other TCG/i.test(a.textContent)) { a._orig = a.textContent; a.textContent = andere(a.textContent); }
    });
  }
  function ensure() {
    if (!$('.cats .cl-bar')) buildBar();
    var seg = feedSeg(), row = seg && seg.closest('.cws-franchise-row');
    if (row && !(row.previousElementSibling && row.previousElementSibling.classList.contains('cl-waarop'))) {
      var w = document.createElement('div');
      /* franchisetabs plus de Filters-knop (opent het voorkeurenpaneel van de oude bouwer; bij Rip Lab 2.0, zonder paneel, blijft de knop verborgen) */
      w.className = 'cl-waarop cl-scope';
      w.innerHTML = '<div class="cl-utabs" data-cl-list="ftabs"></div>' +
        '<button type="button" class="cl-btnf" data-cl-filters aria-expanded="false" hidden>' + ic('sliders', 'sm') + 'Filters<span class="cl-badge" data-cl-badge hidden></span></button>';
      row.parentNode.insertBefore(w, row);
    }
    var rows = $('#gCard .g-rows');
    var all0 = $('.cl-all');
    if (all0 && all0.getAttribute('data-v') !== vKey()) { ctlBack(); all0.remove(); var fh0 = $('.cl-fhead'); if (fh0) fh0.remove(); if (S.pop) dropPop(); all0 = null; }
    if (rows && !all0) {
      var a = document.createElement('div');
      a.className = 'cl-all cl-scope'; a.setAttribute('data-v', vKey());
      a.innerHTML = allHTML(S.v);
      var topD = $('#gCard .g-top');
      if (S.v === 'D' && topD) topD.parentNode.insertBefore(a, topD); else rows.parentNode.insertBefore(a, rows);
    }
    var top = $('#gCard .g-top'), ctl = top && $('.g-ctl', top);
    if (S.v === 'D' && top && ctl && !$('.cl-fhead')) {
      var cr = document.createElement('div'); cr.className = 'cl-fhead cl-crumb cl-scope';
      var dw = function (kind, t) { return '<span class="cl-ddw" data-cl-ddw="' + kind + '"><button type="button" class="cl-dd" data-cl-ddbtn="' + kind + '" aria-haspopup="menu" aria-expanded="false"><span class="cl-ddt" data-cl-ddt="' + kind + '">' + t + '</span>' + ic('chev', 'xs') + '</button><button type="button" class="cl-ddx" data-cl-rm="' + (kind === 'cat' ? 'grp' : 'lang') + '" aria-label="Wissen" hidden>' + ic('x', 'xs') + '</button></span>'; };
      cr.innerHTML = '<span class="cl-c1" data-cl-c1></span><i class="cl-sep">\u203a</i>' + dw('cat', LB('allcat')) + '<i class="cl-sep">\u203a</i>' + dw('lang', LB('alllang')) + '<span class="cl-fcount" data-cl-fcount></span><button type="button" class="cl-link cl-wis" data-cl-rm="all" hidden>Wis</button>';
      top.insertBefore(cr, ctl);
    }
    if (S.v === 4 && top && ctl && !$('.cl-fhead')) {
      var fh = document.createElement('div'); fh.className = 'cl-fhead cl-scope';
      fh.innerHTML = '<div class="cl-utabs lg" data-cl-list="gfr"></div><span class="cl-fcount" data-cl-fcount></span>';
      top.insertBefore(fh, ctl);
    }
    var fr = $('#gFr'); if (fr && fr.parentNode) fr.parentNode.classList.add('cl-hide');
    /* de feedcategorie (#catScroll) heeft geen bediening meer: een eerder gekozen filter terugzetten op "Alles",
       anders blijft de feed onzichtbaar gefilterd */
    if (mode() === 'feed') {
      var on = $('#catScroll [aria-pressed="true"]'), allb = $('#catScroll [data-cat="all"]');
      if (on && allb && on !== allb) allb.click();
    }
  }

  /* ---------- synchronisatie met de echte toestand ---------- */
  function sync() {
    var bar = $('.cats .cl-bar'); if (!bar) return;
    var g = $('[data-cl-greet]', bar), gt = greetText();
    if (g && S.m === '8') {
      /* begroeting in twee regels: dagdeel (met komma als er een naam is) boven, voornaam eronder; gast = enkel het dagdeel */
      if (g.getAttribute('data-gt') !== gt) { var ci = gt.indexOf(','); g.setAttribute('data-gt', gt); g.setAttribute('aria-label', gt); g.innerHTML = '<span class="cl-gd">' + esc(ci < 0 ? gt : gt.slice(0, ci + 1)) + '</span>' + (ci < 0 ? '' : '<span class="cl-gn" aria-hidden="true">' + esc(gt.slice(ci + 1).trim()) + '</span>'); }
    } else if (g && g.textContent !== gt) g.textContent = gt;
    liveSync();
    /* modusbalk-proef variant 12: titel en live-pil mee bij elke tick (geen eigen poll) */
    try { if (MBV.n === 12 || $('.cl-mbvr')) mbvSync(); } catch (e) { /* negeren */ }
    try { dsOff(); dsBadge(); } catch (e) { /* negeren */ }
    var tg = $('.cl-mseg');
    if (tg) {
      var cv = shownView();
      $$('button[data-cl-view]', tg).forEach(function (b) {
        var bv = b.getAttribute('data-cl-view'), on = bv === cv;
        b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      /* modus 8: namen en uitleg volgen de paginataal (de taalknop bouwt de balk niet opnieuw op) */
      $$('button[data-cl-view]', tg).forEach(function (b) {
        var bv = b.getAttribute('data-cl-view'), t1 = $('.cl-t', b), t2 = $('.cl-md', b);
        if (t1 && t1.textContent !== modiN(bv)) t1.textContent = modiN(bv);
        if (b.getAttribute('title') !== modiN(bv)) b.setAttribute('title', modiN(bv));
        if (t2 && t2.textContent !== modiS(bv)) t2.textContent = modiS(bv);
      });
      var lc = $('.cats [data-cl-live]');
      if (lc) { var l1 = $('.cl-t', lc); if (l1 && l1.textContent !== MODI.live.b[lang()]) { l1.textContent = MODI.live.b[lang()]; lc.setAttribute('aria-label', MODI.live.a[lang()]); lc.title = MODI.live.a[lang()]; } }
      if (tg.getAttribute('aria-label') !== modiG()) tg.setAttribute('aria-label', modiG());
      var onI = cv === 'grid' ? '0' : cv === 'lab' ? '1' : '2'; if (tg.getAttribute('data-on') !== onI) tg.setAttribute('data-on', onI);
      if (S.m === '7') pvSync(tg);
      placeInd(tg);
    }
    /* budgetkaart */
    var ft = $('[data-cl-list="ftabs"]'), wa = ft && ft.closest('.cl-waarop');
    var items = feedFrItems();
    var bk = builderKind();
    document.body.classList.toggle('cl-bold', bk === 'old'); document.body.classList.toggle('cl-brl', bk === 'rl');
    if (wa) {
      wa.hidden = !items;
      if (items) syncList(ft, items, '', 'data-cl-fr', true);
      var fb = $('[data-cl-filters]', wa), tr = $('#feed [data-cws-prefs-btn]'), hasPanel = bk === 'old' && !!$('[data-cws-prefs-panel]');
      if (fb) {
        fb.hidden = !hasPanel;
        var bd = $('[data-cl-badge]', fb), n = hasPanel ? feedBadge() : '';
        if (bd) { bd.textContent = n; bd.hidden = !n; }
        var pnl = $('[data-cws-prefs-panel]'); fb.setAttribute('aria-expanded', pnl && !pnl.hidden ? 'true' : (tr ? tr.getAttribute('aria-expanded') || 'false' : 'false'));
      }
    }
    syncGrid();
  }

  /* ---------- Alle producten: groepen, subtypes, taal, 5 varianten ---------- */
  var norm = function (x) { return String(x == null ? '' : x).toLowerCase().replace(/\s+/g, ' ').trim(); };
  var OTHER = '__none';
  /* zoeken zoals de grid van de pagina (gridSearch): elk woord moet voorkomen in titel + franchise + soort */
  /* Tolerant zoeken (een gedeelde functie voor de grote en de sticky zoekbalk): kleine letters, geen accenten, leestekens en
     letter-cijfergrenzen worden spaties, voorloopnullen weg ("OP17", "op 17", "op-17", "op-05" en "op5" zijn gelijk). Een
     woord matcht als het in de tekst voorkomt met of zonder spaties, afkortingen zijn uitgebreid (etb, upc, bb, pkm), en
     bij 0 resultaten valt de zoekfunctie terug op fuzzy (Levenshtein 1 per woord vanaf 4 tekens). */
  var qn = function (x) {
    return String(x == null ? '' : x).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, ' ').replace(/([a-z])(\d)/g, '$1 $2').replace(/(\d)([a-z])/g, '$1 $2')
      .replace(/(^| )0+(?=\d)/g, '$1').replace(/\s+/g, ' ').trim();
  };
  var ABBR = { etb: ['elite trainer box'], upc: ['ultra premium collection'], bb: ['booster box', 'booster bundle'], pkm: ['pokemon'], tcg: ['tcg'] };
  var lev = function (a, b) {
    if (a === b) return 0; if (Math.abs(a.length - b.length) > 1) return 2;
    var prev = [], cur = [], i, j; for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) { cur = [i]; for (j = 1; j <= b.length; j++) cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1)); prev = cur; }
    return prev[b.length];
  };
  var hasPhrase = function (p, ph) { return p.hT.indexOf(ph) > -1 || p.hC.indexOf(ph.replace(/ /g, '')) > -1; };
  /* 10 okt: eenvoudig meervoud (EN/NL): "boxes" en "boxen" vinden "box", "sets" vindt "set"; enkel als extra kans, nooit strenger */
  var stems = function (tk) {
    var out = [];
    /* korte stammen (green > gre, queen > que) matchen te ruim: -es/-en enkel bij een stam van 4+ letters of na x/s/z/ch/sh (boxes > box) */
    var r = tk.slice(0, -2);
    if (tk.length >= 5 && /(es|en)$/.test(tk) && (r.length >= 4 || /(x|s|z|ch|sh)$/.test(r))) out.push(r);
    if (tk.length >= 4 && /[^su]s$/.test(tk)) out.push(tk.slice(0, -1));
    return out;
  };
  var tokOk = function (p, tk) {
    if (hasPhrase(p, tk)) return true;
    var st = stems(tk); for (var si = 0; si < st.length; si++) if (hasPhrase(p, st[si])) return true;
    var alts = ABBR[tk];
    if (alts) for (var i = 0; i < alts.length; i++) if (alts[i].split(' ').every(function (w) { return hasPhrase(p, w); })) return true;
    if (S.qFuzz && tk.length >= 4) for (var j = 0; j < p.hw.length; j++) { var w = p.hw[j]; if (lev(w, tk) <= 1 || (w.length > tk.length && lev(w.slice(0, tk.length), tk) <= 1)) return true; }
    return false;
  };
  var qOk = function (p) {
    if (!S.qt.length) return true;
    if (p.hC.indexOf(S.qt.join('')) > -1) return true;
    for (var i = 0; i < S.qt.length; i++) if (!tokOk(p, S.qt[i])) return false;
    return true;
  };
  /* bij een nieuwe zoekterm: eerst streng; zijn er in het hele aanbod 0 treffers, dan fuzzy */
  function qSet(v) {
    S.q = String(v || '').trim(); S.qt = qn(S.q).split(' ').filter(Boolean); S.qFuzz = false;
    try { dsOff(); } catch (e) { /* negeren */ }
    var P = loadP();
    if (S.qt.length && P) { var n = 0; for (var i = 0; i < P.length && !n; i++) if (qOk(P[i])) n++; if (!n) S.qFuzz = true; }
  }
  var hT0 = function (c) { return qn(c.t + ' ' + (c.fr || c.sfr || '') + ' ' + (c.kind || c.scat || '') + ' ' + (typeof c.set === 'string' ? c.set : '') + ' ' + String(c.h || '').replace(/-/g, ' ')); };
  function groupOf(raw) {
    var n = norm(raw), lb = norm(S.labels[raw]), rest = GROUPS[0].k;
    for (var i = 0; i < GROUPS.length; i++) {
      if (GROUPS[i].rest) rest = GROUPS[i].k;
      if (raw !== OTHER && GROUPS[i].cats.some(function (c) { return norm(c) === n || (lb && norm(c) === lb); })) return GROUPS[i].k;
    }
    return rest;
  }
  /* naam in de taal van de pagina (window.CW_RS_CATLBL uit app.js, zelfde tabel als cw-shop.liquid) */
  var catT = function (k) { try { if (typeof window.CW_RS_CATLBL === 'function') { var v = window.CW_RS_CATLBL(k); if (v) return v; } } catch (e) { /* negeren */ } return null; };
  function grpLabel(k) { for (var i = 0; i < GROUPS.length; i++) if (GROUPS[i].k === k) return catT(GROUPS[i].l) || GROUPS[i].l; return k; }
  /* alle categorieen van een product (scats, elk telt mee zoals op cardworld.be); oudere data: enkel scat */
  var catsOf = function (p) { return p && p.scats && p.scats.length ? p.scats : (p && p.scat ? [p.scat] : []); };
  /* de echte tags van cardworld.be (window.CW_RS_CATS, via Liquid in het template) winnen van de build-data, zoals in app.js (applyLiveCats) */
  var GAME_CATS = { 'Disney Lorcana': 1, 'Yu-Gi-Oh': 1, 'Dragon Ball Super': 1, 'Riftbound': 1 };
  /* 10 okt: heette eerst ook liveCats. Deze var-toewijzing overschreef bij het laden de functie liveCats(cc, grp) verderop (de soorten van een
     groep), waardoor elke groep subs = null kreeg: popHTML brak dan af op i.subs.length, #clPop bleef open zonder plek of met de oude inhoud.
     Eigen naam, nooit meer dezelfde als een functiedeclaratie in dit bestand. */
  var liveTags = function (c) {
    var L = null; try { L = window.CW_RS_CATS; } catch (e) { L = null; }
    var x = L && c && c.h ? L[c.h] : null; if (!x || !x.c) return null;
    var sc = x.c.slice(), first = sc.filter(function (k) { return !GAME_CATS[k]; })[0] || null;
    return { scats: sc, scat: first, sfr: (x.f && x.f[0]) || c.sfr || null };
  };
  var inCats = function (p, set) { var cs = catsOf(p); for (var i = 0; i < cs.length; i++) if (set[cs[i]]) return true; return false; };
  /* de pagina houdt alle producten met hun categorie en taal in een const in een script: eenmalig uitlezen (JSON) */
  function extractArr(src, name) {
    var i = src.indexOf('const ' + name + ' = '); if (i < 0) return null;
    i += ('const ' + name + ' = ').length;
    if (src.charAt(i) !== '[' && src.charAt(i) !== '{') return null;
    var d = 0, inS = false, esc2 = false;
    for (var j = i; j < src.length; j++) {
      var c = src.charAt(j);
      if (inS) { if (esc2) esc2 = false; else if (c === '\\') esc2 = true; else if (c === '"') inS = false; }
      else if (c === '"') inS = true;
      else if (c === '[' || c === '{') d++;
      else if (c === ']' || c === '}') { d--; if (d === 0) { try { return JSON.parse(src.slice(i, j + 1)); } catch (e) { return null; } } }
    }
    return null;
  }
  /* productdata uit de scripts van de pagina: inline blokken, en bij de Shopify-versie (scripts als thema-assets) de externe
     scripts, eenmalig opgehaald (komen uit de browsercache) */
  function ingest(src, out) {
    if (src.indexOf('const SHOP_EXTRA = [') < 0 && src.indexOf('const CATALOG = [') < 0 && src.indexOf('const M3D = {') < 0) return;
    ['CATALOG', 'SHOP_EXTRA'].forEach(function (nm) {
      var arr = extractArr(src, nm);
      if (arr) arr.forEach(function (c) { var lc = liveTags(c); out.push({ c: c, nm: nm, hT: hT0(c), hC: hT0(c).replace(/ /g, ''), hw: hT0(c).split(' '), t: norm(c.t), sfr: lc ? lc.sfr : (c.sfr || null), scat: lc ? lc.scat : (c.scat || null), scats: lc ? lc.scats : catsOf(c), slang: c.slang || null, img: c.img || null, cut: nm === 'CATALOG', av: c.av !== false }); });
    });
    if (!S.M3D && src.indexOf('const M3D = {') > -1) S.M3D = extractArr(src, 'M3D');
    if (/cutImg\s*=/.test(src)) S.texts.push(src);
  }
  /* productdata uit de brug van app.js (window.P = alle producten, gecureerd en overig, met de 3D-velden die
     applyM3D al zette). Zelfde objectvorm als ingest(); M3D wordt uit de producten zelf afgeleid. */
  function fromBridge(out) {
    var BP = null; try { BP = window.P; } catch (e) { BP = null; }
    if (!BP || typeof BP !== 'object') return false;
    var seen = {}, m3 = {};
    Object.keys(BP).forEach(function (id) {
      var p = BP[id]; if (!p || !p.h || !p.t || seen[p.h]) return; seen[p.h] = 1;
      var c = { h: p.h, t: p.t, price: p.price, f: p.f || null, fr: p.franchise || '', kind: p.kind || '', set: p.set || null, faces: p.faces || null, pose3d: p.pose3d || null,
                sfr: p.sfr || null, scat: p.scat || null, scats: catsOf(p), slang: p.slang || null, img: p.img || null, av: p.av, compare_at_price: p.compare_at_price };
      if (p.mode === 'pack') m3[p.h] = { s: 'pack', bulge: p.bulge || 0 }; else if (p.mode === 'fbox' && p.fbox) m3[p.h] = { s: 'box', fbox: p.fbox };
      var nm = p.curated === false ? 'SHOP_EXTRA' : 'CATALOG', h = hT0(c);
      out.push({ id: id, c: c, nm: nm, hT: h, hC: h.replace(/ /g, ''), hw: h.split(' '), t: norm(c.t), sfr: c.sfr, scat: c.scat, scats: c.scats, slang: c.slang, img: c.img, cut: nm === 'CATALOG', av: c.av !== false });
    });
    if (!S.M3D) S.M3D = m3;
    return out.length > 20;
  }
  /* 21 okt (Andrea: 3D van OP-17 niet in de Shop): producten die app.js na de build live aanvulde (liveMerge, window.CW_RS_LIVEADD, met de
     3D-velden die applyLive/applyM3D al zetten) komen er hier bij, zodat 3D-label, hover-3D en podium ze ook kennen. In beide volgordes:
     bij het opbouwen van S.P (loadP) en bij het event cw-rs-livecat (aanvulling na de eerste render). */
  function liveAdd() {
    var A = null; try { A = window.CW_RS_LIVEADD; } catch (e) { A = null; }
    if (!S.P || !Array.isArray(A) || !A.length) return 0;
    var have = {}, n = 0; S.P.forEach(function (e) { if (e && e.c && e.c.h) have[e.c.h] = 1; });
    if (!S.M3D) S.M3D = {};
    A.forEach(function (p) {
      if (!p || !p.h || !p.t || have[p.h]) return; have[p.h] = 1; n++;
      var c = { h: p.h, t: p.t, price: p.price, f: p.f || null, fr: p.franchise || '', kind: p.kind || '', set: p.set || null, faces: p.faces || null, pose3d: p.pose3d || null,
                sfr: p.sfr || null, scat: p.scat || null, scats: catsOf(p), slang: p.slang || null, img: p.img || null, av: p.av };
      if (!S.M3D[p.h]) { if (p.mode === 'pack') S.M3D[p.h] = { s: 'pack', bulge: p.bulge || 0 }; else if (p.mode === 'fbox' && p.fbox) S.M3D[p.h] = { s: 'box', fbox: p.fbox }; }
      var h = hT0(c);
      S.P.push({ id: p.id, c: c, nm: 'SHOP_EXTRA', hT: h, hC: h.replace(/ /g, ''), hw: h.split(' '), t: norm(c.t), sfr: c.sfr, scat: c.scat, scats: c.scats, slang: c.slang, img: c.img, cut: false, av: c.av !== false });
      if (typeof H3 !== 'undefined' && H3 && H3.cache) delete H3.cache[p.h];
    });
    if (n && typeof H3 !== 'undefined' && H3) { H3.byT = null; $$('#gGrid .tile').forEach(function (t) { if (t._cl3 === false) t._cl3 = undefined; }); }
    return n;
  }
  window.addEventListener('cw-rs-livecat', function () { try { if (liveAdd() && S.on && mode() === 'all') h3Badges(); } catch (e) { /* negeren */ } });
  /* ---------- uitverkocht standaard verborgen (16 okt, audit; eigenaarsregel: nooit uitverkochte producten tonen) ----------
     De Shop zet bij het opstarten de beschikbaarheidsfilter van de pagina (#gAvBody, data-gav, filterpaneel) eenmalig op "Op voorraad". De schakelaar
     blijft: kiest de bezoeker daarna zelf Alles of Niet op voorraad, dan blijft dat staan (S.avInit). De tellingen van de Clean-tabs volgen dezelfde
     keuze (avOk), zodat het getal bij Alles klopt met de tegels. */
  /* de stand even bewaren (50 ms): avOk draait per product in elke telling */
  function avMode() {
    var now = performance.now(); if (S.avM && now - S.avMt < 50) return S.avM;
    var e = document.querySelector('#gAvBody [data-gav].on'); S.avM = e ? e.getAttribute('data-gav') : 'all'; S.avMt = now; return S.avM;
  }
  function avOk(p) { var m = avMode(); return m === 'all' || (m === 'in' ? p.av !== false : p.av === false); }
  function avInit() {
    return; /* 16 okt (Andrea): de filter Op voorraad staat niet meer standaard aan; Alles is de start */
    if (S.avInit || !S.on) return;
    var inB = document.querySelector('#gAvBody [data-gav="in"]'); if (!inB) return;
    S.avInit = true;
    S.avM = null;
    if (avMode() === 'all') { try { inB.click(); } catch (e) { /* negeren */ } S.avM = null; }
  }
  function loadP() {
    if (S.P !== undefined) return S.P;
    S.P = null; S.texts = [];
    try { var ob = []; if (fromBridge(ob)) { S.P = ob; liveAdd(); return S.P; } } catch (e) { /* terugval hieronder */ }
    try {
      var out = [];
      $$('script:not([src])').forEach(function (sc) { ingest(sc.textContent || '', out); });
      if (out.length > 20) { S.P = out; liveAdd(); return S.P; }
    } catch (e) { S.P = null; }
    if (!S.Pfetch && window.fetch) {
      S.Pfetch = true;
      var srcs = $$('script[src]').map(function (x) { return x.src; }).filter(function (u) { return /cw-rs-test-s\d+\.js|rip-studio/i.test(u); });
      var out2 = [], i = 0;
      var next = function () {
        if (i >= srcs.length) { if (out2.length > 20) { S.P = out2; H3.byT = null; liveAdd(); } return; }
        fetch(srcs[i++]).then(function (r) { return r.ok ? r.text() : ''; }).then(function (t) { try { ingest(t, out2); } catch (e) { /* negeren */ } next(); }, next);
      };
      next();
    }
    return S.P;
  }
  /* basis-URL van de uitsneden: dezelfde als die van de pagina (cutImg in haar eigen script), of window.CW_RS_CUT_BASE */
  function cutUrl(h) {
    if (S.cb === undefined || S.cb === null) {
      var base = window.CW_RS_CUT_BASE ? String(window.CW_RS_CUT_BASE) : null;
      if (!base) { (S.texts || []).some(function (t) { var m = /cutImg\s*=\s*p\s*=>[^;]*?'([^']*)'\s*\+\s*p\.h\s*\+\s*'\.webp'/.exec(t); if (m) { base = m[1]; return true; } return false; }); }
      if (!base && S.P) {
        var hs = {}; S.P.forEach(function (e) { if (e.nm === 'CATALOG' && e.c.h) hs[e.c.h] = 1; });
        $$('img[src]').some(function (im) { var m = /^(.*?)([a-z0-9][a-z0-9-]*)\.webp(?:\?|$)/i.exec(im.getAttribute('src') || ''); if (m && hs[m[2]]) { base = m[1]; return true; } return false; });
      }
      S.cb = base;
    }
    return S.cb === null || S.cb === undefined ? null : S.cb + h + '.webp';
  }
  function readReal() {
    var ch = $('#gChain'); if (!ch || ch.hidden) return null;
    var c = $('#gChain [data-gcat][aria-selected="true"]'), l = $('#gChain [data-glang][aria-selected="true"]');
    return { cat: c ? c.getAttribute('data-gcat') : '', lang: l ? l.getAttribute('data-glang') : '' };
  }
  function learnLabels() {
    $$('#gChain [data-gcat],#gChain [data-glang]').forEach(function (b) {
      if (b.getAttribute('role') !== 'option') return;
      var k = b.getAttribute('data-gcat') || b.getAttribute('data-glang'), c = b.firstChild;
      S.labels[k] = andere((c && c.nodeType === 3 ? c.textContent : txt(b)).trim());
    });
  }
  var lab = function (k) { return k === OTHER ? 'Overig' : (S.labels[k] || catT(k) || k); };
  var subLab = function (k) { var l = lab(k); return SHORT[l] || SHORT[k] || l; };
  /* tellingen uit de productdata (volgen franchise en taal), zoals cardworld.be: elke categorie van een product telt mee
     (scats), een product zonder categorie (accessoires, cadeaubon) telt in geen enkele categorie (10 okt: geen "Overig") */
  /* 10 okt (Andrea): de tellingen en de lijst volgen de zoekterm NIET; zoeken filtert enkel de tegels */
  function catCounts(fr, lg) {
    var out = {}, P = loadP();
    if (P) { P.forEach(function (p) { if (avOk(p) && (fr === 'all' || p.sfr === fr) && (!lg || p.slang === lg)) { catsOf(p).forEach(function (k) { out[k] = (out[k] || 0) + 1; }); } }); return out; }
    $$('#gChain [data-gcat]').forEach(function (b) { if (b.getAttribute('role') === 'option') out[b.getAttribute('data-gcat')] = +txt($('span', b)) || 0; });
    return out;
  }
  /* aantal producten (niet de som over de categorieen: een product met 2 categorieen telt 1 keer) */
  function prodCount(fr, lg) {
    var P = loadP(), n = 0; if (!P) return null;
    P.forEach(function (p) { if (avOk(p) && (fr === 'all' || p.sfr === fr) && (!lg || p.slang === lg)) n++; });
    return n;
  }
  /* per groep het aantal producten met minstens 1 zichtbare categorie in die groep (Livestream blijft verborgen) */
  function grpCounts(fr, lg) {
    var out = {}, P = loadP(); if (!P) return out;
    P.forEach(function (p) {
      if (!(avOk(p) && (fr === 'all' || p.sfr === fr) && (!lg || p.slang === lg))) return;
      var seen = {}; catsOf(p).forEach(function (c) { if (hiddenCat(c)) return; var g = groupOf(c); if (!seen[g]) { seen[g] = 1; out[g] = (out[g] || 0) + 1; } });
    });
    return out;
  }
  function langCounts(fr, cats) {
    var out = {}, P = loadP();
    if (P) {
      var set = {}; (cats || []).forEach(function (c) { set[c] = 1; });
      P.forEach(function (p) { if (avOk(p) && (fr === 'all' || p.sfr === fr) && p.slang && (!cats || inCats(p, set))) out[p.slang] = (out[p.slang] || 0) + 1; });
      return out;
    }
    $$('#gChain [data-glang]').forEach(function (b) { if (b.getAttribute('role') === 'option') out[b.getAttribute('data-glang')] = +txt($('span', b)) || 0; });
    return out;
  }
  /* 12 okt (Andrea): de lijsten tonen ALTIJD alle categorieen (en talen) van de franchise; de taal bepaalt enkel de aantallen. S.ex = de categorieen die
     er in welke taal dan ook zijn (zonder taalfilter geteld), cc = de aantallen in de gekozen taal (0 = gedempt, wel klikbaar). */
  function liveCats(cc, grp) { var ex = S.ex || cc; return Object.keys(ex).filter(function (c) { return ex[c] > 0 && !hiddenCat(c) && groupOf(c) === grp; }).sort(function (a, b) { return (cc[b] || 0) - (cc[a] || 0) || ex[b] - ex[a]; }); }
  /* past de gekozen taal bij de gekozen categorie(en)? Zonder productdata altijd ja. */
  function langFits() {
    if (!S.lang) return true;
    var P = loadP(); if (!P) return true;
    var cats = selCats(S.ex || {}); if (!cats) return true;
    var set = {}; cats.forEach(function (c) { set[c] = 1; });
    return P.some(function (p) { return avOk(p) && (S.fr === 'all' || p.sfr === S.fr) && p.slang === S.lang && inCats(p, set); });
  }
  function selCats(cc) { if (S.sub) return [S.sub]; if (S.grp) return liveCats(cc, S.grp); return null; }
  var realCatFor = function (cats) { return cats && cats.length === 1 && cats[0] !== OTHER ? cats[0] : ''; };
  var expectedCat = function (cc) { return realCatFor(selCats(cc)); };
  /* applyReal klikt programmatisch in de keuzelijsten van de pagina. Die kliks bereiken onClick/sync van ons zelf: zonder S.inReal sloot onClick de
     open lijst en liet sync() de net gekozen taal terugzetten naar de (nog lege) taal van de pagina, zodat de klik op bv. Chinees niets deed. */
  function applyReal() {
    if (S.inReal) return;
    S.inReal = true;
    try {
      S.ex = catCounts(S.fr, '');
      /* categorie zonder treffers in de gekozen taal: de categorie wint en de taal springt terug naar Alle; een taal zonder treffers in de gekozen
         categorie (S.pickLang, de taal is net gekozen): de taal wint en de categorie gaat weg. Zo land je nooit op een leeg raster. */
      if (!langFits()) { if (S.pickLang) { S.grp = ''; S.sub = ''; } else S.lang = ''; }
      applyReal0();
    } finally { S.inReal = false; S.pickLang = false; }
  }
  function applyReal0() {
    var r = readReal(); if (!r) return;
    var wc = expectedCat(catCounts(S.fr, S.lang));
    if (r.cat !== wc) {
      if (wc) { var o = byAttr('#gChain [data-gcat]', 'data-gcat', wc); if (o) o.click(); }
      else { var x = $('#gChain [data-gcatx]'); if (x) x.click(); }
      r = readReal() || r;
    }
    if (r.lang !== S.lang) {
      if (S.lang) { var lo = byAttr('#gChain [data-glang]', 'data-glang', S.lang); if (lo) lo.click(); }
      else { var lx = $('#gChain [data-glangx]'); if (lx) lx.click(); }
    }
  }
  function setH(el, h) { if (el && el._h !== h) { el._h = h; el.innerHTML = h; } }
  var cntSpan = function (n) { return '<span class="cl-n">' + n + '</span>'; };

  /* ----- opbouw per variant ----- */
  var LANGHTML = '<div class="cl-langwrap"><button type="button" class="cl-langbtn" data-cl-langbtn aria-haspopup="listbox" aria-expanded="false"></button><div class="cl-menu" data-cl-langmenu role="listbox" hidden></div></div>';
  var SEARCHHTML = '<div class="cl-sbar"><div class="cl-swrap"><div class="cl-sinner"><svg class="cl-sic" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>' +
    '<input type="search" class="cl-sinput" data-cl-q placeholder="' + esc(shopPh()) + '" autocomplete="off" aria-label="' + esc(shopPh()) + '">' +
    '<button type="button" class="cl-sclear" data-cl-sclear aria-label="Zoekopdracht wissen"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg></button></div></div><div class="cl-sstatus" data-cl-sstatus aria-live="polite"></div></div>';
  function allHTML(v) { var h = allHTML0(v), i = h.lastIndexOf('<div class="cl-qs"'); return i < 0 ? h + SEARCHHTML : h.slice(0, i) + SEARCHHTML + h.slice(i); }
  function allHTML0(v) {
    var fr = v === 4 ? '' : '<div class="cl-utabs" data-cl-list="gfr"></div>', qs = '<div class="cl-qs" data-cl-qs></div>';
    var ddw = function (kind, t) { return '<span class="cl-ddw" data-cl-ddw="' + kind + '"><button type="button" class="cl-dd" data-cl-ddbtn="' + kind + '" aria-haspopup="menu" aria-expanded="false"><span class="cl-ddt" data-cl-ddt="' + kind + '">' + t + '</span>' + ic('chev', 'xs') + '</button><button type="button" class="cl-ddx" data-cl-rm="' + (kind === 'cat' ? 'grp' : 'lang') + '" aria-label="Wissen" hidden>' + ic('x', 'xs') + '</button></span>'; };
    var wis = function (t) { return '<button type="button" class="cl-link cl-wis" data-cl-rm="all" hidden>' + t + '</button>'; };
        if (v === 'B') return '<div class="cl-frrow cl-one">' + fr + '<div class="cl-chain" data-cl-grprow hidden>' + ddw('cat', LB('cat')) + ddw('lang', LB('lang')) + wis('Wis') + '</div></div>' + qs;
    if (v === 'C') return fr + '<div class="cl-sentence" data-cl-grprow hidden><span>Toon</span>' + ddw('cat', LB('allcat').toLowerCase()) + '<span>in</span>' + ddw('lang', LB('alllang').toLowerCase()) + wis('Wis') + '</div>' + qs;
    if (v === 'D') return fr + qs;
    if (v === 'A' || v === 'E') {
      /* E: de categoriebediening volgt S.cv (catSlotHTML); A houdt de knop. Bij C4 komt de kruimel als eigen rij boven de filterregel. */
      var cv = v === 'E' ? S.cv : '3';
      /* KIES: taal-placeholder "Kies taal..." (dropdown) voor de TAAL-groep; zichtbaar via syncCat zolang er geen taal gekozen is */
      var klw = v === 'E' && cv !== '2' ? '<span class="cl-klw" data-cl-klw hidden><i class="cl-ksep" aria-hidden="true">›</i><span class="cl-kbox cl-kp" data-cl-kbox><button type="button" class="cl-klb" data-cl-ddbtn="lang" aria-haspopup="menu" aria-expanded="false"><span class="cl-t" data-cl-klt>' + esc(LB('klang')) + '</span>' + ic('chev', 'xs cl-chev') + '</button>' + catX('lang', LB('clrlang')) + '</span></span>' : '';
      return fr + (cv === '4' ? catCrumbHTML() : '') + '<div class="cl-chain" data-cl-grprow hidden>' + (cv === '3' ? ddw('cat', LB('cat')) : catSlotHTML(cv)) + klw + '<div class="cl-lgrp" data-cl-lgrp hidden><span class="cl-vsep" aria-hidden="true"></span><span class="cl-llab" data-cl-llab>' + esc(LB('lang')) + '</span><div class="cl-lseg cl-utabs" data-cl-lseg role="group" aria-label="' + esc(LB('lang')) + '"></div></div>' + wis(LB('wisf')) + '</div>' + qs;
    }
    if (v === 6) return fr + '<div class="cl-chain" data-cl-grprow hidden>' +
      '<span class="cl-ddw" data-cl-ddw="cat"><button type="button" class="cl-dd" data-cl-ddbtn="cat" aria-haspopup="menu" aria-expanded="false"><span class="cl-ddt" data-cl-ddt="cat">Categorie</span>' + ic('chev', 'xs') + '</button><button type="button" class="cl-ddx" data-cl-rm="grp" aria-label="Wissen" hidden>' + ic('x', 'xs') + '</button></span>' +
      '<span class="cl-ddw" data-cl-ddw="lang"><button type="button" class="cl-dd" data-cl-ddbtn="lang" aria-haspopup="menu" aria-expanded="false"><span class="cl-ddt" data-cl-ddt="lang">Taal</span>' + ic('chev', 'xs') + '</button><button type="button" class="cl-ddx" data-cl-rm="lang" aria-label="Wissen" hidden>' + ic('x', 'xs') + '</button></span>' +
      '<button type="button" class="cl-link cl-wis" data-cl-rm="all" hidden>Wis filters</button></div>' + qs;
    if (v === 3) return '<div class="cl-frrow">' + fr + '<button type="button" class="cl-btnf" data-cl-fbtn aria-haspopup="dialog" aria-expanded="false">' + ic('sliders', 'sm') + '<span data-cl-fl>Filters</span><span class="cl-badge" data-cl-fbadge hidden></span></button></div><div class="cl-actives" data-cl-actives hidden></div>' + qs;
    if (v === 2) return fr + '<div class="cl-grprow" data-cl-grprow hidden><div class="cl-r2" data-cl-r2></div>' + LANGHTML + '</div>' + qs;
    if (v === 5) return fr + '<div class="cl-grprow v5" data-cl-grprow hidden><div class="cl-gseg pills" data-cl-gseg></div><div class="cl-sub5" data-cl-sub5></div>' + LANGHTML + '</div>' + qs;
    return fr + '<div class="cl-grprow" data-cl-grprow hidden><div class="cl-gseg' + (v === 4 ? ' pills' : '') + '" data-cl-gseg></div>' + LANGHTML + '</div>' + qs;
  }
  function gsegHTML(M, carets) {
    return M.items.map(function (i) {
      var sub = carets && i.k !== 'all' && i.subs.length > 1, open = S.pop && S.pop.kind === 'grp' && S.pop.k === i.k;
      var extra = i.on && S.sub && i.k !== 'all' ? '<span class="cl-gsub">· ' + esc(subLab(S.sub)) + '</span>' : '';
      return '<span class="cl-gi' + (i.on ? ' on' : '') + '"><button type="button" class="cl-gb" data-cl-ggrp="' + esc(i.k) + '"><span class="cl-t">' + esc(i.l) + '</span>' + extra + cntSpan(i.n) + '</button>' +
        (sub ? '<button type="button" class="cl-caret" data-cl-gdd="' + esc(i.k) + '" aria-haspopup="menu" aria-expanded="' + (open ? 'true' : 'false') + '" aria-label="' + esc(i.l) + '">' + ic('chev', 'xs') + '</button>' : '') + '</span>';
    }).join('');
  }
  function subLinks(M, withN) {
    return [{ k: '', l: LB('alle'), n: M.gc[S.grp] }].concat(M.subs.map(function (c) { return { k: c, l: subLab(c), n: M.cc[c] || 0 }; })).map(function (i) {
      return '<button type="button" class="cl-sublink' + ((S.sub || '') === i.k ? ' on' : '') + (i.n === 0 ? ' cl-z' : '') + '" data-cl-gsub="' + esc(i.k) + '">' + esc(i.l) + (withN ? cntSpan(i.n) : '') + '</button>';
    }).join('');
  }
  /* ----- Categorie-bediening in E: opbouw per variant (zie S.cv bovenaan) ----- */
  var catX = function (rm, l) { return '<button type="button" class="cl-ddx" data-cl-rm="' + rm + '" aria-label="' + l + '" hidden>' + ic('x', 'xs') + '</button>'; };
  var catTrig = function (cls, inner) { return '<button type="button" class="' + cls + '" data-cl-cattrig aria-haspopup="menu" aria-expanded="false">' + inner + '</button>'; };
  function catSlotHTML(cv) {
    /* C1: label CATEGORIE + een tekst-tab met onderlijn (zelfde opbouw als de TAAL-groep); in C2 is dit de terugval als de rij niet past */
    var c1 = '<div class="cl-lgrp cl-cgrp cl-cg1" data-cl-cg1 hidden><span class="cl-llab">Categorie</span><div class="cl-lseg cl-utabs cl-cseg" data-cl-cseg><span class="cl-ind"></span>' +
      catTrig('cl-ls on cl-ctab', '<span class="cl-t" data-cl-cattxt>' + esc(LB('alle')) + '</span>' + ic('chev', 'xs cl-chev')) + catX('grp', LB('clrcat')) + '</div></div>';
    if (cv === '1') return c1;
    /* C2: groepen als tekst-tabs (inhoud via syncCat), plus de C1-groep als terugval */
    if (cv === '2') return c1 + '<div class="cl-lgrp cl-cgrp cl-cg2" data-cl-cg2 hidden><span class="cl-llab">Categorie</span><div class="cl-lseg cl-utabs cl-cseg2" data-cl-cseg2 role="group" aria-label="Categorie"></div></div>';
    /* C5: kruimel in de stijl van de categorieregel op de productkaarten (inhoud via c5HTML in syncCat: met KIES is de franchise een vast stuk) */
    if (cv === '5') return '<span class="cl-cg5" data-cl-cg5 hidden></span>';
    return ''; /* C4: de kruimel staat boven de filterregel (catCrumbHTML) */
  }
  function c5HTML(kies) {
    var chev = ic('chev', 'xs cl-chev');
    /* met KIES zit de trigger met het kruisje in een box (.cl-kbox): leeg gestippeld, gekozen effen paars gevuld */
    if (kies) return '<span class="cl-c5fx"><span class="cl-c5fr" data-cl-c5fr>' + esc(LB('all')) + '</span></span><i class="cl-frs" aria-hidden="true">\u203a</i><span class="cl-kbox cl-kp" data-cl-kbox>' + catTrig('cl-c5t cl-k', '<span class="cl-c5c" data-cl-c5c>' + esc(LB('allcat')) + '</span>' + chev) + catX('grp', LB('clrcat')) + '</span>';
    return catTrig('cl-c5t', '<span class="cl-c5fr" data-cl-c5fr>' + esc(LB('all')) + '</span><span class="cl-frs" aria-hidden="true">\u203a</span><span class="cl-c5c" data-cl-c5c>' + esc(LB('allcat')) + '</span>' + chev) + catX('grp', LB('clrcat'));
  }
  function catCrumbHTML() {
    return '<div class="cl-c4" data-cl-c4 hidden><span class="cl-c4fr" data-cl-c4fr>Alles</span><i class="cl-sep" data-cl-c4sep aria-hidden="true">\u203a</i>' +
      catTrig('cl-c4dd', '<span data-cl-cattxt>' + esc(LB('allcat')) + '</span>' + ic('chev', 'sm cl-chev')) + catX('grp', LB('clrcat')) + '<span class="cl-fcount" data-cl-fcount></span></div>';
  }
  /* tabrij met eigen HTML (niet via syncList): herbouwen enkel als de HTML verandert, de indicator start op de vorige plek */
  function setTabs(host, html) {
    if (!host) return;
    if (host._h !== html) {
      var prev = host._ind;
      host._h = html; host.innerHTML = '<span class="cl-ind"></span>' + html;
      var ni = $('.cl-ind', host);
      if (ni && prev) { ni.style.transition = 'none'; ni.style.width = prev.w + 'px'; ni.style.transform = 'translateX(' + prev.x + 'px)'; void ni.offsetWidth; ni.style.transition = ''; host._indReady = true; }
      else host._indReady = false;
    }
    placeInd(host);
  }
  var frDisp = function (l) { return norm(l) === 'pokemon' ? 'Pok\u00e9mon' : andere(l || ''); };
  /* franchisekleur zoals op de kaarten (FRC); zonder franchise lavendel */
  function frColor(l) { var k = norm(String(l || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '')); if (!k) return ['#a78fd4', '#7B5EA7']; return FRC[k] || ['#9488AE', '#6d6685']; }
  function syncCat(M, items, frItems) {
    var all = $('.cl-all'); if (!all || S.v !== 'E') return;
    var has = items.length > 1, open = !!(S.pop && S.pop.kind === 'cat'), chosen = !!(S.grp || S.sub);
    var catTxt = S.sub ? subLab(S.sub) : S.grp ? grpLabel(S.grp) : '';
    var onF = frItems.filter(function (x) { return x.on; })[0], frL = onF && onF.k !== 'all' ? onF.l : '';
    var setT = function (el, s) { if (el && el.textContent !== s) el.textContent = s; };
    /* KIES: niets gekozen = gestippelde placeholder (klasse cl-kp op de trigger), gekozen = de stijl van de variant */
    var k = kiesOn(), kEmpty = k && !chosen;
    var g1 = $('[data-cl-cg1]', all);
    if (g1) {
      g1.hidden = !has;
      g1.classList.toggle('cl-kempty', kEmpty);
      var b1 = $('[data-cl-cattrig]', g1); b1.classList.toggle('cl-kp', kEmpty);
      setT($('[data-cl-cattxt]', g1), kEmpty ? LB('kcat') : (catTxt || LB('alle')));
      b1.setAttribute('aria-expanded', open && !S.pop.k ? 'true' : 'false');
      $('.cl-ddx', g1).hidden = !chosen;
      if (!kEmpty) placeInd($('[data-cl-cseg]', g1));
    }
    var g2 = $('[data-cl-cg2]', all);
    if (g2) {
      g2.hidden = !has;
      var host = $('[data-cl-cseg2]', g2);
      setTabs(host, items.map(function (i) {
        var isOn = i.k === 'all' ? !S.grp : S.grp === i.k, pop = i.k !== 'all' && i.subs.length > 1;
        var s = '<button type="button" class="cl-ls' + (isOn ? ' on' : '') + '" data-cl-ctab="' + esc(i.k) + '"' + (pop ? ' aria-haspopup="menu"' : '') + '><span class="cl-t">' + esc(i.k === 'all' ? LB('alle') : i.l) + '</span>' + (i.k !== 'all' ? cntSpan(i.n) : '') + '</button>';
        if (isOn && S.sub && i.k !== 'all') s += '<span class="cl-csub"><i aria-hidden="true">\u203a</i><span>' + esc(subLab(S.sub)) + '</span><button type="button" class="cl-ddx" data-cl-rm="sub" aria-label="Subtype wissen">' + ic('x', 'xs') + '</button></span>';
        return s;
      }).join(''));
      $$('[data-cl-ctab]', host).forEach(function (b) {
        b.setAttribute('aria-pressed', b.classList.contains('on') ? 'true' : 'false');
        if (b.hasAttribute('aria-haspopup')) b.setAttribute('aria-expanded', open && S.pop.k === b.getAttribute('data-cl-ctab') ? 'true' : 'false');
      });
      /* past de rij niet (1440 met een gekozen subtype), dan de C1-weergave; de C2-groep blijft onzichtbaar buiten de flow en dus meetbaar,
         zodat de keuze niet heen en weer springt */
      var row = g2.closest('[data-cl-grprow]');
      if (row && has) {
        var gap = parseFloat(getComputedStyle(row).columnGap) || 14, used = 0, n = 0;
        Array.prototype.forEach.call(row.children, function (c) { if (c === g2 || c === g1 || c.hidden) return; var w = c.getBoundingClientRect().width; if (w < 1) return; used += w; n++; });
        var fb = used + g2.getBoundingClientRect().width + n * gap > row.clientWidth;
        if (all.classList.contains('cl-c2fb') !== fb) { all.classList.toggle('cl-c2fb', fb); if (g1) { $('[data-cl-cseg]', g1)._indReady = false; placeInd($('[data-cl-cseg]', g1)); } }
      } else all.classList.remove('cl-c2fb');
    }
    var c4 = $('[data-cl-c4]', all);
    if (c4) {
      c4.hidden = false;
      setT($('[data-cl-c4fr]', c4), frL ? frDisp(frL) : LB('all'));
      setT($('[data-cl-cattxt]', c4), kEmpty ? LB('kcat') : (catTxt || LB('allcat')));
      var b4 = $('[data-cl-cattrig]', c4); b4.hidden = !has; $('[data-cl-c4sep]', c4).hidden = !has; b4.classList.toggle('cl-kp', kEmpty);
      b4.setAttribute('aria-expanded', open ? 'true' : 'false');
      $('.cl-ddx', c4).hidden = !chosen;
      setT($('[data-cl-fcount]', c4), txt($('#gCount')) + ' ' + txt($('#gCountL')));
    }
    var g5 = $('[data-cl-cg5]', all);
    if (g5) {
      g5.hidden = !has;
      /* met KIES is de franchise een vast kruimelstuk en enkel het te kiezen deel de knop; de opbouw wisselt alleen bij de schakelaar */
      var k5 = k ? 'k' : 'n'; if (g5._k !== k5) { g5._k = k5; g5.innerHTML = c5HTML(k); }
      var col = frColor(frL);
      if (g5._c !== col[0]) { g5._c = col[0]; g5.style.setProperty('--frc', col[0]); g5.style.setProperty('--frct', col[1]); }
      setT($('[data-cl-c5fr]', g5), frL ? frDisp(frL) : LB('all'));
      /* met KIES enkel het diepste niveau (zoals op de kaarten: franchise > categorie), zodat de gekozen waarde in de placeholderbreedte past en de
         regel niet verspringt; de groep blijft in hash, titel en megamenu. Zonder KIES het volledige pad. */
      var path = kEmpty ? '<span>' + esc(LB('kcat')) + '</span>' : k && catTxt ? '<span>' + esc(catTxt) + '</span>' : S.grp ? '<span>' + esc(grpLabel(S.grp)) + '</span>' + (S.sub ? '<span class="cl-frs" aria-hidden="true">\u203a</span><span>' + esc(subLab(S.sub)) + '</span>' : '') : '<span>' + esc(LB('allcat')) + '</span>';
      setH($('[data-cl-c5c]', g5), path);
      var b5 = $('[data-cl-cattrig]', g5); b5.classList.toggle('on', chosen); b5.setAttribute('aria-expanded', open ? 'true' : 'false');
      var kb5 = $('[data-cl-kbox]', g5); if (kb5) { kb5.classList.toggle('cl-kp', kEmpty); kb5.classList.toggle('cl-kv', !kEmpty); }
      $('.cl-ddx', g5).hidden = !chosen;
    }
    /* taal met KIES: altijd dezelfde dropdown-box op dezelfde plek (nooit de TAAL-tabs): leeg "Kies taal..." met stippelrand, gekozen de taal
       met effen lichte rand en kruisje; de box houdt de breedte van de lege staat (gemeten) zodat de regel niet verspringt */
    var klw = $('[data-cl-klw]', all);
    if (klw) {
      var kl = k && M.langItems.length > 1;
      klw.hidden = !kl;
      if (k) { var lg = $('[data-cl-lgrp]', all); if (lg) lg.hidden = true; }
      var klb = $('[data-cl-ddbtn]', klw);
      klb.setAttribute('aria-expanded', kl && S.pop && S.pop.kind === 'lang' ? 'true' : 'false');
      var kbl = $('[data-cl-kbox]', klw); kbl.classList.toggle('cl-kp', !S.lang); kbl.classList.toggle('cl-kv', !!S.lang);
      setT($('[data-cl-klt]', klw), S.lang ? lab(S.lang) : LB('klang'));
      $('.cl-ddx', klw).hidden = !S.lang;
    }
  }
  var CAT_MEGA = false;
  function popHTML(M) {
    var h = '', row = function (attr, k, l, n, on) { return '<button type="button" role="menuitem" class="' + (on ? 'on' : '') + (n === 0 ? ' cl-z' : '') + '" ' + attr + '="' + esc(k) + '"><span>' + esc(l) + '</span><i>' + n + '</i></button>'; };
    /* 10 okt: de categoriekeuze is een gewone lijst zoals Kies taal (Andrea); het megamenu met beelden staat uit via CAT_MEGA */
    if (S.pop.kind === 'cat' && S.v === 'E' && CAT_MEGA) {
      /* kolommen: elke groep met meerdere soorten een eigen kolom, de groepen van een soort samen onder elkaar in de laatste kolom
         (Packs | Boxen | Tins + Speciaal); zijn er enkel enkelvoudige groepen, dan verdeeld over maximaal 3 kolommen. Rijen als grid
         (beeld | naam | aantal), korte namen met de volledige naam in title. */
    var colHTML = function (groups) {
        var h2 = '<div class="cl-mcol">';
        groups.forEach(function (i) {
          var im = grpImg(M.fr, i, M);
          h2 += '<button type="button" role="menuitem" class="cl-mh' + (S.grp === i.k && !S.sub ? ' on' : '') + (i.n === 0 ? ' cl-z' : '') + '" data-cl-gpick="' + esc(i.k) + '|">' +
            '<span class="cl-mi">' + (im ? '<img src="' + esc(im) + '" alt="" width="56" height="56" loading="lazy">' : '') + '</span><b class="cl-mx">' + esc(i.l) + '</b><i class="cl-mn">' + i.n + '</i></button>';
          if (i.subs.length > 1) i.subs.forEach(function (c) {
            var si = subImg(M.fr, c), full = subLab(c), shortL = MSHORT[lab(c)] || full;
            h2 += '<button type="button" role="menuitem" class="cl-ms' + (S.sub === c ? ' on' : '') + (!M.cc[c] ? ' cl-z' : '') + '" data-cl-gpick="' + esc(i.k) + '|' + esc(c) + '"' + (shortL !== full ? ' title="' + esc(lab(c)) + '"' : '') + '>' +
              '<span class="cl-msi">' + (si ? '<img src="' + esc(si) + '" alt="" width="30" height="30" loading="lazy">' : '') + '</span><span class="cl-mst">' + esc(shortL) + '</span><i>' + M.cc[c] + '</i></button>';
          });
        });
        return h2 + '</div>';
      };
      /* C2: enkel de kolom van de aangeklikte groep */
      var one = S.pop.k ? M.items.filter(function (i) { return i.k === S.pop.k; })[0] : null;
      if (one) return '<div class="cl-mcols" style="--cl-mn:1">' + colHTML([one]) + '</div>';
      var gs = M.items.filter(function (i) { return i.k !== 'all'; }), multi = gs.filter(function (i) { return i.subs.length > 1; }), single = gs.filter(function (i) { return i.subs.length <= 1; });
      var cols = multi.map(function (i) { return [i]; });
      if (single.length) {
        if (!multi.length) { var kN = Math.min(3, single.length); for (var ci = 0; ci < kN; ci++) cols.push([]); single.forEach(function (g2, ix) { cols[ix % kN].push(g2); }); }
        else if (cols.length < 3) cols.push(single);
        else {
          /* al 3 (of meer) kolommen: de enkelvoudige groepen onder de kortste kolom, zodat de kolommen breed genoeg blijven voor de namen */
          var rowsOf = function (col) { return col.reduce(function (n, g3) { return n + 1 + (g3.subs.length > 1 ? g3.subs.length : 0); }, 0); };
          single.forEach(function (g4) { var best = 0; for (var cj = 1; cj < cols.length; cj++) if (rowsOf(cols[cj]) < rowsOf(cols[best])) best = cj; cols[best].push(g4); });
        }
      }
      h = '<button type="button" role="menuitem" class="cl-mall' + (!S.grp && !S.sub ? ' on' : '') + '" data-cl-gpick="|"><span>' + esc(LB('allcat')) + '</span><i>' + M.total + '</i></button>' +
        '<div class="cl-mcols" style="--cl-mn:' + Math.max(1, cols.length) + '">' + cols.map(colHTML).join('') + '</div>';
      return h;
    }
    if (S.pop.kind === 'cat') {
      h = row('data-cl-gpick', '|', LB('allcat'), M.total, !S.grp && !S.sub);
      M.items.forEach(function (i) {
        if (i.k === 'all') return;
        h += '<button type="button" role="menuitem" class="cl-ph' + (S.grp === i.k && !S.sub ? ' on' : '') + (i.n === 0 ? ' cl-z' : '') + '" data-cl-gpick="' + esc(i.k) + '|"><span>' + esc(i.l) + '</span><i>' + i.n + '</i></button>';
        if (i.subs.length > 1) i.subs.forEach(function (c) { h += '<button type="button" role="menuitem" class="cl-ps' + (S.sub === c ? ' on' : '') + (!M.cc[c] ? ' cl-z' : '') + '" data-cl-gpick="' + esc(i.k) + '|' + esc(c) + '"><span>' + esc(subLab(c)) + '</span><i>' + M.cc[c] + '</i></button>'; });
      });
      return h;
    }
    if (S.pop.kind === 'sort') {
      var ss = $('#gSort'); if (!ss) return '';
      return $$('option', ss).map(function (o) { var on = ss.value === o.value; return '<button type="button" role="menuitemradio" aria-checked="' + on + '" class="' + (on ? 'on' : '') + '" data-cl-sortopt="' + esc(o.value) + '"><span>' + esc(o.textContent) + '</span><i>' + (on ? ic('check', 'sm') : '') + '</i></button>'; }).join('');
    }
    if (S.pop.kind === 'fr') return (S.frItems || readGrid().fr).map(function (i) { return '<button type="button" role="menuitem" class="' + (i.on ? 'on' : '') + '" data-cl-gfr="' + esc(i.k) + '"><span>' + esc(i.l) + '</span><i>' + i.n + '</i></button>'; }).join('');
    if (S.pop.kind === 'lang') return M.langItems.map(function (i) { return row('data-cl-langopt', i.k, i.l, i.n, (S.lang || '') === i.k); }).join('');
    if (S.pop.kind === 'grp') {
      var g = S.pop.k, subs = M.gsubs[g] || [];
      h = row('data-cl-gpick', g + '|', 'Alle ' + grpLabel(g), M.gc[g] || 0, S.grp === g && !S.sub) + subs.map(function (c) { return row('data-cl-gpick', g + '|' + c, subLab(c), M.cc[c], S.sub === c); }).join('');
      return h;
    }
    h = '<div class="cl-fp-h">Type</div><div class="cl-chips">' + M.items.filter(function (i) { return i.k !== 'all'; }).map(function (i) { return '<button type="button" class="cl-chip' + (i.on ? ' on' : '') + (i.n === 0 ? ' cl-z' : '') + '" data-cl-ggrp="' + esc(i.k) + '"><span class="cl-t">' + esc(i.l) + '</span>' + cntSpan(i.n) + '</button>'; }).join('') + '</div>';
    if (S.grp && M.subs.length > 1) h += '<div class="cl-fp-h">' + esc(grpLabel(S.grp)) + '</div><div class="cl-chips">' + M.subs.map(function (c) { return '<button type="button" class="cl-chip' + (S.sub === c ? ' on' : '') + (!M.cc[c] ? ' cl-z' : '') + '" data-cl-gsub="' + esc(c) + '"><span class="cl-t">' + esc(subLab(c)) + '</span>' + cntSpan(M.cc[c]) + '</button>'; }).join('') + '</div>';
    if (M.langItems.length > 1) h += '<div class="cl-fp-h">' + esc(M.lt[0]) + '</div><div class="cl-chips">' + M.langItems.map(function (i) { return '<button type="button" class="cl-chip' + ((S.lang || '') === i.k ? ' on' : '') + (i.n === 0 ? ' cl-z' : '') + '" data-cl-langopt="' + esc(i.k) + '"><span class="cl-t">' + esc(i.l) + '</span>' + cntSpan(i.n) + '</button>'; }).join('') + '</div>';
    h += '<div class="cl-fp-f"><button type="button" class="cl-link" data-cl-pricebtn>Prijs en beschikbaarheid</button><button type="button" class="cl-link" data-cl-rm="all">Wis keuzes</button></div>';
    return h;
  }
  /* populairste product met beeld per groep: eerst de gecureerde producten (gerangschikt, met uitsnede), dan de rest;
     eerst binnen de gekozen franchise, anders over alle franchises */
  /* uitsnede (CUT_BASE, vrijstaand) van het populairste product: eerst de gecureerde producten (gerangschikt), dan de rest; eerst beschikbaar,
     eerst binnen de gekozen franchise, anders over alle franchises. Enkel producten met een uitsnede (gecureerd of met 3D-model). */
  function cutOf(p) { if (p.cut) return cutUrl(p.c.h); var m = null; try { m = h3Build(p); } catch (e) { m = null; } return m ? cutUrl(p.c.h) : null; }
  function pickImg(fr, test) {
    var P = loadP(); if (!P) return null;
    var find = function (frx, needAv) {
      for (var i = 0; i < P.length; i++) { var p = P[i]; if ((frx === 'all' || p.sfr === frx) && (!needAv || p.av) && test(p)) { var cu = cutOf(p); if (cu) return cu; } }
      return null;
    };
    return find(fr, true) || find(fr, false) || find('all', true) || find('all', false);
  }
  /* per subcategorie: het populairste product van die soort */
  function subImg(fr, c) {
    var key = 's|' + fr + '|' + c; if (key in S.imgs) return S.imgs[key];
    if (!loadP()) return null;
    var out = pickImg(fr, function (p) { return catsOf(p).indexOf(c) > -1; });
    S.imgs[key] = out; return out;
  }
  /* per groepskop: de voorkeurssoort (Packs een booster pack, Boxen een booster box, Tins een tin, Speciaal een vintage pack), anders de grootste soort
     (geen bundle bij Packs); binnen die soort liefst een product waarvan de titel bij de soort past (geen kaartenwaaier) */
  var HDR = { packs: ['Booster Packs', /booster pack/i], boxes: ['Booster Boxen', /booster box/i], tins: ['Tins', /tin/i], special: ['Vintage', /pack|booster/i] };
  function grpImg(fr, item, M) {
    var key = 'g|' + fr + '|' + item.k; if (key in S.imgs) return S.imgs[key];
    if (!loadP()) return null;
    var pref = HDR[item.k], sub = null;
    if (pref) { var want = pref[0]; sub = item.subs.filter(function (c) { return norm(lab(c)) === norm(want) || norm(c) === norm(want); })[0] || null; }
    if (!sub) { var cands = item.subs.filter(function (c) { return !(item.k === 'packs' && /bundle/i.test(lab(c))); }); sub = cands[0] || item.subs[0] || null; }
    var rx = pref ? pref[1] : null, out = null;
    if (sub) { out = (rx ? pickImg(fr, function (p) { return catsOf(p).indexOf(sub) > -1 && rx.test(p.c.t || ''); }) : null) || pickImg(fr, function (p) { return catsOf(p).indexOf(sub) > -1; }); }
    if (!out) out = pickImg(fr, function (p) { return catsOf(p).some(function (c) { return groupOf(c) === item.k; }); });
    S.imgs[key] = out; return out;
  }
  function popEl() {
    var p = $('#clPop');
    if (!p) { p = document.createElement('div'); p.id = 'clPop'; p.className = 'cl-pop cl-scope'; p.hidden = true; document.body.appendChild(p); }
    return p;
  }
  /* bruikbaar anker: in de DOM, met afmetingen, niet onzichtbaar (de sticky balk staat buiten beeld op visibility hidden) en in het venster.
     Een verborgen knop geeft een rect van 0, en dan landde de lijst linksboven in het venster (10 okt). */
  function popVis(n) {
    if (!n || !n.isConnected) return false;
    var r = n.getBoundingClientRect(); if (r.width < 1 || r.height < 1 || r.bottom <= 0 || r.top >= innerHeight) return false;
    try { if (getComputedStyle(n).visibility === 'hidden') return false; } catch (e) { /* negeren */ }
    return true;
  }
  function visFirst(sel) { return $$(sel).filter(popVis)[0] || null; }
  /* de lijst dicht zonder sync (veilig vanuit sync en placePop zelf) */
  function dropPop() {
    S.pop = null; S.popA = null; var p = $('#clPop'); if (p) { p.hidden = true; p.style.visibility = ''; }
    /* knoppen (aria-expanded, .on) kunnen al als "open" berekend zijn: een keer later opnieuw syncen (zonder S.pop geen lus) */
    if (!S.popResync) { S.popResync = true; setTimeout(function () { S.popResync = false; if (!S.pop) sync(); }, 0); }
  }
  function placePop() {
    var p = popEl(), a = S.popA; if (!S.pop || p.hidden) return false;
    if (!popVis(a)) {
      var kd = S.pop.kind;
      var q = kd === 'grp' ? visFirst('[data-cl-gdd="' + S.pop.k + '"]') : kd === 'filters' ? visFirst('[data-cl-fbtn]') : kd === 'sort' ? visFirst('[data-cl-sortbtn]')
        : kd === 'cat' && S.pop.k ? visFirst('[data-cl-ctab="' + S.pop.k + '"]') : kd === 'cat' ? visFirst('[data-cl-cattrig],[data-cl-ddw="cat"]')
        : kd === 'lang' ? visFirst('[data-cl-klw] [data-cl-ddbtn="lang"],[data-cl-ddw="lang"]') : visFirst('[data-cl-ddw="' + kd + '"]');
      a = S.popA = q ? (q.closest('.cl-gi') || q.closest('.cl-ddw') || q) : null;
    }
    /* geen zichtbaar anker (knop verborgen, ander scherm, sticky balk weg): de lijst gaat dicht, nooit los linksboven in het venster */
    if (!a) { dropPop(); return false; }
    var r = a.getBoundingClientRect(), w = p.offsetWidth;
    var left = S.pop.kind === 'filters' || S.pop.kind === 'sort' ? r.right - w : r.left;
    var L = Math.min(Math.max(12, left), innerWidth - w - 12) + 'px';
    /* hoogte (10 okt): de lijst past altijd in het venster. Ruimte onder de knop, of erboven als daar meer plaats is en de lijst onder niet past;
       daarbinnen scrolt de lijst zelf (CSS: overflow-y auto, overscroll-behavior contain). scrollHeight is de volledige inhoud, ook als max-height
       hem al beperkt, dus er hoeft niets tijdelijk losgelaten te worden (dat zou de scrollpositie in de lijst bij elke sync op 0 zetten). */
    var gap = 8, edge = 12, need = p.scrollHeight + (p.offsetHeight - p.clientHeight);
    var below = Math.floor(innerHeight - r.bottom - gap - edge), above = Math.floor(r.top - gap - edge);
    var up = need > below && above > below, room = Math.max(120, up ? above : below);
    var T = (up ? Math.max(edge, r.top - gap - Math.min(need, room)) : r.bottom + gap) + 'px', MH = room + 'px';
    if (p.style.left !== L) p.style.left = L;
    if (p.style.top !== T) p.style.top = T;
    if (p.style.maxHeight !== MH) p.style.maxHeight = MH;
    return true;
  }
  /* inhoud van de lijst; een fout geeft een lege string (dan opent er niets) in plaats van een open #clPop met oude inhoud */
  function popSafe(M) { try { return M && S.pop ? popHTML(M) : ''; } catch (e) { if (!CLEAN_PROD && window.console) console.warn('[clean] popHTML', e); return ''; } }
  function openPop(kind, k, anchor) {
    if (S.pop && S.pop.kind === kind && S.pop.k === k) { closePop(); return; }
    closeLangMenu();
    if (!S.M) sync(); /* klik voor de eerste sync: eerst het model vullen, nog zonder S.pop */
    S.pop = { kind: kind, k: k }; S.popA = anchor;
    var p = popEl(), h = popSafe(S.M);
    if (!h) { dropPop(); sync(); return; }
    p.className = 'cl-pop cl-scope ' + (kind === 'filters' ? 'wide' : kind === 'cat' && S.v === 'E' && CAT_MEGA ? 'mega' + (k ? ' one' : '') : '');
    p.innerHTML = p._h = h;
    /* eerst vullen en plaatsen terwijl de lijst onzichtbaar is (meetbaar, maar nooit een frame op de oude plek of op 0,0), dan tonen */
    p.style.visibility = 'hidden'; p.hidden = false;
    var ok = placePop();
    p.style.visibility = '';
    sync();
    if (ok && (kind === 'cat' || kind === 'lang' || kind === 'sort')) setTimeout(function () { var f = $('#clPop button.on') || $('#clPop button'); if (f) f.focus(); }, 30);
  }
  function closePop() {
    if (!S.pop) return;
    dropPop(); sync();
  }
  function fixTitle(M) {
    var t = $('#gTitle'); if (!t) return;
    var on = $('#gFr .g-pill.on'), c = on && on.firstChild;
    var parts = [on ? andere((c && c.nodeType === 3 ? c.textContent : txt(on)).trim()) : LB('all')];
    if (S.sub) parts.push(subLab(S.sub)); else if (S.grp) parts.push(grpLabel(S.grp));
    if (S.lang) parts.push(lab(S.lang));
    var s = parts.join(' › ');
    if (t.textContent !== s) t.textContent = s;
  }
  function syncGrid() {
    gridWatch();
    var all = $('.cl-all'); if (!all) return;
    /* onder 1100 px staat het Clean-zoekveld er niet en filtert Clean niets: een oude zoekterm (uit een eerdere brede stand of een
       vorige hash) mag de tegels dan nooit meer verbergen */
    if (!desk() && !mqOn() && (S.hideSet || S.hiding)) { S.hideSet = null; clearHide(); }
    var on = $('#gFr .g-pill.on'), fr = on ? on.getAttribute('data-gfr') : 'all', v = S.v;
    if (fr !== S.fr) { S.fr = fr; S.grp = ''; S.sub = ''; S.lang = ''; if (S.pop) closePop(); }
    learnLabels();
    var frItems = readGrid().fr;
    /* franchisetellers blijven staan tijdens het zoeken (zelfde regel als de categorieen) */
    if (loadP()) frItems = frItems.map(function (it) { return it.k === 'all' ? { k: it.k, l: it.l, n: prodCount('all', ''), on: it.on } : it; });
    $$('[data-cl-q]').forEach(function (qq) { if (document.activeElement !== qq && qq.value !== S.q) qq.value = S.q; });
    S.frItems = frItems;
    var qin = $('[data-cl-q]', all);
    if (qin) {
      var onp = $('#gFr .g-pill.on'), fcn = onp && onp.firstChild, fl = onp ? andere((fcn && fcn.nodeType === 3 ? fcn.textContent : txt(onp)).trim()) : '';
      var ph = fl ? LB('zoek') + fl : shopPh(); $$('[data-cl-q]').forEach(function (qq) { if (qq.placeholder !== ph) { qq.placeholder = ph; qq.setAttribute('aria-label', ph); } });
    }
    $$('[data-cl-list="gfr"]').forEach(function (h) { syncList(h, frItems, '', 'data-cl-gfr', true); });
    var fc = $('[data-cl-fcount]'); if (fc) { var ft = txt($('#gCount')) + ' ' + txt($('#gCountL')); if (fc.textContent !== ft) fc.textContent = ft; }
    var real = readReal();
    if (real) {
      S.ex = catCounts(fr, '');
      var cc0 = catCounts(fr, S.lang);
      if (real.cat !== expectedCat(cc0)) { if (real.cat) { S.sub = real.cat; S.grp = groupOf(real.cat); } else { S.sub = ''; S.grp = ''; } }
      if (real.lang !== S.lang) S.lang = real.lang;
    }
    var gr = readGrid();
    var ex = catCounts(fr, ''); S.ex = ex;
    var cc = catCounts(fr, S.lang); Object.keys(ex).forEach(function (k) { if (!(k in cc)) cc[k] = 0; });
    var exg = {}; Object.keys(ex).forEach(function (c) { if (ex[c] > 0 && !hiddenCat(c)) exg[groupOf(c)] = 1; });
    if (S.grp && !liveCats(cc, S.grp).length) { S.grp = ''; S.sub = ''; }
    if (S.sub && !(ex[S.sub] > 0)) S.sub = '';
    var total = 0, gc = {}, gsubs = {};
    Object.keys(cc).forEach(function (c) { total += cc[c]; if (hiddenCat(c)) return; var g = groupOf(c); gc[g] = (gc[g] || 0) + cc[c]; });
    /* 10 okt: Alles = aantal producten en elke groep telt een product 1 keer (een product met 2 categorieen in dezelfde
       groep, zoals pokemon-chase-bag, telde dubbel); zonder productdata blijft de som als terugval */
    var pc = prodCount(fr, S.lang); if (pc !== null) { total = pc; gc = grpCounts(fr, S.lang); }
    var allL = LB('all');
    var items = [{ k: 'all', l: allL, n: total, on: !S.grp, subs: [] }];
    GROUPS.forEach(function (g) { gsubs[g.k] = liveCats(cc, g.k); if (exg[g.k]) items.push({ k: g.k, l: grpLabel(g.k), n: gc[g.k] || 0, on: S.grp === g.k, subs: gsubs[g.k] }); });
    var cats = selCats(cc);
    var lc = langCounts(fr, cats), lcAll = langCounts(fr, null);
    Object.keys(lc).forEach(function (k) { if (!(k in lcAll)) lcAll[k] = lc[k]; });
    var langKeys = Object.keys(lcAll).filter(function (k) { return lcAll[k] > 0; }).sort(function (a, b) { return lcAll[b] - lcAll[a]; });
    langKeys.forEach(function (k) { if (!(k in lc)) lc[k] = 0; });
    if (S.lang && !(lc[S.lang] > 0)) S.lang = '';
    if (real && (real.lang !== S.lang || real.cat !== expectedCat(cc))) applyReal();
    var lt = { nl: ['Taal', 'Alle'], fr: ['Langue', 'Toutes'], en: ['Language', 'All'] }[lang()];
    var langItems = [{ k: '', l: lt[1], n: langKeys.reduce(function (a, k) { return a + lc[k]; }, 0) }].concat(langKeys.map(function (k) { return { k: k, l: lab(k), n: lc[k] }; }));
    var M = { fr: fr, items: items, cc: cc, gc: gc, gsubs: gsubs, subs: S.grp ? gsubs[S.grp] || [] : [], langItems: langItems, lt: lt, total: total };
    S.M = M;
    var showGroups = items.length > 2, showLang = langKeys.length > 1 || !!S.lang;
    /* taalmenu (alle varianten behalve V3) */
    var lbtn = $('[data-cl-langbtn]', all), lmenu = $('[data-cl-langmenu]', all);
    if (lbtn) {
      lbtn.parentNode.hidden = !showLang;
      var lh = lt[0] + ': <b>' + esc(S.lang ? lab(S.lang) : lt[1]) + '</b>' + ic('chev', 'xs');
      if (lbtn._h !== lh) { lbtn._h = lh; lbtn.innerHTML = lh; }
      setH(lmenu, langItems.map(function (i) {
        return '<button type="button" role="option" class="' + ((S.lang || '') === i.k ? 'on' : '') + (i.n === 0 ? ' cl-z' : '') + '" aria-selected="' + ((S.lang || '') === i.k) + '" data-cl-langopt="' + esc(i.k) + '"><span>' + esc(i.l) + '</span><i>' + i.n + '</i></button>';
      }).join(''));
    }
    var row = $('[data-cl-grprow]', all);
    if (row) row.hidden = $('.g-ctl', row) ? false : (/^[ABCE]$/.test(String(v)) ? !(items.length > 1 || showLang) : !(showGroups || showLang));
    var gseg = $('[data-cl-gseg]', all);
    if (v === 1 || v === 4) { if (gseg) { gseg.hidden = !showGroups; setH(gseg, gsegHTML(M, true)); } }
    else if (v === 5) {
      if (gseg) { gseg.hidden = !showGroups; setH(gseg, gsegHTML(M, false)); }
      var s5 = $('[data-cl-sub5]', all);
      if (s5) {
        var h5 = S.grp && M.subs.length > 1 ? '<span class="cl-s5l">' + esc(grpLabel(S.grp)) + ':</span>' + M.subs.map(function (c) { return '<button type="button" class="cl-sublink' + (S.sub === c ? ' on' : '') + '" data-cl-gsub="' + esc(c) + '" title="' + esc(subLab(c)) + ' (' + cc[c] + ')">' + esc(subLab(c)) + '</button>'; }).join('<i class="cl-dot">·</i>') : '';
        s5.hidden = !h5; setH(s5, h5);
      }
    } else if (v === 2) {
      var r2 = $('[data-cl-r2]', all);
      if (r2) {
        var h2 = '';
        if (S.grp && M.subs.length > 1) h2 = '<button type="button" class="cl-back" data-cl-back aria-label="Terug">' + ic('back', 'sm') + '<b>' + esc(grpLabel(S.grp)) + '</b></button><div class="cl-sub">' + subLinks(M, true) + '</div>';
        else if (showGroups) h2 = '<div class="cl-gseg">' + gsegHTML(M, false) + '</div>';
        setH(r2, h2);
      }
    } else if (/^[A-E]$/.test(String(v))) {
      var cw = $('.cl-all [data-cl-ddw="cat"],.cl-fhead [data-cl-ddw="cat"]'), lw = $('.cl-all [data-cl-ddw="lang"],.cl-fhead [data-cl-ddw="lang"]'), sent = v === 'C', crumb = v === 'D';
      if (cw) cw.hidden = items.length < 2;
      if (lw) lw.hidden = !showLang;
      var setDd = function (w, key, text, active) {
        if (!w) return;
        var t = $('[data-cl-ddt]', w), b = $('[data-cl-ddbtn]', w), x = $('.cl-ddx', w);
        if (t.textContent !== text) t.textContent = text;
        w.classList.toggle('on', !!active); x.hidden = !active;
        b.setAttribute('aria-expanded', S.pop && S.pop.kind === key ? 'true' : 'false');
      };
      /* KIES: lege keuze als placeholder-tekst met stippelrand (klasse cl-kp), ook op de compacte knoppen van de sticky balk */
      var kE = kiesOn() && !(S.grp || S.sub), kL = kiesOn() && !S.lang;
      setDd(cw, 'cat', S.sub ? subLab(S.sub) : S.grp ? grpLabel(S.grp) : sent ? LB('allcat').toLowerCase() : crumb ? LB('allcat') : kE ? LB('kcat') : LB('cat'), S.grp || S.sub);
      if (cw) cw.classList.toggle('cl-kp', kE);
      setDd(lw, 'lang', S.lang ? (sent ? 'het ' : '') + lab(S.lang) : sent ? 'alle talen' : crumb ? 'Alle talen' : lt[0], S.lang);
      var catTxt = S.sub ? subLab(S.sub) : S.grp ? grpLabel(S.grp) : kE ? LB('kcat') : LB('cat'), langTxt = S.lang ? lab(S.lang) : kL ? LB('klang') : lt[0];
      $$('.cl-stk [data-cl-ddw="fr"]').forEach(function (w) { var on3 = frItems.filter(function (x) { return x.on; })[0]; var h3 = (on3 ? esc(on3.l) : esc(LB('all'))) + (on3 && on3.n != null ? ' <span class="cl-n">' + on3.n + '</span>' : ''), t3 = $('[data-cl-ddt]', w); if (t3 && t3._h !== h3) { t3._h = h3; t3.innerHTML = h3; } $('[data-cl-ddbtn]', w).setAttribute('aria-expanded', S.pop && S.pop.kind === 'fr' ? 'true' : 'false'); });
      $$('.cl-stk [data-cl-ddw="cat"]').forEach(function (w) { w.hidden = items.length < 2; setDd(w, 'cat', catTxt, S.grp || S.sub); w.classList.toggle('cl-kp', kE); });
      $$('.cl-stk [data-cl-ddw="lang"]').forEach(function (w) { w.hidden = !showLang; setDd(w, 'lang', langTxt, S.lang); w.classList.toggle('cl-kp', kL); });
      $$('.cl-wis').forEach(function (ww) { ww.hidden = !(S.grp || S.sub || S.lang); });
      if (crumb) { var c1 = $('[data-cl-c1]'), on1 = $('#gFr .g-pill.on'), fc1 = on1 && on1.firstChild, t1 = on1 ? andere((fc1 && fc1.nodeType === 3 ? fc1.textContent : txt(on1)).trim()) : LB('all'); if (c1 && c1.textContent !== t1) c1.textContent = t1; }
      if (v === 'A' || v === 'E') {
        var ls = $('[data-cl-lseg]', all);
        if (ls) {
          var abbr = function (k) { var n = norm(lab(k)); return { engels: 'EN', japans: 'JP', chinees: 'CN', koreaans: 'KR', duits: 'DE', frans: 'FR' }[n] || lab(k).slice(0, 2).toUpperCase(); };
          ls.parentNode.hidden = !showLang; ls.hidden = false;
          var ll = $('[data-cl-llab]', all); if (ll && ll.textContent !== lt[0]) ll.textContent = lt[0];
          syncList(ls, langItems.map(function (i) { return { k: i.k, l: i.k === '' ? i.l : abbr(i.k), n: null, on: (S.lang || '') === i.k }; }), 'cl-ls', 'data-cl-langopt', true);
          $$('button', ls).forEach(function (b, ix) { var it = langItems[ix], t = it ? it.l + ' (' + it.n + ')' : ''; if (b.title !== t) b.title = t; });
        }
      }
    } else if (v === 3) {
      var act = $('[data-cl-actives]', all), pills = [];
      var pill = function (rm, l) { return '<span class="cl-sum">' + esc(l) + '<button type="button" data-cl-rm="' + rm + '" aria-label="Wissen">' + ic('x', 'xs') + '</button></span>'; };
      if (S.grp) pills.push(pill('grp', grpLabel(S.grp)));
      if (S.sub) pills.push(pill('sub', subLab(S.sub)));
      if (S.lang) pills.push(pill('lang', lab(S.lang)));
      if (act) { act.hidden = !pills.length; setH(act, pills.join('')); }
      var fb = $('[data-cl-fbtn]', all), nn = (S.grp ? 1 : 0) + (S.sub ? 1 : 0) + (S.lang ? 1 : 0) + (+txt($('#gFCount')) || 0);
      if (fb) {
        var bd = $('[data-cl-fbadge]', fb); bd.textContent = nn; bd.hidden = !nn;
        fb.setAttribute('aria-expanded', S.pop && S.pop.kind === 'filters' ? 'true' : 'false');
      }
    }
    /* groep/subtype/taal die de pagina zelf niet kan (meerdere categorieen, of zonder franchise): tegels filteren wij */
    var hide = !!(desk() && loadP() && (fr === 'all' ? (cats || S.lang || S.qt.length) : ((cats && !(cats.length === 1 && cats[0] !== OTHER)) || S.qt.length))), cnt = 0;
    if (hide) {
      var set = {}; (cats || []).forEach(function (c) { set[c] = 1; });
      var allowed = {};
      loadP().forEach(function (p) { if ((fr === 'all' || p.sfr === fr) && (!cats || inCats(p, set)) && (!S.lang || p.slang === S.lang) && qOk(p)) { allowed[p.t] = 1; cnt++; } });
      /* rem op het bijladen: telt per zoek-/filtercombinatie, niet per tick */
      var msig = S.q + '|' + fr + '|' + (cats || []).join(',') + '|' + S.lang;
      if (msig !== S.moreSig) { S.moreSig = msig; S.moreN = 0; }
      S.hideSet = allowed; hideNew();
      var ce = $('#gCount'); if (ce && ce.textContent !== String(cnt)) ce.textContent = cnt;
      S.hiding = true;
    } else if (desk() || !mqOn()) {
      /* ook zonder S.hiding: de pagina bouwt het raster opnieuw op (applyGrid) met dezelfde tegelelementen. Een tegel die tijdens een eerdere
         filter verborgen werd en toen niet in het raster stond (bv. uitverkocht, achteraan, bijgeladen) behield cl-gh en bleef onzichtbaar
         ("Pokemon > Blisters" toonde 1 van 6). Daarom altijd opruimen zodra er geen verberglijst meer is. */
      S.hideSet = null; if (S.hiding || $('#gGrid .tile.cl-gh')) clearHide();
    }
    var nq = $('[data-cl-noq]'), gg = $('#gGrid');
    var nqOn = !!(S.qt.length && hide && !cnt);
    if (desk()) {
    if (nqOn && !nq && gg) { nq = document.createElement('div'); nq.className = 'cl-noq cl-scope'; nq.setAttribute('data-cl-noq', ''); nq.setAttribute('role', 'status'); gg.parentNode.insertBefore(nq, gg); }
    if (nq) {
      nq.hidden = !nqOn;
      if (nqOn) { var nh = '<p>Geen resultaten voor \u201c' + esc(S.q) + '\u201d</p><button type="button" class="cl-noqx" data-cl-noqx>Zoekopdracht wissen</button> <button type="button" class="cl-noqx cl-noqp" data-cl-noqp>' + esc(DSL.pk[lang()]) + '</button>'; if (nq._h !== nh) { nq._h = nh; nq.innerHTML = nh; } }
    }
    }
    var sst = $('[data-cl-sstatus]', all);
    /* bij 0 treffers geen regel onder de zoekbalk: de lege staat in het raster zegt het al (stond dubbel, eigenaar 11 okt) */
    if (sst) { var stx = S.qt.length && hide && cnt ? cnt + (cnt === 1 ? ' resultaat' : ' resultaten') : ''; if (sst.textContent !== stx) sst.textContent = stx; }
    if (v === 'E') syncCat(M, items, frItems);
    fixTitle(M);
    var qh = gr.qs.map(function (q) { return '<span class="cl-sum">' + esc(q.l) + '<button type="button" data-cl-gq="' + q.i + '" aria-label="Wissen">' + ic('x', 'xs') + '</button></span>'; }).join('');
    var qe = $('[data-cl-qs]', all); if (qe && qe._h !== qh) { qe.innerHTML = qh; qe._h = qh; }
    if (S.pop) {
      var p = popEl(), ph = popSafe(M);
      if (!ph) dropPop();
      else { if (p._h !== ph) { p._h = ph; p.innerHTML = ph; } placePop(); }
    }
  }
  /* verbergen (groep, zoeken, taal zonder franchise) op alle tegels in de DOM; ook direct op nieuw bijgeladen tegels (zie gridWatch) */
  function hideNew() {
    var set = S.hideSet; if (!set) return;
    if (!desk() && !mqOn()) { S.hideSet = null; clearHide(); return; }
    var vis = 0, tiles = $$('#gGrid .tile');
    tiles.forEach(function (t) {
      var h = !set[norm(txt($('.t-title', t)))];
      if (h !== !!t._clh) { t.classList.toggle('cl-gh', h); t._clh = h; }
      if (!h) vis++;
    });
    /* de pagina laadt maar 36 tegels per keer: zit er in dit blok niets dat past terwijl er wel treffers zijn, dan meteen het volgende
       blok bijladen (niet wachten op de IntersectionObserver, die bij een verborgen raster of smalle layout soms niet vuurt) */
    /* genoeg zichtbare tegels om het scherm te vullen (24), en bij weinig treffers allemaal: ook als er al wat zichtbaar is blijven we bijladen */
    /* begrensd op het aantal treffers (anders bleef hij bij 3 zichtbare treffers nutteloos verborgen blokken bijladen); de klik loopt onder
       S.inReal zodat onze eigen document-handlers (menu's, filterpaneel, topkaarten) hem niet als klik buiten opvatten en dingen sluiten */
    var want = Math.min(24, Object.keys(set).length);
    if (vis < want && tiles.length && document.body.classList.contains('mode-grid')) {
      var mb = $('#gMore:not([hidden]) [data-gmore]'); if (mb && (S.moreN || 0) < 12) { S.moreN = (S.moreN || 0) + 1; var wasR = S.inReal; S.inReal = true; try { mb.click(); } finally { S.inReal = wasR; } }
    }
  }
  /* De pagina laadt tegels lui bij (nieuwe blokken van 36, ook na een filterwissel). Zonder deze waarnemer kregen die tegels hun
     kaartstijl en hun verbergen pas bij de volgende poll (tot 250 ms later): een tweede layoutsprong. Een MutationObserver enkel op
     de kinderlijst van #gGrid; hij wijzigt enkel de tegels zelf (geen kinderlijst), dus geen lus. Draait in een microtask, voor de paint. */
  function gridWatch() {
    if (S.gridMO) return;
    var g = $('#gGrid'); if (!g || !window.MutationObserver) return;
    S.gridMO = new MutationObserver(function () { if (!S.on) return; try { cardStyle(); hideNew(); if (HOVER_3D) h3Badges(); } catch (e) { /* negeren */ } });
    S.gridMO.observe(g, { childList: true });
  }
  function clearHide() {
    S.hiding = false;
    $$('#gGrid .tile.cl-gh').forEach(function (t) { t.classList.remove('cl-gh'); t._clh = false; });
  }
  function closeLangMenu() {
    var m = $('[data-cl-langmenu]'), b = $('[data-cl-langbtn]');
    if (m) m.hidden = true; if (b) b.setAttribute('aria-expanded', 'false');
  }

  /* ---------- mandje: pil, lade, auto-open ---------- */
  function readCart() {
    /* eerst de stand die de pagina zelf publiceert (window.CW_RS_CART_STATE, zelfde bron als het mandjepaneel); #hdrRipN
       bestaat niet in elke build, dan toonde de pil altijd "Mandje leeg" */
    var s = window.CW_RS_CART_STATE;
    if (s && typeof s.units === 'number') return { u: Math.max(0, s.units | 0), t: String(s.totalTxt || '') };
    var n = $('#hdrRipN'), t = $('#barTotal');
    return { u: n ? parseInt(txt(n), 10) || 0 : 0, t: t ? txt(t) : '' };
  }
  document.addEventListener('cw:cart', function () { try { syncPill(); } catch (e) { /* negeren */ } });
  function syncPill() {
    var p = $('.cl-pill'); if (!p) return;
    var c = readCart(), h;
    if (c.u > 0) h = ic('bag') + '<span class="cl-pl">' + esc(tt('cart')) + '</span><i class="cl-d">·</i><b class="cl-pe">' + esc(c.t) + '</b><i class="cl-d">·</i><span class="cl-pn">' + c.u + '</span>';
    else h = ic('bag') + '<span class="cl-pl">' + esc(tt('cart')) + ' ' + esc(tt('empty')) + '</span>';
    p.classList.toggle('has', c.u > 0);
    if (S.pillH !== h) { S.pillH = h; p.innerHTML = h; }
    /* op gsm is de pil een compact tasicoon (tekst verborgen): de naam voor schermlezers staat in aria-label */
    var al = c.u > 0 ? tt('cart') + ', ' + c.u + ' ' + (c.u === 1 ? 'stuk' : 'stuks') + ', ' + c.t : tt('cart') + ' ' + tt('empty');
    if (p.getAttribute('aria-label') !== al) p.setAttribute('aria-label', al);
    if (!desk()) { var ex = $('#ripSheet.on') ? 'true' : 'false'; if (p.getAttribute('aria-expanded') !== ex) p.setAttribute('aria-expanded', ex); }
    /* gsm: bij een toevoeging een korte tik op de knop (enkel transform), het teken dat het product in het mandje landde */
    if (S.pillU != null && c.u > S.pillU && !desk() && p.animate && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches)) {
      p.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.18)' }, { transform: 'scale(1)' }], { duration: 380, easing: 'cubic-bezier(.34,1.56,.64,1)' });
    }
    S.pillU = c.u;
    var dt = $('[data-cl-dt]'); if (dt && dt.textContent !== tt('title')) dt.textContent = tt('title');
    var dx = $('[data-cl-close]'); if (dx && dx.getAttribute('aria-label') !== tt('close')) dx.setAttribute('aria-label', tt('close'));
  }
  var cartOpen = function () { return document.body.classList.contains('cl-cart'); };
  var cdxOpen = function () { var c = $('#conc'); return !!(c && c.classList.contains('on')); };
  function setExpanded(v) { var p = $('.cl-pill'); if (p) p.setAttribute('aria-expanded', v ? 'true' : 'false'); }
  /* gsm (10 okt, Andrea: "toon gewoon rechtsboven jouw winkelmandje gelijk op desktop"): de mandjebalk onderaan is weg (css), de pil in de kopbalk
     opent het mandjeblad van de pagina zelf (#ripSheet, met Afrekenen) via dezelfde knop als de balk (#barSum: openSheet('ripSheet')).
     De lade (.col-r) bestaat enkel op desktop. */
  function openCartM() {
    var sh = $('#ripSheet'); if (sh && sh.classList.contains('on')) return;
    /* focus eerst op de pil: openSheet onthoudt het actieve element en zet de focus daar terug bij sluiten (iOS geeft een tik geen focus) */
    try { $('.cl-pill').focus({ preventScroll: true }); } catch (e) { /* negeren */ }
    var b = $('#barSum') || $('#barStackBtn'); if (b) b.click();
  }
  /* vluchtdoel voor app.js (stackTarget): een toegevoegd product landt op de Mandje-pil in de header; op desktop met open mandje-lade null (dan landt het in de lade) */
  window.CW_RS_CART_TARGET = function () { if (!S.on || (desk() && cartOpen())) return null; var p = $('.cl-pill'); return popVis(p) ? p : null; };
  /* mandje v2 (16 okt, testvlag ?cwcart=1 op cardworld.be): cw-cart.js (CWCart.open/close) gebruikt op de Rip Studio de eigen lade in plaats van een tweede.
     true = hier geopend (Clean staat aan); false laat cw-cart.js zijn eigen lade tonen. Zonder cw-cart.js (geen vlag) roept niemand dit aan. */
  window.CW_RS_OPEN_CART = function () { if (!S.on) return false; if (desk()) { if (!cartOpen()) openCart(false); } else openCartM(); return true; };
  window.CW_RS_CLOSE_CART = function () { if (S.on && desk() && cartOpen()) closeCart(); };
  /* focus en schermlezer: zolang de lade open staat en niet automatisch is geopend, is de themaheader inert en is de lade modaal; alles terug bij sluiten, stickCart en Clean uit */
  function cartModal(off) {
    var b = document.body, col = $('.col-r'), on = !off && S.on && b.classList.contains('cl-cart') && !b.classList.contains('cl-auto');
    var hs = $$('.shopify-section-group-header-group'), w = $('#cwh-wrap');
    if (w) { var wt = w.closest('.shopify-section-group-header-group') || w; if (hs.indexOf(wt) < 0) hs.push(wt); }
    hs.forEach(function (h) { if (on) { if (!h.hasAttribute('inert')) { h.setAttribute('inert', ''); h._clInert = true; } } else if (h._clInert) { h.removeAttribute('inert'); h._clInert = false; } });
    if (col) { if (on) col.setAttribute('aria-modal', 'true'); else col.removeAttribute('aria-modal'); }
  }
  function openCart(auto) {
    if (!desk()) return;
    if (cdxOpen()) closeCardix();
    if (S.pop) closePop();
    var b = document.body;
    clearTimeout(S.autoT);
    /* 10 okt: ook de automatische opening krijgt de donkere achtergrond (geen cl-auto meer); enkel de focus blijft dan waar hij was */
    b.classList.add('cl-cart'); b.classList.remove('cl-auto'); setExpanded(true); cartModal();
    /* 10 okt (Andrea): de automatische opening sluit niet meer vanzelf */
    if (!auto) { var x = $('[data-cl-close]'); if (x) setTimeout(function () { try { x.focus({ preventScroll: true }); } catch (e) { /* negeren */ } }, 60); }
  }
  function closeCart() {
    clearTimeout(S.autoT);
    document.body.classList.remove('cl-cart', 'cl-auto'); setExpanded(false); cartModal();
  }
  function stickCart() { if (document.body.classList.contains('cl-auto')) { clearTimeout(S.autoT); document.body.classList.remove('cl-auto'); cartModal(); } }
  function autoEnd() {
    var col = $('.col-r');
    if (!cartOpen() || !document.body.classList.contains('cl-auto')) return;
    /* de gebruiker staat erin (muis of focus): niet onder zijn handen sluiten */
    if (col && (col.matches(':hover') || col.contains(document.activeElement))) { S.autoT = setTimeout(autoEnd, 1500); return; }
    closeCart();
  }
  /* de pagina speelt bij openen en sluiten een cirkel/flip-animatie van ca. 0,6 s; die maken we meteen af zodat het paneel
     zonder wachttijd opent en sluit (de toestand van de pagina zelf is al direct goed, enkel de animatie liep nog) */
  function cdxFinish() {
    [$('#conc'), $('.col-r')].forEach(function (el) {
      if (!el || !el.getAnimations) return;
      try { el.getAnimations({ subtree: true }).forEach(function (a) { if (a.animationName || a.transitionProperty) return; try { a.finish(); } catch (e) { /* oneindige animaties negeren */ } }); } catch (e2) { /* negeren */ }
    });
  }
  /* korte uitfade (140 ms) nadat de pagina het paneel al direct heeft gesloten: de klasse houdt het kort zichtbaar */
  function cdxOut() {
    var c = $('#conc'); if (!c || RMQ.matches) return;
    c.classList.add('cl-out'); clearTimeout(S.outT); S.outT = setTimeout(function () { c.classList.remove('cl-out'); }, 150);
  }
  /* ---------- typemachine voor de voorbeeldvragen (zelfde lijst als cardix-client.js, 7b) ---------- */
  var ZINNEN = {
    nl: ['Vertel me je budget en wat je zoekt', '60 euro, Pok\u00e9mon, voor een cadeau', 'Wat zit er in de Prismatic Evolutions ETB?', 'One Piece onder 100 euro', 'Vanaf hoeveel is verzending gratis?', 'Wat wordt er nu geopend?'],
    fr: ['Dis-moi ton budget et ce que tu cherches', '80 euros, plut\u00f4t One Piece', "Qu'est-ce qu'il y a dans une ETB ?", 'Vous livrez en France ?', "Qu'est-ce qui s'ouvre en ce moment ?"],
    en: ['Tell me your budget and what you want', '50 euros, Pokemon, for a beginner', 'What is in an Elite Trainer Box?', 'Do you have Lorcana in stock?', 'What is opening right now?']
  };
  var TW = { t: 0, idx: 0, pos: 0, del: false, lg: '' };
  var twList = function () { return ZINNEN[lang()] || ZINNEN.nl; };
  function twAllowed() {
    var ta = $('#clTa'); if (!S.on || !ta || document.hidden || !cdxOpen()) return false;
    return document.activeElement !== ta && !ta.value;
  }
  function twPaint() {
    var ov = $('.cl-ph'), tx = ov && $('.cl-pht', ov); if (!ov) return;
    var cur = twList()[TW.idx % twList().length] || '';
    var shown = cur.substring(0, TW.pos);
    if (tx.textContent !== shown) tx.textContent = shown;
  }
  function twStop(hide) {
    clearTimeout(TW.t); TW.t = 0;
    if (hide) { var ov = $('.cl-ph'); if (ov) ov.hidden = true; }
  }
  function twStep() {
    TW.t = 0;
    if (!twAllowed()) { twStop(true); return; }
    var ov = $('.cl-ph'); if (!ov) return; ov.hidden = false;
    var list = twList(), cur = list[TW.idx % list.length];
    if (!TW.del) {
      TW.pos++; twPaint();
      if (TW.pos >= cur.length) { TW.del = true; TW.t = setTimeout(twStep, 1600); return; }
      TW.t = setTimeout(twStep, 35 + Math.random() * 10);
    } else {
      TW.pos--; twPaint();
      if (TW.pos <= 0) { TW.del = false; TW.pos = 0; TW.idx = (TW.idx + 1) % list.length; TW.t = setTimeout(twStep, 350); return; }
      TW.t = setTimeout(twStep, 18);
    }
  }
  /* wordt vanuit de poll aangeroepen: start enkel als het paneel open is en het veld leeg en zonder focus; geen timers in de achtergrond */
  function twCheck() {
    var ov = $('.cl-ph'); if (!ov) return;
    if (!twAllowed()) { if (TW.t || !ov.hidden) twStop(true); return; }
    if (RMQ.matches) { ov.hidden = false; ov.classList.add('static'); var l0 = twList(); ov.firstChild.textContent = l0[0]; return; }
    if (TW.lg !== lang()) { TW.lg = lang(); TW.idx = 0; TW.pos = 0; TW.del = false; }
    if (!TW.t) { if (ov.hidden) { TW.pos = 0; TW.del = false; } TW.t = setTimeout(twStep, ov.hidden ? 300 : 0); }
  }
  document.addEventListener('focusin', function (e) { if (S.on && e.target && e.target.id === 'clTa') twStop(true); });
  document.addEventListener('focusout', function (e) { if (S.on && e.target && e.target.id === 'clTa') setTimeout(twCheck, 0); });
  document.addEventListener('click', function (e) {
    var ov = e.target && e.target.closest && e.target.closest('.cl-ph'); if (!ov || !S.on) return;
    var ta = $('#clTa'); if (!ta) return;
    /* de voorbeeldvraag is enkel een placeholder: klikken zet niets in het veld, enkel focus op een leeg veld */
    twStop(true); ta.focus();
  });
  function taGrow(ta) {
    ta.style.height = 'auto';
    var cs = getComputedStyle(ta), lh = parseFloat(cs.lineHeight) || 20, pad = (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0), max = lh * 3 + pad;
    ta.style.height = Math.min(ta.scrollHeight, max) + 'px'; ta.style.overflowY = ta.scrollHeight > max + 1 ? 'auto' : 'hidden';
  }
  function taSync() {
    var ta = $('#clTa'), ci = $('#cin2'); if (!ta || !ci) return;
    var flat = ta.value.replace(/\n/g, ' ');
    if (ci.value !== flat) { if (document.activeElement !== ta || !ci.value) { ta.value = ci.value; } else return; taGrow(ta); }
  }
  document.addEventListener('input', function (e) {
    var ta = e.target && e.target.id === 'clTa' ? e.target : null; if (!ta) return;
    var ci = $('#cin2'); if (!ci) return;
    ci.value = ta.value.replace(/\n/g, ' '); ci.dispatchEvent(new Event('input', { bubbles: true })); taGrow(ta);
  });
  document.addEventListener('keydown', function (e) {
    var ta = e.target && e.target.id === 'clTa' ? e.target : null; if (!ta || e.isComposing) return;
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (!ta.value.trim()) return;
      var f = $('#cbar2'); if (f) { if (f.requestSubmit) f.requestSubmit(); else { var sb = $('#cdxSend'); if (sb) sb.click(); } }
    }
  });
  document.addEventListener('submit', function (e) {
    if (!S.on || !e.target || e.target.id !== 'cbar2') return;
    setTimeout(function () { var ta = $('#clTa'), ci = $('#cin2'); if (ta && ci) { ta.value = ci.value; taGrow(ta); } }, 0);
  });
  document.addEventListener('focusout', function (e) {
    var q = e.target && e.target.closest && e.target.closest('.cl-stk [data-cl-q]'); if (!q || S.q || q.value) return;
    setTimeout(function () { var sk = $('.cl-stk'); if (sk && !sk.contains(document.activeElement) && !S.q) { sk.classList.remove('s-open'); var sb = $('[data-cl-stks]', sk); if (sb) sb.setAttribute('aria-expanded', 'false'); } }, 0);
  });
  document.addEventListener('focusin', function (e) {
    if (S.on && e.target && e.target.id === 'cin2') { var ta = $('#clTa'); if (ta && desk()) ta.focus(); }
  });
  function fabGet() { try { return localStorage.getItem('cwCleanFabHidden') === '1'; } catch (e) { return false; } }
  function fabSet(v) { try { localStorage.setItem('cwCleanFabHidden', v ? '1' : '0'); } catch (e) { /* negeren */ } }
  function hideFab() {
    if (cdxOpen()) closeCardix();
    var b = document.body; fabSet(true);
    if (RMQ.matches) b.classList.add('cl-fabhid');
    else { b.classList.add('cl-fabout'); setTimeout(function () { b.classList.remove('cl-fabout'); b.classList.add('cl-fabhid'); }, 160); }
    setTimeout(function () { var t = $('.cl-fabtab'); if (t) try { t.focus(); } catch (e) { /* negeren */ } }, RMQ.matches ? 0 : 170);
  }
  function showFab(focus) {
    fabSet(false); var b = document.body; b.classList.remove('cl-fabhid', 'cl-fabout');
    if (focus) { var f = $('.cl-fab'); if (f) try { f.focus(); } catch (e) { /* negeren */ } }
  }
  function closeCardix() { var x = $('#conc [data-close]'); if (x && cdxOpen()) { x.click(); cdxFinish(); cdxOut(); } }
  function toggleCardix() {
    if (cartOpen()) closeCart();
    var was = cdxOpen(), c0 = $('#conc'); if (!was && c0) { clearTimeout(S.outT); c0.classList.remove('cl-out'); }
    var t = $('#cdkTabR'); if (t) { t.click(); cdxFinish(); if (was) cdxOut(); }
  }
  function watchCart() {
    var c = readCart();
    if (S.units === null) { S.units = c.u; return; }
    /* 10 okt (Andrea): de lade opent enkel bij de eerste toevoeging per paginabezoek; daarna niet meer (S.autoDone) */
    /* 11 okt (Andrea): niet na "Alles in mijn mandje" in Samenstellen (html[data-rlc-adding], rip-lab-cadeau.js rond addMany); dan opent het
       mandje enkel via "Bekijk mijn mandje", en blijft de eerste gewone toevoeging het mandje wel openen (S.autoDone blijft dan onaangeroerd) */
    if (c.u > S.units && !S.autoDone && desk() && !cdxOpen() && !$('.sheet.on') && !$('.ov.on') && !document.documentElement.hasAttribute('data-rlc-adding')) {
      S.autoDone = true;
      if (!cartOpen()) openCart(true);
    }
    S.units = c.u;
  }
  function syncFab() {
    if (cdxOpen() && document.body.classList.contains('cl-fabhid')) showFab(false);
    var f = $('.cl-fab'); if (f) f.setAttribute('aria-expanded', cdxOpen() ? 'true' : 'false');
  }


  /* ---------- filters openen (echte panelen): voorkeurenpaneel van de oude bouwer onder de eigen knop, of het Filters-paneel van het raster ---------- */
  function openFilters(anchor) {
    if (mode() === 'feed') {
      var tr = $('#feed [data-cws-prefs-btn]'); if (!tr) return;
      tr.click();
      /* het originele paneel meet de verborgen knop (0 x 0): onder de eigen knop zetten */
      var panel = $('[data-cws-prefs-panel]');
      if (panel && !panel.hidden && panel.style.bottom !== '0px' && innerWidth > 460) {
        var r = anchor.getBoundingClientRect(), w = Math.min(540, innerWidth - 24); panel.style.width = w + 'px';
        var right = Math.max(12, Math.min(Math.round(innerWidth - r.right), innerWidth - w - 12));
        var below = innerHeight - r.bottom - 22;
        panel.style.left = 'auto'; panel.style.right = right + 'px'; panel.style.bottom = '';
        panel.style.top = Math.round(r.bottom + 10) + 'px'; panel.style.maxHeight = Math.max(240, Math.round(below)) + 'px';
      }
      S.fbAnchor = anchor;
    } else {
      var gb = $('#gFiltersBtn'); if (gb) gb.click();
    }
  }

  /* ---------- Rip Lab startstaat (oude bouwer): eerst een startkaart, de selectie pas na een bewuste start ----------
     body.cl-lstart verbergt .cws-mid en .cws-buy (visibility en hoogte 0, de bouwer rekent gewoon door); start = klik op de knop, de slider of een franchisetab.
     Onthouden per sessie (sessionStorage), een nieuw bezoek begint weer met de startkaart. */
  var LSKEY = 'cwCleanLabStart';
  function labStarted() { if (S.lst) return true; try { return sessionStorage.getItem(LSKEY) === '1'; } catch (e) { return false; } }
  function labStart() {
    if (S.lst && !document.body.classList.contains('cl-lstart')) return;
    S.lst = true; try { sessionStorage.setItem(LSKEY, '1'); } catch (e) { /* negeren */ }
    document.body.classList.remove('cl-lstart'); document.body.classList.add('cl-lshow');
    clearTimeout(S.lshT); S.lshT = setTimeout(function () { document.body.classList.remove('cl-lshow'); }, 260);
    fireResize(); setTimeout(fireResize, 60);
  }
  /* CARDIX uit (html.cw-cardix-off, pack.js): de startkaart noemt CARDIX, dus geen kaart en geen startstand (cl-lstart); de bouwer staat meteen open */
  var cdxOff = function () { return document.documentElement.classList.contains('cw-cardix-off'); };
  function labStartSync() {
    var on = S.on && !cdxOff() && builderKind() === 'old' && !labStarted();
    document.body.classList.toggle('cl-lstart', on);
    var inn = $('#feed .cws-in'); if (!inn) return;
    var card = $('.cl-startcard', inn);
    if (on && !card) {
      card = document.createElement('div'); card.className = 'cl-startcard cl-scope';
      card.innerHTML = '<span class="cl-sc-ic">' + ic('spark') + '</span><h3 class="cl-sc-t">Laat CARDIX je box samenstellen</h3>' +
        '<p class="cl-sc-p">Kies je budget en franchise, CARDIX zoekt de beste combinatie uit de voorraad van vandaag.</p>' +
        '<button type="button" class="cl-sc-b" data-cl-lstart>' + ic('spark', 'sm') + '<span>Maak mijn selectie</span></button>';
      var mid = $('.cws-mid', inn); if (mid) inn.insertBefore(card, mid); else inn.appendChild(card);
    }
    if (!on && card) card.remove();
  }
  document.addEventListener('input', function (e) { if (S.on && e.isTrusted && e.target && e.target.hasAttribute && e.target.hasAttribute('data-cws-slider')) labStart(); }, true);
  document.addEventListener('change', function (e) { if (S.on && e.isTrusted && e.target && e.target.hasAttribute && e.target.hasAttribute('data-cws-slider')) labStart(); }, true);
  /* voorkeurenpaneel: de focus gaat terug naar de eigen Filters-knop (de originele knop is verborgen) */
  function fbRefocus() { setTimeout(function () { var b = $('[data-cl-filters]'); var pn = $('[data-cws-prefs-panel]'); if (b && !b.hidden && (!pn || pn.hidden)) b.focus(); }, 30); }
  document.addEventListener('click', function (e) { if (S.on && e.target.closest && e.target.closest('[data-cws-prefs-done],.cws-prefs-backdrop')) fbRefocus(); }, true);
  document.addEventListener('keydown', function (e) { if (S.on && e.key === 'Escape') fbRefocus(); }, true);

  /* ---------- productkiezer-paneel (oude bouwer): het "Voeg toe"-paneel van de bouwer (zoeken, franchise- en soortchips, lijst, plus) staat met CSS als kolom
     rechts in het Rip Lab-kader; de toevoeglogica blijft die van de bouwer (rij klikken = addToManual + updateBasket). Het is geen modal: het mandje mag tegelijk open zijn.
     Hier: de CARDIX-knop verbergt zich zolang het open is (body.cl-addopen), aria-modal gaat uit en de franchise van Rip Lab is de standaard in de chips. ---------- */
  function addSync() {
    var pn = $('[data-cws-add-panel]'), open = !!(pn && !pn.hidden && S.on && document.body.classList.contains('cl-bold'));
    var was = document.body.classList.contains('cl-addopen');
    document.body.classList.toggle('cl-addopen', open);
    if (pn) pn.setAttribute('aria-modal', open ? 'false' : 'true');
    if (open !== was) { var fr0 = $('.cl-labframe'); document.body.style.setProperty('--cl-addw', (fr0 && fr0.getBoundingClientRect().width < 1100 ? 380 : 440) + 'px'); clearTimeout(S.addRz); S.addRz = setTimeout(fireResize, 280); fireResize(); }
    if (open && !was) {
      var cur = $('.cws-seg-franchise3 button[aria-checked="true"],.cws-seg-franchise3 button.cws-on,.cws-seg-franchise3 button[aria-pressed="true"]');
      var nm = cur ? norm(txt(cur)) : '';
      if (nm && nm !== 'alles' && nm !== 'all') {
        var chips = $$('[data-cws-add-fr] .cws-add-chip', pn), hit = chips.filter(function (c) { var cn = norm(c.firstChild && c.firstChild.nodeType === 3 ? c.firstChild.textContent : txt(c)); return cn === nm || cn.indexOf(nm) === 0 || nm.indexOf(cn) === 0 && cn.length > 2; })[0];
        if (hit && hit.getAttribute('aria-pressed') !== 'true') hit.click();
      }
    }
  }

  /* ---------- Ronde 3 (oude bouwer): A. AI-regel in de zijbalk "Voeg toe", B. "Mogelijke hits in jouw box" ----------
     A: de tekst wordt lokaal gelezen (bedrag, franchise, soort, trefwoorden, "af tot X euro") en tegen de catalogus en de PriceDex-topkaarten gelegd;
        toevoegen loopt via de rijen van de bouwer zelf. Serverkant: zie CLEAN-LIVE.md (verzoektype "aanvullen" op cardixai, niet gebouwd).
     B: de topkaarten komen uit TOPCARDS van de pagina (PriceDex-momentopname). Die staat niet op window, dus lezen we hem lui uit de scriptbron
        (inline scripts, anders de gecachete scriptbestanden), eenmalig, met cache. */
  var TOP = { st: 0, d: null, cbs: [] };
  function topParse(txt0) {
    var i = txt0.indexOf('const TOPCARDS = {'); if (i < 0) return null;
    var s = txt0.indexOf('{', i), depth = 0, inStr = false, esc2 = false, j;
    for (j = s; j < txt0.length; j++) {
      var ch = txt0.charAt(j);
      if (inStr) { if (esc2) esc2 = false; else if (ch === '\\') esc2 = true; else if (ch === '"') inStr = false; continue; }
      if (ch === '"') inStr = true; else if (ch === '{') depth++; else if (ch === '}') { depth--; if (!depth) break; }
    }
    try { return JSON.parse(txt0.slice(s, j + 1)); } catch (e) { return null; }
  }
  function topLoad(cb) {
    if (TOP.d) { cb(TOP.d); return; }
    if (TOP.st === 2) { cb(null); return; }
    TOP.cbs.push(cb); if (TOP.st === 1) return; TOP.st = 1;
    var done = function (d) { TOP.d = d; TOP.st = d ? 3 : 2; var l = TOP.cbs; TOP.cbs = []; l.forEach(function (f) { try { f(d); } catch (e) { /* negeren */ } }); };
    try { var w = window.CW_RS_TOPCARDS; if (w && w.sets) { done(w); return; } } catch (e0) { /* negeren */ }
    try {
      var sc = $$('script:not([src])').filter(function (x) { return (x.textContent || '').indexOf('const TOPCARDS = {') > -1; })[0];
      if (sc) { done(topParse(sc.textContent)); return; }
    } catch (e1) { /* negeren */ }
    var srcs = $$('script[src]').map(function (x) { return x.src; }).filter(function (u) { return /cw-rs-test-s\d+\.js/i.test(u); }).sort(function (a, b) { return (/s6\.js/.test(b) ? 1 : 0) - (/s6\.js/.test(a) ? 1 : 0); });
    (function nx(k) {
      if (k >= srcs.length || !window.fetch) { done(null); return; }
      fetch(srcs[k]).then(function (r) { if (!r.ok) throw new Error('http'); return r.text(); }).then(function (t0) { var d = topParse(t0); if (d) done(d); else nx(k + 1); }, function () { nx(k + 1); });
    })(0);
  }
  var eurF = function (n) { try { return new Intl.NumberFormat('nl-BE', { style: 'currency', currency: 'EUR' }).format(n); } catch (e) { return '€ ' + (+n).toFixed(2).replace('.', ','); } };
  var numOf = function (s) { var m = /(\d+(?:[.,]\d+)?)/.exec(String(s || '').replace(/\./g, function (x, o, a) { return /\d\.\d{3}/.test(a.slice(Math.max(0, o - 1), o + 4)) ? '' : '.'; })); return m ? parseFloat(m[1].replace(',', '.')) : 0; };
  function selHandles() {
    var out = [], seen = {};
    $$('#feed .cws-stack-item[data-handle]:not(.cws-add-tile)').forEach(function (it) { var h = it.getAttribute('data-handle'); if (h && !seen[h] && it.getBoundingClientRect().height > 0) { seen[h] = 1; out.push(h); } });
    return out;
  }

  /* ----- A. AI-regel: weg sinds de CARDIX-chat live staat ----- */

  /* ----- B. Mogelijke hits in jouw box ----- */
  function hitsData(top) {
    var rows = [], best = null, n = 0, seenSet = {};
    selHandles().forEach(function (h) {
      var e = entByH(h), key = top && top.products && top.products[h], set = key && top.sets[key];
      if (!e || !set || !set.cards || !set.cards.length) return;
      var cards = set.cards.slice().sort(function (a, b) { return b.pr - a.pr; }).slice(0, 12);
      rows.push({ e: e, cards: cards, key: key });
      if (!seenSet[key]) { seenSet[key] = 1; n += cards.length; }
      if (!best || cards[0].pr > best.pr) best = cards[0];
    });
    return { rows: rows, best: best, n: n };
  }
  function hitsPlace() {
    var f = $('#hitsPanel'); var st = $('.cl-hits'); if (!st || !f || f.hidden) return;
    var r = st.getBoundingClientRect(), maxH = Math.max(220, Math.min(innerHeight * 0.62, r.top - 90));
    f.style.left = Math.round(r.left) + 'px'; f.style.width = Math.round(r.width) + 'px'; f.style.bottom = Math.round(innerHeight - r.top + 8) + 'px'; f.style.maxHeight = Math.round(maxH) + 'px';
  }
  function hitsClose(refocus) { var f = $('#hitsPanel'), b = $('.cl-hits-bar'); if (f && !f.hidden) { f.hidden = true; if (b) { b.setAttribute('aria-expanded', 'false'); if (refocus) b.focus(); } } }
  function hitsSync() {
    var buy = $('#feed .cws-buy'), on = S.on && document.body.classList.contains('cl-bold') && document.body.classList.contains('cl-lab') && !document.body.classList.contains('cl-lstart') && buy;
    var st = $('.cl-hits');
    if (!on) { if (st) st.hidden = true; var f0 = $('#hitsPanel'); if (f0) f0.hidden = true; return; }
    var sig = selHandles().join('|');
    if (!st) {
      st = document.createElement('div'); st.className = 'cl-hits cl-scope'; st.hidden = true;
      st.innerHTML = '<button type="button" class="cl-hits-bar" aria-expanded="false" aria-controls="hitsPanel">' + ic('spark', 'sm') + '<span class="cl-hits-t">Topkaarten uit deze sets</span><span class="cl-hits-c">' + ic('chev', 'sm') + '</span></button>';
      buy.parentNode.insertBefore(st, buy.nextSibling);
      var pnl = $('#hitsPanel') || document.createElement('div'); pnl.id = 'hitsPanel'; pnl.className = 'cl-hitsp cl-scope'; pnl.hidden = true; pnl.setAttribute('role', 'region'); pnl.setAttribute('aria-label', 'Mogelijke hits in jouw box');
      if (!pnl.parentNode) document.body.appendChild(pnl);
    } else if (st.previousSibling !== buy) buy.parentNode.insertBefore(st, buy.nextSibling);
    if (st._sig === sig) { if (!st.hidden) hitsPlace(); return; }
    if (!sig) { st.hidden = true; return; }
    st._sig = sig;
    topLoad(function (top) {
      var d = top ? hitsData(top) : { rows: [] };
      if (!d.rows.length) { st.hidden = true; var f1 = $('#hitsPanel'); if (f1) f1.hidden = true; return; }
      st.hidden = false;
      var pn = $('#hitsPanel');
      pn.innerHTML = '<div class="cl-hp-h"><div><h3>Mogelijke hits in jouw box</h3><p>Niet gegarandeerd in jouw box. Prijzen indicatief via PriceDex.</p></div>' +
        '<button type="button" class="cl-hp-x" data-cl-hitsx aria-label="Sluiten">' + ic('x', 'sm') + '</button></div><div class="cl-hp-b">' +
        d.rows.map(function (r) {
          return '<section class="cl-hp-r"><h4>' + esc(r.e.c.t) + '</h4><div class="cl-hp-cs">' + r.cards.map(function (c) {
            return '<button type="button" class="cl-hp-c" data-cl-pdx="' + esc(c.k || '') + '" title="' + esc(c.n) + '"><span class="cl-hp-im"><img src="' + esc(c.im) + '" alt="" loading="lazy" decoding="async"></span><span class="cl-hp-n">' + esc(c.n) + '</span><span class="cl-hp-p">' + eurF(c.pr) + '</span></button>';
          }).join('') + '</div></section>';
        }).join('') + '</div>';
      hitsPlace();
    });
  }
  document.addEventListener('click', function (e) {
    if (!S.on || S.inReal || !e.target.closest) return;
    var bar = e.target.closest('.cl-hits-bar');
    if (bar) { var f = $('#hitsPanel'); if (!f) return; f.hidden = !f.hidden; bar.setAttribute('aria-expanded', f.hidden ? 'false' : 'true'); if (!f.hidden) hitsPlace(); return; }
    if (e.target.closest('[data-cl-hitsx]')) { hitsClose(true); return; }
    var pc = e.target.closest('[data-cl-pdx]'); if (pc && pc.getAttribute('data-cl-pdx') && window.PDXModal) { window.PDXModal.open(pc.getAttribute('data-cl-pdx')); return; }
    var fo = $('#hitsPanel'); if (fo && !fo.hidden && !e.target.closest('#hitsPanel,.cl-hits')) hitsClose(false);
  }, true);
  document.addEventListener('keydown', function (e) { if (S.on && e.key === 'Escape') { var f = $('#hitsPanel'); if (f && !f.hidden) { e.preventDefault(); e.stopImmediatePropagation(); hitsClose(true); } } }, true);

  /* Rip Lab, oude bouwer, 1 tot 3 kaarten: de kaarten groeien mee met de vrije hoogte van de track (de bouwer houdt een vaste top van 320 px aan).
     CSS-variabele --cl-zh op de track = beschikbare beeldhoogte; bij een wijziging een resize zodat de beeldmaat en het 3D-model opnieuw rekenen. */
  function fitFew() {
    var tr = $('#feed .cws-carousel-track'), on = tr && S.on && document.body.classList.contains('cl-bold') && document.body.classList.contains('cl-lab') && !document.body.classList.contains('cl-lstart');
    if (!tr) return;
    var its = $$('.cws-stack-item[data-handle]:not(.cws-add-tile)', tr).filter(function (i) { return i.offsetHeight > 0; });
    var few = !!on && its.length >= 1 && its.length <= 3, zh = 0;
    if (few) {
      var z0 = $('.cws-stack-imgzone', its[0]), over = its[0].offsetHeight - (z0 ? z0.offsetHeight : 0);
      zh = Math.max(240, Math.min(560, Math.floor(tr.clientHeight - 12 - over - 16)));
    }
    var key = few ? zh : 0;
    if (tr._clzh === key) { tr.classList.toggle('cl-few', few); return; }
    tr._clzh = key; tr.classList.toggle('cl-few', few);
    if (few) tr.style.setProperty('--cl-zh', zh + 'px'); else tr.style.removeProperty('--cl-zh');
    fireResize(); setTimeout(fireResize, 80);
  }

  /* de Tab-focusval van de bouwer houdt het paneel in de pagina niet vast: Tab loopt gewoon door de pagina */
  document.addEventListener('keydown', function (e) {
    if (!S.on || e.key !== 'Tab' || !document.body.classList.contains('cl-addopen') || !e.target.closest) return;
    if (e.target.closest('[data-cws-add-panel]')) e.stopPropagation();
  }, true);
  /* Escape sluit het in-pagina paneel (ook als de focus na een toevoeging op de body staat); het mandje en de hits-lade gaan voor */
  document.addEventListener('keydown', function (e) {
    if (!S.on || e.key !== 'Escape' || e.defaultPrevented || cartOpen() || S.pop) return;
    var h = $('#hitsPanel'); if (h && !h.hidden) return;
    var pn = $('[data-cws-add-panel]'); if (!pn || pn.hidden || !document.body.classList.contains('cl-bold')) return;
    var x = $('[data-cws-add-close]', pn); if (x) { e.preventDefault(); e.stopPropagation(); x.click(); }
  }, true);

  /* ---------- acties ---------- */
  function byAttr(sel, attr, val) { return $$(sel).filter(function (b) { return b.getAttribute(attr) === val; })[0]; }
  function settle() { sync(); clearTimeout(S.t2); S.t2 = setTimeout(sync, 380); }
  function doGrid(act, k) {
    var el;
    if (act === 'gfr') {
      if (k === 'all') el = $('#gFr .g-pill.on'); else el = byAttr('#gFr .g-pill', 'data-gfr', k);
      if (el) el.click();
    } else if (act === 'gcat') {
      el = byAttr('#gChain [data-gcat]', 'data-gcat', k);
      if (el && el.getAttribute('aria-selected') === 'true') { var x = $('#gChain [data-gcatx]'); if (x) x.click(); } else if (el) el.click();
    } else if (act === 'glang') {
      el = byAttr('#gChain [data-glang]', 'data-glang', k);
      if (el && el.getAttribute('aria-selected') === 'true') { var y = $('#gChain [data-glangx]'); if (y) y.click(); } else if (el) el.click();
    }
  }
  /* de pagina zet bij een nieuwe lijst de scrollpositie van het raster op 0: bewaren en terugzetten */
  function keepScroll() { var sc = $('#gScroll'); if (!sc || mode() !== 'all') return; S.keep = { top: gsTop(), until: performance.now() + 600 }; Promise.resolve().then(restoreScroll); }
  function restoreScroll() {
    var k = S.keep, sc = $('#gScroll'); if (!k || !sc) return;
    if (performance.now() > k.until) { S.keep = null; return; }
    if (k.top > 0 && gsTop() < k.top) gsSet(k.top);
  }
  /* grijze keuzes (0 treffers in deze selectie) zijn niet kiesbaar, ook niet met het toetsenbord: de klik stopt hier, voor alle andere handlers */
  window.addEventListener('click', function (e) {
    var z = e.target && e.target.closest ? e.target.closest('.cl-z,.g-z') : null;
    if (z) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);
  function onClick(e) {
    if (S.inReal) return;
    var tg = e.target; if (!tg || !tg.closest) return;
    if (e.isTrusted) S.userAct = true;
    if (S.on && tg.closest('[data-cl-gfr],[data-cl-ggrp],[data-cl-gsub],[data-cl-gpick],[data-cl-langopt],[data-cl-sortopt],[data-cl-rm],[data-cl-ctab]')) keepScroll();
    if (S.on && !tg.closest('.cl-langwrap')) closeLangMenu();
    if (S.on && S.pop && !tg.closest('#clPop,[data-cl-gdd],[data-cl-fbtn],[data-cl-ddbtn],[data-cl-sortbtn],[data-cl-stkf],[data-cl-cattrig],[data-cl-ctab]')) closePop();
    if (S.on && tg.closest('[data-cl-noqp]')) { dsTrack('disc_empty_click', { where: 'clean' }); goMode('lab'); return; }
    if (S.on && tg.closest('[data-cl-noqx]')) { $$('[data-cl-q]').forEach(function (qq) { qq.value = ''; }); clearTimeout(S.qT); setQ(''); return; }
    if (S.on && tg.closest('[data-cl-sclear]')) {
      var qi = tg.closest('.cl-sinner').querySelector('[data-cl-q]'), inStk = !!tg.closest('.cl-stk');
      if (qi) qi.value = ''; clearTimeout(S.qT); setQ('');
      if (inStk) stkSearchClose(true); else if (qi) qi.focus();
      return;
    }
    var sw = tg.closest('[data-cl-c]');
    if (sw) { apply(+sw.getAttribute('data-cl-c')); return; }
    var sv = tg.closest('[data-cl-v]');
    if (sv) { setVariant(sv.getAttribute('data-cl-v')); return; }
    var scv = tg.closest('[data-cl-cv]');
    if (scv) { setCatVariant(scv.getAttribute('data-cl-cv')); return; }
    var smv = tg.closest('[data-cl-m6v]');
    if (smv) { setMap(smv.getAttribute('data-cl-m6v')); return; }
    if (tg.closest('[data-cl-lstart]')) { if (!cdxOff()) labStart(); return; }
    if (S.on && e.isTrusted && document.body.classList.contains('cl-lstart') && tg.closest('[data-cl-fr]')) labStart();
    var smm = tg.closest('[data-cl-m]');
    if (smm) { setModus(smm.getAttribute('data-cl-m')); return; }
    var skz = tg.closest('[data-cl-kies]');
    if (skz) { setKies(skz.getAttribute('data-cl-kies') === '1'); return; }
    if (!S.on) return;
    /* mandje en CARDIX */
    if (tg.closest('[data-cl-pill]')) { if (!desk()) openCartM(); else if (cartOpen()) closeCart(); else openCart(false); return; }
    if (tg.closest('[data-cl-close],[data-cl-scrim]')) { closeCart(); return; }
    if (tg.closest('[data-cl-fabx]')) { hideFab(); return; }
    if (tg.closest('[data-cl-fabtab]')) { showFab(true); return; }
    if (tg.closest('[data-cl-fab]')) { toggleCardix(); return; }
    if (tg.closest('[data-cl-cdxclose]')) { closeCardix(); var fb0 = $('.cl-fab'); if (fb0) fb0.focus(); return; }
    /* de tab Mandje in het CARDIX-paneel: de pagina sluit CARDIX, wij tonen de lade */
    if (tg.closest('#conc [data-side="cart"]') && desk()) { setTimeout(function () { openCart(false); }, 30); return; }
    var t = tg.closest('[data-cl-view],[data-cl-fr],[data-cl-gfr],[data-cl-ggrp],[data-cl-gsub],[data-cl-gdd],[data-cl-ddbtn],[data-cl-stkf],[data-cl-stks],[data-cl-sortbtn],[data-cl-sortopt],[data-cl-gpick],[data-cl-fbtn],[data-cl-back],[data-cl-rm],[data-cl-pricebtn],[data-cl-langbtn],[data-cl-langopt],[data-cl-gq],[data-cl-act],[data-cl-filters],[data-cl-cattrig],[data-cl-ctab]');
    if (!t) return;
    var g = function (a) { return t.getAttribute(a); };
    /* Categorie-bediening (C1, C4, C5): de trigger opent het mega-menu; C2: een groep-tab filtert de groep en opent enkel die kolom */
    if (t.hasAttribute('data-cl-cattrig')) { openPop('cat', '', t); return; }
    if (t.hasAttribute('data-cl-ctab')) {
      var ck = g('data-cl-ctab');
      if (ck === 'all') { S.grp = ''; S.sub = ''; closePop(); applyReal(); settle(); return; }
      if (S.grp !== ck) { S.grp = ck; S.sub = ''; applyReal(); }
      var subs2 = S.M && S.M.gsubs ? S.M.gsubs[ck] || [] : [];
      if (subs2.length > 1) openPop('cat', ck, t); else closePop();
      settle(); return;
    }
    if (t.hasAttribute('data-cl-view')) {
      var want = g('data-cl-view');
      if (e.isTrusted) S.popAt = 0; /* eigen keuze van de bezoeker: niet meer wachten op een popstate (hashSync, popHold) */
      if (want === 'lab' || want === 'chase') {
        /* Samenstellen en Chase zoeken leven in de feedweergave van de pagina. Staat er een productpagina open (feedweergave), dan zou de knop van de
           pagina enkel een pagina terug gaan (pageBack); daarom alle productpagina's in 1 keer dicht (window.pageCloseAll, history.go). De hashwissel
           die volgt mag de oude manier niet terugzetten: de keuze even vasthouden (S.ftHold, zie hashchange) */
        var pgFeed = document.body.classList.contains('pg-open') && mode() !== 'all';
        if (pgFeed && S.ft !== want) S.ftHold = { ft: want, t: performance.now() };
        S.ft = want;
        if (pgFeed && typeof window.pageCloseAll === 'function') { window.pageCloseAll(); closePop(); feedPos(true); chSync(); settle(); return; }
        want = 'feed';
      }
      var vb = $('.viewseg [data-view="' + want + '"]'); if (vb) vb.click();
      closePop(); feedPos(true); chSync(); settle(); return;
    }
    if (t.hasAttribute('data-cl-fr')) {
      var fb = byAttr('#feed .cws-seg-franchise3 button', 'data-franchise3', g('data-cl-fr')); if (fb) fb.click();
      settle(); return;
    }
    if (t.hasAttribute('data-cl-gfr')) { if (S.pop) closePop(); doGrid('gfr', g('data-cl-gfr')); S.grp = ''; S.sub = ''; S.lang = ''; settle(); return; }
    if (t.hasAttribute('data-cl-ggrp')) { var gk = g('data-cl-ggrp'); S.grp = (gk === 'all' || (S.v === 3 && S.grp === gk)) ? '' : gk; S.sub = ''; applyReal(); settle(); return; }
    if (t.hasAttribute('data-cl-gsub')) { var sk = g('data-cl-gsub'); S.sub = (sk === '' || ((S.v === 3 || S.v === 5) && S.sub === sk)) ? '' : sk; applyReal(); settle(); return; }
    if (t.hasAttribute('data-cl-gdd')) { openPop('grp', g('data-cl-gdd'), t.closest('.cl-gi') || t); return; }
    if (t.hasAttribute('data-cl-stkf')) { var ob = $('#gFiltersBtn'); if (ob) ob.click(); placeFP(); return; }
    if (t.hasAttribute('data-cl-stks')) { var sk = $('.cl-stk'); var op = sk.classList.toggle('s-open'); t.setAttribute('aria-expanded', op ? 'true' : 'false'); if (op) { var si = $('.cl-stk [data-cl-q]'); if (si) setTimeout(function () { si.focus(); }, 30); } return; }
    if (t.hasAttribute('data-cl-sortbtn')) { openPop('sort', '', t); return; }
    if (t.hasAttribute('data-cl-sortopt')) { var so = $('#gSort'); if (so) { so.value = g('data-cl-sortopt'); so.dispatchEvent(new Event('change', { bubbles: true })); } closePop(); settle(); return; }
    if (t.hasAttribute('data-cl-ddbtn')) { openPop(g('data-cl-ddbtn'), '', t.closest('.cl-ddw') || t); return; }
    if (t.hasAttribute('data-cl-fbtn')) { openPop('filters', '', t); return; }
    /* eerst applyReal, dan closePop: closePop synct, en zonder toegepaste paginakeuze zou die sync de net gekozen groep of het subtype terugzetten */
    if (t.hasAttribute('data-cl-gpick')) { var pk = g('data-cl-gpick').split('|'); S.grp = pk[0]; S.sub = pk[1] || ''; applyReal(); closePop(); settle(); return; }
    if (t.hasAttribute('data-cl-back')) { S.grp = ''; S.sub = ''; applyReal(); settle(); return; }
    if (t.hasAttribute('data-cl-rm')) {
      var rm = g('data-cl-rm');
      if (rm === 'grp' || rm === 'all') { S.grp = ''; S.sub = ''; } else if (rm === 'sub') S.sub = '';
      if (rm === 'lang' || rm === 'all') S.lang = '';
      applyReal(); if (rm === 'grp' || rm === 'all') closePop(); settle(); return;
    }
    if (t.hasAttribute('data-cl-pricebtn')) { closePop(); var pb = $('#gFiltersBtn'); if (pb) pb.click(); return; }
    if (t.hasAttribute('data-cl-langbtn')) {
      var lm = $('[data-cl-langmenu]'); lm.hidden = !lm.hidden; t.setAttribute('aria-expanded', lm.hidden ? 'false' : 'true'); return;
    }
    if (t.hasAttribute('data-cl-langopt')) { S.lang = g('data-cl-langopt'); S.pickLang = true; closeLangMenu(); applyReal(); if (S.pop && S.pop.kind === 'lang') closePop(); settle(); return; }
    if (t.hasAttribute('data-cl-gq')) {
      var qb = $$('#gFr .g-q button')[+g('data-cl-gq')]; if (qb) qb.click();
      settle(); return;
    }
    if (t.hasAttribute('data-cl-filters')) { openFilters(t); settle(); return; }
    if (t.hasAttribute('data-cl-act')) {
      if (g('data-cl-act') === 'gclear') { var x = $('#gChain [data-gcatx]') || $('#gChain [data-glangx]'); if (x) x.click(); }
      settle(); return;
    }
  }

  /* ---------- zwevend schakelpaneel ---------- */
  function buildSwitch() {
    var sw = document.createElement('div');
    sw.className = 'cl-sw'; sw.setAttribute('role', 'group'); sw.setAttribute('aria-label', 'Layout vergelijken');
    sw.innerHTML = '<b>Layout</b><button type="button" data-cl-c="0">Origineel</button><button type="button" data-cl-c="1">Clean</button><b class="cl-sw-b2">Filters</b>' +
      ['A', 'B', 'C', 'D', 'E'].map(function (n) { return '<button type="button" data-cl-v="' + n + '">' + n + '</button>'; }).join('') +
      '<b class="cl-sw-b2">Categorie</b>' + ['1', '2', '3', '4', '5'].map(function (n) { return '<button type="button" data-cl-cv="' + n + '">' + n + '</button>'; }).join('') +
      '<b class="cl-sw-b2">Kies</b><button type="button" data-cl-kies="1">Aan</button><button type="button" data-cl-kies="0">Uit</button>' +
      '<b class="cl-sw-b2">Modus</b>' + ['0', '1', '2', '3', '4', '5', '6', '7'].map(function (n) { return '<button type="button" data-cl-m="' + n + '">' + n + '</button>'; }).join('') +
      '<b class="cl-sw-b2" data-cl-swmap>Map</b>' + ['A', 'B', 'C'].map(function (n) { return '<button type="button" data-cl-swmap data-cl-m6v="' + n + '">' + n + '</button>'; }).join('');
    document.body.appendChild(sw);
  }
  function updateV() { $$('.cl-sw [data-cl-v]').forEach(function (b) { var on = b.getAttribute('data-cl-v') === S.v; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); }); }
  function updateCV() { $$('.cl-sw [data-cl-cv]').forEach(function (b) { var on = b.getAttribute('data-cl-cv') === S.cv; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); }); }
  function updateM() {
    $$('.cl-sw [data-cl-m]').forEach(function (b) { var on = b.getAttribute('data-cl-m') === S.m; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    $$('.cl-sw [data-cl-m6v]').forEach(function (b) { var on = b.getAttribute('data-cl-m6v') === S.m6v; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    $$('.cl-sw [data-cl-swmap]').forEach(function (el) { el.hidden = S.m !== '6'; });
  }
  function setMap(n) {
    S.m6v = String(n); try { localStorage.setItem(MAPKEY, S.m6v); } catch (e) { /* negeren */ }
    updateM(); vClass(); if (S.on) { sync(); fireResize(); setTimeout(function () { sync(); }, 60); }
  }
  /* modus 2: de wissel hoort in de header (tussen zoekbalk en knoppen); in alle andere modi terug in de Clean-balk */
  function mPlace() {
    var w = $('.cl-mwrap'); if (!w) return;
    var hd = $('.cwh-header__inner'), bar = $('.cats .cl-bar');
    if (S.on && S.m === '2' && hd) { var ics = $('#cwhIcons', hd) || $('.cwh-icons', hd); if (w.parentNode !== hd && ics) hd.insertBefore(w, ics); }
    else if (bar && w.parentNode !== bar) bar.appendChild(w);
  }
  function setModus(n) {
    S.m = String(n); try { localStorage.setItem(MKEY, S.m); } catch (e) { /* negeren */ }
    updateM(); vClass(); mPlace(); if (S.on) { sync(); fireResize(); setTimeout(function () { sync(); }, 60); }
  }
  function updateK() { $$('.cl-sw [data-cl-kies]').forEach(function (b) { var on = (b.getAttribute('data-cl-kies') === '1') === S.kies; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); }); }
  function vClass() {
    'ABCDE'.split('').forEach(function (L) { document.body.classList.toggle('cl-v' + L, S.on && S.v === L); });
    '12345'.split('').forEach(function (n) { document.body.classList.toggle('cl-c' + n, S.on && S.v === 'E' && S.cv === n); });
    document.body.classList.toggle('cl-kies', S.on && kiesOn());
    [document.body, document.documentElement].forEach(function (el) {
      el.classList.toggle('cl-mx', S.on && S.m !== '0');
      '12345678'.split('').forEach(function (n) { el.classList.toggle('cl-m' + n, S.on && S.m === n); });
      'ABC'.split('').forEach(function (L) { el.classList.toggle('cl-m6' + L.toLowerCase(), S.on && S.m === '6' && S.m6v === L); });
    });
  }
  function setKies(on) {
    S.kies = !!on; try { localStorage.setItem(KKEY, S.kies ? '1' : '0'); } catch (e) { /* negeren */ }
    updateK(); vClass(); if (S.on) { closePop(); sync(); }
  }
  function setVariant(n) {
    S.v = String(n); try { localStorage.setItem(VKEY, String(n)); } catch (e) { /* negeren */ }
    updateV(); S.grp = ''; S.sub = ''; S.lang = ''; vClass(); if (S.on) { try { applyReal(); } catch (e) { /* negeren */ } closePop(); ensure(); sync(); }
  }
  /* categorievariant wisselen: het filterblok wordt herbouwd (vKey), de gekozen groep, subtype en taal blijven staan */
  function setCatVariant(n) {
    S.cv = String(n); try { localStorage.setItem(CKEY, S.cv); } catch (e) { /* negeren */ }
    updateCV(); vClass(); if (S.on) { closePop(); ensure(); sync(); }
  }
  function updateSw() { $$('.cl-sw [data-cl-c]').forEach(function (b) { var on = (+b.getAttribute('data-cl-c') === 1) === S.on; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); }); }

  /* ---------- grid-kop: sorteerknop als de Filters-knop, Filters-paneel als dropdown ---------- */
  var stkOn = function () { return document.body.classList.contains('cl-stuck') && mode() === 'all'; };
  function placeFP() {
    if (!desk()) return; /* gsm: het filterpaneel is een onderblad van de pagina zelf */
    var fp = $('#gFilterPanel'), fb = $('#gFiltersBtn'); if (!fp || !fb || fb.getAttribute('aria-expanded') !== 'true') return;
    var anc = stkOn() ? $('[data-cl-stkf]') : fb, r = (anc || fb).getBoundingClientRect(), w = fp.offsetWidth || 380;
    fp.style.left = Math.round(Math.min(Math.max(16, r.right - w), innerWidth - w - 16)) + 'px'; fp.style.right = 'auto';
    fp.style.top = Math.round(r.bottom + 8) + 'px'; fp.style.maxHeight = Math.max(240, Math.round(innerHeight - r.bottom - 24)) + 'px';
    fp.classList.add('cl-placed');
  }
  function ctlBack() {
    var c = $('.cl-all .g-ctl'), top = $('#gCard .g-top');
    if (c && top) top.appendChild(c);
  }
  /* afstand vanaf de bovenrand van het raster waarop de filterkaart als 'weg' telt: standaard 72 px (modus 8: 78 px, de rij is 52 px); in modus 6 en 7 de onderrand van de
     (hogere) keuzerij, anders verdwijnt de filterkaart al onder die rij zonder dat de sticky balk komt */
  function stkOff() { return S.m === '6' ? 116 : S.m === '7' ? 98 : S.m === '8' ? 78 : 72; }
  /* ---------- sticky filterbalk: schuift in zodra de filterkaart uit beeld is ---------- */
  function stkWatch() {
    var all = $('.cl-all'), root = $('#gScroll'), stk = $('.cl-stk'); if (!all || !root || !stk) return;
    /* cl-flow: het venster is de root; de bovenrand van het rastervlak is dan de kopbalk (--hdr), dus die zit in de marge (en in de sleutel) */
    var fl = flowOn(), key = stkOff() + '|' + (fl ? 'f' + cssPx('--hdr') : 'g');
    if (S.stkIO && S.stkEl === all && S.stkOffNow === key) return;
    if (S.stkIO) S.stkIO.disconnect();
    S.stkEl = all;
    if (!('IntersectionObserver' in window)) { S.stkIO = null; return; }
    S.stkIO = new IntersectionObserver(function (es) {
      var en = es[es.length - 1], rb = en.rootBounds, st = !en.isIntersecting && rb && en.boundingClientRect.bottom <= rb.top + 1;
      setStuck(!!st);
    }, { root: fl ? null : root, threshold: 0, rootMargin: '-' + (stkOff() + (fl ? cssPx('--hdr') : 0)) + 'px 0px 0px 0px' });
    S.stkOffNow = key;
    S.stkIO.observe(all);
  }
  function setStuck(on) {
    var b = document.body; if (b.classList.contains('cl-stuck') === on) return;
    if (S.pop) closePop();
    var fb = $('#gFiltersBtn'); if (fb && fb.getAttribute('aria-expanded') === 'true') fb.click();
    b.classList.toggle('cl-stuck', on);
  }
  function stkSync() {
    var stk = $('.cl-stk'); if (!stk) return;
    /* product open (productweergave of -blad): balk en strook zijn via CSS al weg; open dropdowns en het Filters-paneel sluiten */
    if (document.body.classList.contains('pg-open') || $('#pdpSheet.on')) { if (S.pop) closePop(); var fo = $('#gFiltersBtn'); if (fo && fo.getAttribute('aria-expanded') === 'true') fo.click(); }
    if (mode() !== 'all' && document.body.classList.contains('cl-stuck')) document.body.classList.remove('cl-stuck');
    if (S.q && !stk.classList.contains('s-open')) { stk.classList.add('s-open'); var sb = $('[data-cl-stks]', stk); if (sb) sb.setAttribute('aria-expanded', 'true'); }
    var ob = $('#gFiltersBtn'), fb = $('[data-cl-stkf]', stk);
    if (ob && fb) {
      fb.setAttribute('aria-expanded', ob.getAttribute('aria-expanded') || 'false');
      var bd = $('[data-cl-stkb]', fb), fc = $('#gFCount'), n = fc && !fc.hidden ? txt(fc) : '';
      if (bd) { bd.textContent = n; bd.hidden = !n; }
    }
    var cv = shownView();
    $$('.cl-stk-v button', stk).forEach(function (b) {
      var v = b.getAttribute('data-cl-view'), on = v === cv; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (b.getAttribute('aria-label') !== modiN(v)) { b.setAttribute('aria-label', modiN(v)); b.setAttribute('data-tip', modiN(v)); var vl = $('.cl-stk-vl', b); if (vl) vl.textContent = modiN(v); }
    });
    var sv = $('.cl-stk-v', stk); if (sv) placeInd(sv);
    /* de pagina wil de scrollpositie van het raster na Terug herstellen, maar zet ze terwijl het raster nog verborgen is (werkt niet):
       onthouden zolang het raster zichtbaar is en na sluiten van het product zelf terugzetten */
    var pgNow = document.body.classList.contains('pg-open') || !!$('#pdpSheet.on'), gsc = $('#gScroll');
    if (gsc && mode() === 'all') {
      /* cl-flow: de scrollpositie is die van het venster; tijdens de productpagina staat de pagina vast (body overflow hidden, css), dus ze blijft */
      var gy = gsTop();
      if (!pgNow && !S.pgWas) S.gTop = gy;
      if (S.pgWas && !pgNow) { if (Math.abs(gy - (S.gTop || 0)) > 2) gsSet(S.gTop || 0); }
    }
    /* productpagina open/dicht: de indicator (enkel in andere modi zichtbaar) zonder animatie meteen op de nieuwe plek zetten (geen sprong) */
    /* productpagina opent terwijl de mandjelade open staat (data-info, openFromCart): lade dicht, zodat de pagina niet verdoezeld achter de scrim opent */
    if (pgNow && !S.pgWas && cartOpen() && desk()) closeCart();
    if (!!S.pgWas !== pgNow) $$('.cl-mseg').forEach(function (h) { h._indReady = false; placeInd(h); });
    S.pgWas = pgNow; try { dkSlide(); } catch (er) { /* negeren */ }
    /* na sluiten van een product geeft de IntersectionObserver geen nieuwe melding (de toestand veranderde niet): controleer handmatig */
    if (mode() === 'all' && !document.body.classList.contains('pg-open') && !$('#pdpSheet.on')) {
      var al = $('.cl-all'), rt = $('#gScroll');
      if (al && rt) { var ar = al.getBoundingClientRect(), rr = rt.getBoundingClientRect(); if ((flowOn() || rr.height > 50) && ar.height > 0) setStuck(ar.bottom <= gsRootTop() + stkOff()); }
    }
    stkFit(stk);
    stkWatch();
  }
  /* geen franchise-tab halverwege afkappen: passen de tabs niet, dan wordt het de compacte knop "Franchise ▾" */
  function stkFit(stk) {
    if (!document.body.classList.contains('cl-stuck')) return;
    var ut = $('.cl-utabs', stk); if (!ut) return;
    var compact = stk.classList.contains('cl-stk-c');
    if (!compact) S.stkTW = ut.scrollWidth;
    if (!S.stkTW) return;
    var cs = getComputedStyle(stk), inner = stk.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0), used = 0, n = 0;
    Array.prototype.forEach.call(stk.children, function (c) {
      if (c === ut || c.classList.contains('cl-stk-sp') || c.classList.contains('cl-stk-frdd')) return;
      var r = c.getBoundingClientRect(); if (r.width < 1) return; used += r.width; n++;
    });
    var need = S.stkTW + used + (n + 2) * 8 + 8;
    var want = need > inner;
    if (want !== compact) stk.classList.toggle('cl-stk-c', want);
    /* modus 7: de wissel heeft labels; past hij zelfs compact niet (smalle inhoud met open streamkolom), dan enkel iconen */
    if (S.m === '7') {
      stk.classList.remove('cl-stk-nl');
      var sv = $('.cl-stk-v', stk);
      if (sv && want && sv.getBoundingClientRect().right > stk.getBoundingClientRect().right - (parseFloat(cs.paddingRight) || 0) + 1) stk.classList.add('cl-stk-nl');
    }
  }
  /* ---------- streamkolom: lipje volgt de livestatus, kolom open (live) of dicht (offline), 4 of 5 tegels per rij ----------
     Status = de klassen die de pagina zelf zet (cw-liveq-known, cw-is-offline). Tot de status bekend is staat de kolom via CSS
     (html zonder cl-colk) ingeklapt als veilige start, zonder animatie; is hij bekend, dan beslist Clean via de eigen knoppen van de
     pagina (#colLToggle, #colLTab) en zet html.cl-colk. Een handmatige klik van de bezoeker blijft gelden tot de volgende statuswissel.
     Bij elke wissel (4 of 5 tegels per rij) blijft de bovenste zichtbare tegel in beeld (colKeep). Vangnet: blijft de status 8 s
     onbekend, dan de stand van de pagina zelf (open) zonder te beslissen. */
  /* status: '' = nog niet bekend, 'err' = de poll faalt (body.cw-liveq-err, gezet door de pagina) = onbekend, anders 'off' of 'live' */
  function liveStatus() { var b = document.body.classList; if (b.contains('cw-liveq-err')) return 'err'; return b.contains('cw-liveq-known') ? (b.contains('cw-is-offline') ? 'off' : 'live') : ''; }
  /* modus 8: het live-vak (smal eerste vak in de schakelaar, desktop) en het vierde item in de gsm-balk. Bron: de status die de pagina zelf bijhoudt
     (liveStatus: body.cw-liveq-known / cw-is-offline uit de bestaande stream-poll), dus geen eigen poll. Klik = de bestaande LIVE-ingang van de kopbalk
     (#cwhLive). Voorbeeldstand ("Voorbeeld: live", localStorage cl-live-demo): toont enkel de weergave van het vak, de pagina zelf blijft ongemoeid
     (colSync, speler en tabs lezen nog altijd liveStatus). */
  var DEMOKEY = 'cl-live-demo';
  /* 15 okt (Andrea: "doe die Voorbeeld: live weg"): geen voorbeeldstand meer; de schakelaar wordt niet meer gebouwd */
  var demoOn = function () { return false; };
  var liveReal = function () { return liveStatus() === 'live'; };
  var liveWant = function () { return liveReal() || demoOn(); };
  function liveSync() {
    var on = liveWant();
    /* 15 okt: de voorbeeldstand laat ook het live-bolletje op gsm zien (testen terwijl we offline zijn), zie style.css html.cl-live-demo */
    var dm = demoOn(), he = document.documentElement; if (he.classList.contains('cl-live-demo') !== dm) he.classList.toggle('cl-live-demo', dm);
    var hb = $('.cats .cl-bar');
    var cell = $('.cats [data-cl-live]');
    if (cell && cell.hidden === on) {
      /* de knop staat los van de tabs (rechts in de rij): de tabs blijven staan, enkel de knop zelf komt zacht binnen */
      if (hb && hb.classList.contains('cl-hl') !== on) hb.classList.toggle('cl-hl', on);
      cell.hidden = !on;
      if (on && !RMQ.matches && cell.animate && cell.offsetWidth) cell.animate([{ opacity: 0, transform: 'translateX(10px) scale(.94)' }, { opacity: 1, transform: 'none' }], { duration: 420, easing: 'cubic-bezier(.34,1.32,.5,1)' });
    }
    if (typeof MB !== 'undefined' && MB && MB.el) {
      /* gsm-balk: geen "Nu live"-knop meer (Andrea 15 okt), het LIVE-lipje rechts opent de stream; de balk houdt altijd drie manieren */
      var mi = $('[data-cl-mv="live"]', MB.el); if (mi && !mi.hidden) mi.hidden = true;
      if (MB.el.classList.contains('has-live')) MB.el.classList.remove('has-live');
    }
  }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[data-cl-live],[data-cl-mv="live"]'); if (!t) return;
    /* 15 okt (Andrea: "deze knop moet volledig de fullscreen openen"): meteen het grote streamscherm (desktop en gsm), ook bij een dichte kolom
       en offline (dan met de offline-staat); de oude routes hieronder enkel als de pagina die haak (nog) niet heeft */
    if (typeof window.cwOpenStream === 'function') { window.cwOpenStream(); return; }
    /* desktop: de linker streamkolom open of dicht (ook in de voorbeeldstand), als handmatige keuze tot de volgende statuswissel */
    if (desk() && $('#colLTab')) { S.colManual = true; colSet(document.body.classList.contains('colL-hidden') ? 'open' : 'hidden'); return; }
    if (!liveReal()) return; /* gsm in de voorbeeldstand zonder echte stream: er is niets om naartoe te gaan */
    var h = $('#cwhLive') || $('#colLTab'); if (h) h.click();
  });
  /* de voorbeeldknop: enkel op deze testpagina, want enkel hier wordt Clean zo geladen. Desktop: vast linksonder. Gsm: als klein schakelaartje vooraan
     in de iconenrij van de kopbalk (#cwhIcons), zodat hij nooit over inhoud of knoppen ligt; zonder kopbalk een klein knopje linksonder (zie css). */
  function demoInit() {
    if ($('.cl-demo') || !document.body) return;
    var l = document.createElement('label'); l.className = 'cl-demo';
    l.innerHTML = '<input type="checkbox" class="cl-demo-i"><span class="cl-demo-tg" aria-hidden="true"></span><span class="cl-demo-t">Voorbeeld: live</span>';
    var i = $('input', l); i.checked = demoOn(); i.setAttribute('aria-label', 'Voorbeeld: live');
    i.addEventListener('change', function () {
      try { localStorage.setItem(DEMOKEY, i.checked ? '1' : '0'); } catch (er) { /* negeren */ }
      liveSync(); if (MB.el) mbSync();
    });
    document.body.appendChild(l);
    demoPlace();
  }
  function demoPlace() {
    var l = $('.cl-demo'); if (!l) return;
    var box = desk() ? null : ($('#cwhIcons') || $('.cwh-icons'));
    if (box) { if (l.parentNode !== box || box.firstChild !== l) box.insertBefore(l, box.firstChild); }
    else if (l.parentNode !== document.body) document.body.appendChild(l);
    if (l.classList.contains('cl-demo-hdr') !== !!box) l.classList.toggle('cl-demo-hdr', !!box);
    if (l.title !== 'Voorbeeld: live') l.title = 'Voorbeeld: live';
  }
  /* wissel tussen desktop en gsm (10 okt): Clean bouwt zijn filterkaart, sorteerknop en CARDIX-invoerveld op desktop; onder 1100 px staat tick() stil,
     dus die stukken zijn daar niet bijgewerkt. Ze zijn via CSS verborgen onder 1100 px; hier de verhuisde originelen terug op hun plek zetten,
     zodat de gsm exact de pagina zelf toont: sorteren en Filters terug in de kop van de filterkaart, het Filters-paneel zonder de inline plaatsing
     van de desktopdropdown (op gsm is het een blad onderaan), het originele CARDIX-invoerveld weer bereikbaar, open dropdowns dicht.
     Op desktop zet tick() (gridChrome) alles vanzelf terug. */
  function vpSync() {
    var d = desk(), ci = $('#cin2');
    if (ci && $('#clTa')) {
      if (d) { if (ci.tabIndex !== -1) ci.tabIndex = -1; if (ci.getAttribute('aria-hidden') !== 'true') ci.setAttribute('aria-hidden', 'true'); }
      else { if (ci.hasAttribute('tabindex')) ci.removeAttribute('tabindex'); if (ci.hasAttribute('aria-hidden')) ci.removeAttribute('aria-hidden'); }
    }
    if (d) { try { mqsUnwrap(); } catch (er) { /* negeren */ } }
    if (!d) {
      ctlBack(); closePop(); closeLangMenu();
      var fp = $('#gFilterPanel'); if (fp) { ['left', 'right', 'top', 'maxHeight'].forEach(function (k) { fp.style[k] = ''; }); fp.classList.remove('cl-placed'); }
      document.body.classList.remove('cl-stuck');
    }
    demoPlace();
  }
  function lipSync(st) {
    var tab = $('#colLTab'); if (!tab) return;
    var off = st === 'off', err = st === 'err';
    if (tab.classList.contains('off') !== off) tab.classList.toggle('off', off);
    if (tab.classList.contains('err') !== err) tab.classList.toggle('err', err);
    var l = $('.lbl', tab), want = err ? 'RIP & SHIP' : off ? 'OFFLINE' : 'LIVE'; if (l && l.textContent !== want) l.textContent = want;
  }
  function colKeep() {
    var sc = $('#gScroll'); if (!sc || mode() !== 'all') return null;
    var top = gsRootTop(), tiles = $$('#gGrid .tile:not(.cl-gh)'), t = null;
    /* anker = de middelste tegel van de bovenste rij die minstens half in beeld is: bij 4 naar 5 (of terug) blijft die tegel in
       dezelfde rij, zodat de rij waar de bezoeker naar kijkt niet verticaal verspringt (de eerste tegel van een rij kan de laatste
       van de vorige rij worden) */
    var i0 = -1;
    for (var i = 0; i < tiles.length; i++) { var r = tiles[i].getBoundingClientRect(); if (r.bottom > top + Math.min(r.height / 2, 160)) { i0 = i; break; } }
    if (i0 < 0) return null;
    var y0 = tiles[i0].offsetTop, rowT = [];
    for (var j = i0; j < tiles.length && Math.abs(tiles[j].offsetTop - y0) < 2; j++) rowT.push(tiles[j]);
    t = rowT[Math.floor((rowT.length - 1) / 2)] || tiles[i0];
    var off = t.getBoundingClientRect().top - top;
    return function () { if (!t.isConnected) return; var d = (t.getBoundingClientRect().top - gsRootTop()) - off; if (Math.abs(d) > 1) gsBy(d); };
  }
  function colSet(want) {
    var hidden = document.body.classList.contains('colL-hidden');
    if ((want === 'hidden') === hidden) return;
    var btn = want === 'hidden' ? $('#colLToggle') : $('#colLTab'); if (btn) btn.click();
  }
  /* live-pil: aria-expanded volgt de streamkolom (zoals #colLTab), aria-controls idem */
  function liveAria() {
    var lc = $('[data-cl-live]'); if (!lc) return;
    if (typeof window.cwOpenStream === 'function') {
      /* de knop opent een dialoog (het streamscherm), geen uitklapbare kolom */
      if (lc.getAttribute('aria-haspopup') !== 'dialog') { lc.setAttribute('aria-haspopup', 'dialog'); lc.removeAttribute('aria-expanded'); lc.removeAttribute('aria-controls'); }
      return;
    }
    var ex = document.body.classList.contains('colL-hidden') ? 'false' : 'true';
    if (lc.getAttribute('aria-expanded') !== ex) lc.setAttribute('aria-expanded', ex);
    if (!lc.hasAttribute('aria-controls')) lc.setAttribute('aria-controls', 'colLToggle');
  }
  function colSync() {
    var st = liveStatus(); lipSync(st); liveAria();
    var h = document.documentElement;
    if (!st) { if (!S.colT0) S.colT0 = performance.now(); else if (performance.now() - S.colT0 > 8000 && !h.classList.contains('cl-colk')) h.classList.add('cl-colk'); return; }
    if (st === 'err') {
      /* poll faalt: nog geen geldige status gehad = ingeklapt in de echte paginastand (zodat een klik van de bezoeker gewoon werkt);
         was er al een geldige status, dan niets wisselen tot er weer een is */
      if (!S.colSt && !h.classList.contains('cl-colk')) { document.body.classList.add('colL-instant'); colSet('hidden'); requestAnimationFrame(function () { requestAnimationFrame(function () { document.body.classList.remove('colL-instant'); }); }); }
      if (!h.classList.contains('cl-colk')) h.classList.add('cl-colk');
      return;
    }
    if (st !== S.colSt) {
      /* 16 okt (Andrea: bij refresh schoof het lipje los van de rand met een kier): de eerste stand na het laden zonder animatie */
      var eerste = !S.colSt, b = document.body; S.colSt = st; S.colManual = false;
      if (eerste) b.classList.add('colL-instant');
      colSet(st === 'live' ? 'open' : 'hidden');
      if (eerste) requestAnimationFrame(function () { requestAnimationFrame(function () { b.classList.remove('colL-instant'); }); });
    }
    if (!h.classList.contains('cl-colk')) h.classList.add('cl-colk');
  }
  /* de knoppen van de pagina: voor de wissel de bovenste tegel onthouden (capture), erna terugzetten (bubble); een echte klik = handmatige keuze */
  document.addEventListener('click', function (e) {
    if (!S.on || !desk() || !e.target || !e.target.closest || !e.target.closest('#colLToggle,#colLTab')) return;
    S.colRestore = colKeep(); if (e.isTrusted) S.colManual = true;
  }, true);
  document.addEventListener('click', function (e) {
    if (!S.on || !S.colRestore || !e.target || !e.target.closest || !e.target.closest('#colLToggle,#colLTab')) return;
    var r = S.colRestore; S.colRestore = null; r(); requestAnimationFrame(r);
    if (S.pop) closePop(); placeFP();
  });
  function gridChrome() {
    /* Filters en sorteren verhuizen naar de rechterkant van de filterregel (niet bij variant D: daar staat de kruimel in de kop) */
    var rowC = $('.cl-all [data-cl-grprow]'), ctlC = $('#gCard .g-ctl');
    if (rowC && ctlC && S.v !== 'D' && ctlC.parentNode !== rowC) rowC.appendChild(ctlC);
    var ctl = $('#gCard .g-ctl'), sel = $('#gSort');
    if (ctl && sel && !$('[data-cl-sortbtn]', ctl)) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'g-filters-btn cl-sortbtn'; b.setAttribute('data-cl-sortbtn', '');
      b.setAttribute('aria-haspopup', 'menu'); b.setAttribute('aria-expanded', 'false');
      ctl.insertBefore(b, sel);
    }
    if (sel) $$('[data-cl-sortbtn]').forEach(function (sb) {
      var o = sel.options[sel.selectedIndex], h = ic('sort', 'sm') + '<span>' + esc(o ? o.textContent : '') + '</span>' + ic('chev', 'xs');
      if (sb._h !== h) { sb._h = h; sb.innerHTML = h; }
      sb.setAttribute('aria-expanded', S.pop && S.pop.kind === 'sort' ? 'true' : 'false');
    });
    /* Filters-paneel: de originele elementen blijven staan (de pagina bedient ze), enkel geplaatst als dropdown onder de knop */
    var fp = $('#gFilterPanel'), fb = $('#gFiltersBtn');
    if (fp && fb) {
      $$('.gf-sec:not(.cl-sortsec)', fp).forEach(function (d) { if (!d.open) d.open = true; });
      var cl = $('#gfClearAll'); if (cl && cl.textContent !== 'Wis filters') cl.textContent = 'Wis filters';
      /* het paneel hangt aan body (anders is position:fixed relatief aan een getransformeerde ouder) */
      if (fp.parentNode !== document.body) { fp._clP = fp.parentNode; fp._clN = fp.nextSibling; document.body.appendChild(fp); }
      /* prijs: de pagina zelf toont de twee bedragen (#gfPriceVal: min links, max rechts, live), Clean laat ze staan */
      if (fb.getAttribute('aria-expanded') === 'true') {
        placeFP();
        var sec = $('.gf-sec:not(.cl-sortsec)', fp), ind = $('.cl-gfind', sec), act = $('#gAvBody .g-pill.on', fp);
        if (!ind && sec) { ind = document.createElement('span'); ind.className = 'cl-ind cl-gfind'; ind.setAttribute('aria-hidden', 'true'); sec.appendChild(ind); }
        if (ind && act) {
          var sr = sec.getBoundingClientRect(), ar = act.getBoundingClientRect();
          if (!ind._r) { ind.style.transition = 'none'; }
          ind.style.width = ar.width + 'px'; ind.style.transform = 'translate(' + Math.round(ar.left - sr.left) + 'px,' + Math.round(ar.bottom - sr.top - 4) + 'px)';
          if (!ind._r) { void ind.offsetWidth; ind.style.transition = ''; ind._r = true; }
        }
      } else { var ii = $('.cl-gfind', fp); if (ii) ii._r = false; fp.classList.remove('cl-placed'); }
    }
  }
  document.addEventListener('click', function (e) {
    if (!S.on || S.inReal) return;
    placeFP(); /* direct na het openen door de pagina, nog voor het eerste getekende frame */
    var fb = $('#gFiltersBtn'), fp = $('#gFilterPanel');
    if (fb && fp && fb.getAttribute('aria-expanded') === 'true' && !e.target.closest('#gFilterPanel,#gFiltersBtn,[data-cl-stkf],[data-cl-mqf]')) fb.click();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !S.on) return;
    var fb = $('#gFiltersBtn'); if (fb && fb.getAttribute('aria-expanded') === 'true') setTimeout(function () { try { fb.focus(); } catch (er) { /* negeren */ } }, 0);
  });

  /* ---------- 3D bij hover op de tegels van Alle producten ----------
     De rastertegels tonen enkel een stilstaand beeld; de pagina heeft wel 3D-modellen (Stage3D, globale buildStage3D)
     voor de producten in M3D en de gecureerde dozen met faces. Eigen productobjecten worden hier uit dezelfde data
     opgebouwd (zelfde regels als applyM3D van de pagina). Eerst 1 gedeelde Stage3D-instantie (1 WebGL-context),
     lazy bij de eerste hover, enkel de gehoverde tegel; geen model = tegel blijft ongemoeid. */
  var H3 = { mh: null, mbusy: false, tEnter: 0, ms: [], lastMove: 0, F: { rx: 0, ry: 0, dx: 0, dy: 0 }, tx: 0, ty: 0, cx: 0, cy: 0, wob: 0, mode: 'play', t0: 0, t1: 0, from: 0, rect: {}, busy: false, pt: 0, done: 0, rel: null, warm: false, io: null, pfn: 0, pf: {}, inst: null, fail: false, tile: null, timer: 0, gen: 0, raf: 0, el: null, plate: null, ent: null, cache: {}, byT: null, meta: undefined, lastScroll: 0 };
  var RMQ = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  function h3Ent(title) {
    var P = loadP(); if (!P) return null;
    if (!H3.byT) { H3.byT = {}; P.forEach(function (e) { if (!(e.t in H3.byT)) H3.byT[e.t] = e; }); }
    return H3.byT[title] || null;
  }
  function h3Meta() {
    if (H3.meta === undefined) { try { H3.meta = JSON.parse($('#cut-meta').textContent); } catch (e) { H3.meta = null; } }
    return H3.meta;
  }
  function h3Build(e) {
    var c = e.c, h = c.h; if (h in H3.cache) return H3.cache[h];
    var m = S.M3D && S.M3D[h], p = null, f = c.faces;
    if (f && f.front && (f.side || f.top)) p = { h: h, f: c.f || null, faces: f, pose3d: c.pose3d || null };
    else if (m && m.faces && m.faces.front && (m.faces.side || m.faces.top)) p = { h: h, f: c.f || m.f || null, faces: m.faces, pose3d: m.pose3d || null };
    else if (m && (m.s === 'pack' || m.s === 'flat')) p = { h: h, f: c.f || null, mode: 'pack', bulge: m.bulge || 0 };
    else if (m && m.s === 'box' && m.fbox) p = { h: h, f: c.f || null, mode: 'fbox', fbox: m.fbox };
    if (p) { var cm = h3Meta(), mm = cm && cm[h]; if (mm && mm.bb) p.cbb = mm.bb; p.curated = e.nm === 'CATALOG'; }
    H3.cache[h] = p; return p;
  }
  function h3Rect(plate, p) {
    var W = plate.clientWidth, Hh = plate.clientHeight; if (W < 5 || Hh < 5) return null;
    var cm = h3Meta(), mm = cm && cm[p.h];
    if (p.curated && mm && mm.bb && mm.ar > 0) {
      var iw, ih; if (W / Hh > mm.ar) { ih = Hh; iw = Hh * mm.ar; } else { iw = W; ih = W / mm.ar; }
      var ox = (W - iw) / 2, oy = (Hh - ih) / 2;
      return { x: ox + mm.bb[0] * iw, y: oy + mm.bb[1] * ih, w: (mm.bb[2] - mm.bb[0]) * iw, h: (mm.bb[3] - mm.bb[1]) * ih };
    }
    return { x: W * .12, y: Hh * .1, w: W * .76, h: Hh * .8 };
  }
  function h3Badges() {
    if (!loadP()) return;
    $$('#gGrid .tile').forEach(function (t) {
      if (t._cl3 !== undefined) return;
      var e = h3Ent(norm(txt($('.t-title', t)))), p = e && h3Build(e);
      t._cl3 = !!p; if (p && H3.io) H3.io.observe(t);
      if (p && !$('.cl-3dh', t)) { var b = document.createElement('span'); b.className = 'cl-3dh'; b.textContent = '3D'; b.setAttribute('aria-hidden', 'true'); t.appendChild(b); }
    });
  }
  function h3Init() {
    if (H3.inst) return true;
    if (H3.fail || !window.THREE || !window.buildStage3D) return false;
    try { var i = window.buildStage3D(); if (!i.init()) { H3.fail = true; return false; } H3.inst = i; return true; } catch (e) { H3.fail = true; return false; }
  }
  var h3Key = function (p, W) { return p.h + '|' + W; };
  /* textures vooraf decoderen: de bouw van het model hoeft dan niet meer op netwerk of decode te wachten */
  function h3Decode(p) {
    if (H3.pf['i' + p.h]) return; H3.pf['i' + p.h] = 1;
    try { var im = new Image(); im.decoding = 'async'; var cu0 = cutUrl(p.h); if (!cu0) return; im.src = cu0; if (im.decode) im.decode().catch(function () { /* negeren */ }); } catch (e) { /* negeren */ }
  }
  function h3Prefetch(tile) {
    if (!H3.inst || !tile || tile._cl3 === false) return;
    var e = h3Ent(norm(txt($('.t-title', tile)))), p = e && h3Build(e);
    if (!p) return; h3Decode(p);
    try { H3.inst.prefetch(p); } catch (er) { /* negeren */ }
  }
  /* de tegel onder de cursor en de buren (links, rechts, onder, boven) alvast opbouwen; de cache van de viewer is 5 groot */
  function h3Neighbors(tile) {
    var list = $$('#gGrid .tile').filter(function (t) { return t.offsetParent !== null; }), i = list.indexOf(tile); if (i < 0) return;
    var cols = 1, top0 = list[0].offsetTop; while (cols < list.length && list[cols].offsetTop === top0) cols++;
    [0, 1, -1, cols, -cols].forEach(function (d) { var t = list[i + d]; if (t) h3Prefetch(t); });
  }
  /* framing-rect vooraf meten bij idle: tegels in beeld en een scherm eronder, dichtst bij het midden eerst, een voor een;
     pauzeert bij hover, muisbeweging en scrollen. Bewaard wordt enkel de rect per product + breedte. */
  function h3Pump() {
    if (H3.mbusy || !S.on || mode() !== 'all' || H3.fail || !H3.inst) return;
    var now = performance.now();
    if (H3.tile || H3.rel || now - H3.lastScroll < 300 || now - H3.lastMove < 300) return;
    var vh = innerHeight, mid = vh / 2, best = null, bd = 1e9;
    $$('#gGrid .tile').forEach(function (t) {
      if (!t._cl3 || t._clm) return;
      var plate = $('.plate', t); if (!plate || plate.clientWidth < 20) return;
      var r = t.getBoundingClientRect(); if (r.bottom < 0 || r.top > vh * 2) return;
      var e = h3Ent(norm(txt($('.t-title', t)))), p = e && h3Build(e); if (!p || (h3Key(p, plate.clientWidth) in H3.rect)) { t._clm = true; return; }
      var d = Math.abs((r.top + r.bottom) / 2 - mid) + (r.top > vh ? 400 : 0);
      if (d < bd) { bd = d; best = t; }
    });
    if (!best) return;
    var tile = best, plate = $('.plate', tile), e2 = h3Ent(norm(txt($('.t-title', tile)))), p2 = h3Build(e2), W = plate.clientWidth, Hh = plate.clientHeight, key = h3Key(p2, W);
    if (!H3.mh) { H3.mh = document.createElement('div'); H3.mh.setAttribute('aria-hidden', 'true'); H3.mh.style.cssText = 'position:fixed;left:-10000px;top:0;visibility:hidden;pointer-events:none'; document.body.appendChild(H3.mh); }
    H3.mh.style.width = W + 'px'; H3.mh.style.height = Hh + 'px';
    H3.mbusy = true; h3Decode(p2);
    var done = function (rect) {
      H3.mbusy = false;
      if (rect) { H3.rect[key] = rect; tile._clm = true; }
      try { if (!H3.rel) { H3.inst.detach(); H3.inst.pause(true); } } catch (er) { /* negeren */ }
    };
    try { H3.inst.follow(null); H3.inst.still(false); H3.inst.pause(true); } catch (er0) { /* negeren */ }
    H3.inst.show(p2, H3.mh, null).then(function (ok) {
      if (!ok || H3.rel) { done(null); return; }
      var d = null; try { d = H3.inst.debugFrame && H3.inst.debugFrame(); } catch (er1) { d = null; }
      var bw = W * .8, bh = Hh * .8, rect = { x: W * .1, y: Hh * .1, w: bw, h: bh };
      if (d && d.proj && d.proj.w > 4 && d.proj.h > 4) { var k = Math.min(bw / d.proj.w, bh / d.proj.h), w = d.proj.w * k, h = d.proj.h * k; rect = { x: (W - w) / 2, y: (Hh - h) / 2, w: w, h: h }; }
      done(rect);
    }, function () { done(null); });
  }
  /* de gedeelde viewer bij idle klaarzetten, de eerste zichtbare tegels alvast opbouwen (max 5) */
  function h3Warm() {
    if (H3.warm || H3.fail || !window.THREE || !window.buildStage3D) return;
    H3.warm = true;
    var go = function () {
      if (!S.on || !h3Init()) return;
      if (!H3.io && 'IntersectionObserver' in window) {
        H3.io = new IntersectionObserver(function (es) {
          es.forEach(function (en) { if (en.isIntersecting && H3.pfn < 5) { H3.pfn++; var t = en.target; H3.io.unobserve(t); (window.requestIdleCallback || function (f) { setTimeout(f, 60); })(function () { h3Prefetch(t); }); } });
        }, { root: flowOn() ? null : $('#gScroll'), threshold: .5 });
        $$('#gGrid .tile').forEach(function (t) { if (t._cl3) H3.io.observe(t); });
      }
    };
    if (window.requestIdleCallback) requestIdleCallback(go, { timeout: 3000 }); else setTimeout(go, 400);
  }

  /* ---------- tegelstijl van de live collectiepagina (cw-shop.liquid, buildCard) ----------
     franchisestrip tussen foto en tekst (transparant in rust, kleurt bij hover), bolletje + franchise + categorie,
     prijs met eventuele doorstreepte compare-at (enkel als de data die kent), puntenbadge met munt.
     Punten zoals live: ceil(prijs x RIPS_PER_EURO), RIPS_PER_EURO = 3 (metafield xp_per_euro, standaard 3);
     met een tier-multiplier (window._cwTierMultiplier, > 1) ceil(basis x multiplier) met doorgehaalde basis. */
  var RIPS_PER_EURO = 3;
  var FRC = { 'pokemon': ['#EAB308', '#A16207'], 'one piece': ['#DC2626', '#B91C1C'], 'mystery': ['#4F46E5', '#4338CA'], 'accessoires': ['#64748B', '#475569'] };
  var TCGK = [[/lorcana/i, 'Disney Lorcana', ['#0EA5A9', '#0F766E']], [/dragon ball/i, 'Dragon Ball Super', ['#EA7A17', '#C2610C']], [/yu-?gi-?oh/i, 'Yu-Gi-Oh!', ['#7C3AED', '#6D28D9']], [/riftbound/i, 'Riftbound', ['#2563EB', '#1D4ED8']], [/magic/i, 'Magic', ['#475569', '#334155']]];
  function cardInfo(e) {
    var fr = e.sfr || '', key = fr.toLowerCase(), disp = key === 'pokemon' ? 'Pok\u00e9mon' : fr, col = FRC[key] || ['#9488AE', '#6d6685'];
    if (key === 'other tcg' || !fr) {
      disp = LB('oth');
      for (var i = 0; i < TCGK.length; i++) if (TCGK[i][0].test(e.c.t || '')) { disp = TCGK[i][1]; col = TCGK[i][2]; break; }
    }
    return { name: disp, bar: col[0], text: col[1] };
  }
  function cardStyle() {
    if (!loadP()) return;
    $$('#gGrid .tile').forEach(function (t) {
      if (t._clc) return;
      var e = h3Ent(norm(txt($('.t-title', t)))); if (!e) return;
      t._clc = true; photoFix(t, e);
      var info = cardInfo(e), meta = $('.t-meta', t), price = $('.t-price', t); if (!meta) return;
      t.style.setProperty('--frc', info.bar); t.style.setProperty('--frct', info.text);
      var bar = document.createElement('div'); bar.className = 'cl-frbar'; bar.setAttribute('aria-hidden', 'true');
      t.insertBefore(bar, meta);
      var row = document.createElement('div'); row.className = 'cl-frrow';
      var cat = e.scat && e.scat !== OTHER ? lab(e.scat) : '';
      row.innerHTML = '<span class="cl-frn">' + esc(info.name) + '</span>' + (cat ? '<span class="cl-frs">\u203a</span><span class="cl-frc">' + esc(cat) + '</span>' : '');
      var title = $('.t-title', meta); meta.insertBefore(row, title);
      if (price) {
        /* 27 okt: prijs en compare-at van de tegel zelf (data-pr/data-cmp, live uit Shopify via app.js), anders de ingebakken waarde */
        var lpr = +t.getAttribute('data-pr'), live = lpr > 0;
        var pr = live ? lpr : e.c.price, cmpv = live ? +t.getAttribute('data-cmp') || 0 : +(e.c.compare_at_price || e.c.compare_at || 0);
        var mult = window._cwTierMultiplier || 1, base = Math.ceil(pr * RIPS_PER_EURO), pts = mult > 1 ? Math.ceil(base * mult) : base;
        var prow = document.createElement('div'); prow.className = 'cl-prow';
        var pr1 = document.createElement('div'); pr1.className = 'cl-pr1';
        price.parentNode.insertBefore(prow, price); pr1.appendChild(price);
        if (cmpv > pr) { var cm = document.createElement('span'); cm.className = 'cl-cmp'; cm.textContent = price.textContent.replace(/[\d.,]+/, cmpv.toFixed(2).replace('.', ',')); pr1.appendChild(cm); }
        prow.appendChild(pr1);
        var rb = document.createElement('span'); rb.className = 'cl-rips'; rb.title = 'CARDWORLD+ punten';
        rb.innerHTML = (mult > 1 ? '<s>+' + base + '</s> ' : '') + '+' + pts + '<i class="cl-coin" aria-hidden="true"></i>';
        prow.appendChild(rb);
      }
    });
  }
  function cardRestore() {
    $$('#gGrid .tile').forEach(function (t) {
      if (!t._clc) return;
      var prow = $('.cl-prow', t), price = prow && $('.t-price', prow);
      if (prow && price) { prow.parentNode.insertBefore(price, prow); }
      $$('.cl-prow,.cl-frbar,.cl-frrow', t).forEach(function (n) { n.remove(); });
      t.style.removeProperty('--frc'); t.style.removeProperty('--frct'); t._clc = false;
    });
  }
  function h3Release() {
    var rel = H3.rel; H3.rel = null; if (!rel) return;
    rel.tile.classList.remove('cl-3dact');
    try { H3.inst.detach(); H3.inst.pause(true); } catch (e) { /* negeren */ }
    if (rel.el.parentNode) rel.el.parentNode.removeChild(rel.el);
    rel.plate.classList.remove('cl-h3host');
  }
  var entByH = function (h) { var P = loadP(); if (!P) return null; if (!S.byH) { S.byH = {}; P.forEach(function (e) { if (e.c.h && !(e.c.h in S.byH)) S.byH[e.c.h] = e; }); } return S.byH[h] || null; };
  var entById = function (id) { var P = loadP(); if (!P) return null; if (!S.byId) { S.byId = {}; P.forEach(function (e) { if (e.id != null) S.byId[e.id] = e; }); } return S.byId[id] || null; };
  function badge3D(host, e) {
    if (!host || $('.cl-3dh', host)) return;
    if (!h3Build(e)) return;
    var b = document.createElement('span'); b.className = 'cl-3dh'; b.textContent = '3D'; b.setAttribute('aria-hidden', 'true'); host.appendChild(b);
  }
  /* kader van de productpagina (.pg-bg) ook achter Rip Lab: een eigen element met dezelfde klasse, zodat het de declaraties van de pagina volgt
     (achtergrondverlopen, stippenpatroon, rand, schaduw); enkel de plaatsing staat in clean-inject.css (.cl-labframe). Eenmalig aangemaakt. */
  function labFrame() {
    if (S.lf && S.lf.parentNode && S.lfc && S.lfc.parentNode) return;
    if (!S.lf || !S.lf.parentNode) { S.lf = document.createElement('div'); S.lf.className = 'pg-bg cl-labframe'; S.lf.setAttribute('aria-hidden', 'true'); document.body.appendChild(S.lf); }
    /* kap (cl-flow): exacte kopie van het kader (zelfde klassen, dus zelfde plaats, verloop en stippen), boven de inhoud maar enkel de strook van de
       schakelaarrij zichtbaar (clip-path in de css): wat onder de vaste rij doorscrolt, verdwijnt achter de bovenkant van het kader */
    if (!S.lfc || !S.lfc.parentNode) { S.lfc = document.createElement('div'); S.lfc.className = 'pg-bg cl-labframe cl-labcap'; S.lfc.setAttribute('aria-hidden', 'true'); document.body.appendChild(S.lfc); }
  }
  function catRow(e, info) {
    var row = document.createElement('div'); row.className = 'cl-frrow';
    var cat = e.scat && e.scat !== OTHER ? lab(e.scat) : '';
    row.innerHTML = '<span class="cl-frn">' + esc(info.name) + '</span>' + (cat ? '<span class="cl-frs">›</span><span class="cl-frc">' + esc(cat) + '</span>' : '');
    return row;
  }
  function ripsBadge(price) {
    var mult = window._cwTierMultiplier || 1, base = Math.ceil(price * RIPS_PER_EURO), pts = mult > 1 ? Math.ceil(base * mult) : base;
    var rb = document.createElement('span'); rb.className = 'cl-rips'; rb.title = 'CARDWORLD+ punten';
    rb.innerHTML = (mult > 1 ? '<s>+' + base + '</s> ' : '') + '+' + pts + '<i class="cl-coin" aria-hidden="true"></i>';
    return rb;
  }
  /* Rip Lab-box van de oude bouwer (.cws-stack-item) en de feed (.scene .stage): dezelfde kaartstijl-elementen als de Shop-tegels
     (categorieregel, franchiselijn, punten, 3D-label), per product uit de catalogusdata. De kaarten van Rip Lab 2.0 (.rl-item) krijgen niets:
     die bouwer toont zelf set en taal, en de 3D-doos staat daar al in beeld. */
  function ripStyle() {
    if (!loadP()) return;
    $$('.cws-stack-item').forEach(function (it) {
      if (it._clc) return;
      var e = entByH(it.getAttribute('data-handle')); if (!e) return; it._clc = true;
      var info = cardInfo(e), lb = $('.cws-stack-label', it), zone = $('.cws-stack-imgzone', it);
      it.style.setProperty('--frc', info.bar); it.style.setProperty('--frct', info.text);
      if (lb) {
        var bar = document.createElement('div'); bar.className = 'cl-frbar'; bar.setAttribute('aria-hidden', 'true'); it.insertBefore(bar, lb);
        /* het label van de stack-kaart blijft het ontwerp van de bouwer (lavendel box, titel, type, prijspil): geen kruimel en geen puntenbadge; enkel het accent op de bovenrand */
      }
      if (zone) badge3D(zone, e);
    });
    $$('#feed .scene[data-pid]').forEach(function (sc) {
      if (sc._clc) return;
      var e = entById(sc.getAttribute('data-pid')); if (!e) return; sc._clc = true;
      var st = $('.stage', sc); if (st) badge3D(st, e);
    });
  }
  /* tegels met een Shopify-foto (grijs-witte achtergrond): heeft het product een 3D-model, dan bestaat er een uitsnede en gebruiken we die
     (zelfde bestand als bij de andere tegels); zonder uitsnede blijft de foto en wordt de lichte achtergrond met multiply weggewerkt */
  function photoFix(tile, e) {
    if (e.nm !== 'SHOP_EXTRA') return;
    var img = $('.plate img', tile); if (!img || img._clph) return; img._clph = true;
    var cu = h3Build(e) ? cutUrl(e.c.h) : null;
    if (cu) {
      /* het raster houdt het beeld van tegels buiten beeld in data-gsrc tot ze bijna zichtbaar zijn (app.js gimgWatch): dan hier ook enkel dat attribuut aanpassen, anders start de uitsnede meteen */
      img._clo0 = img.getAttribute('data-gsrc') || img.getAttribute('src');
      img.onerror = function () { if (!img.hasAttribute('src') || !(img.complete && img.naturalWidth === 0)) return; /* geen echte mislukking: het raster brak het laden af */ img.onerror = null; img.src = img._clo0; tile.classList.add('cl-photo'); };
      if (img.hasAttribute('data-gsrc')) img.setAttribute('data-gsrc', cu); else img.src = cu;
    } else {
      tile.classList.add('cl-photo');
      /* de kleurmeting haalt het beeld apart op (CORS): pas als het beeld zelf geladen is, dan komt het uit de cache. Anders start dit voor elke tegel meteen een extra download en verdringt het de zichtbare beelden */
      if (img.complete && img.naturalWidth) photoTint(tile, img); else img.addEventListener('load', function () { photoTint(tile, img); }, { once: true });
    }
  }
  /* de achtergrondkleur van de foto (hoekpixel) als plaatkleur, zodat het vlak onzichtbaar wordt; zonder CORS een vaste lichte tint */
  /* mandjelade: de volledige titel in title (de regel toont maximaal 2 regels, zie CSS) en, zoals in het raster, de uitsnede voor een
     Shopify-foto met grijze achtergrond als er een uitsnede bestaat (product met 3D-model). De pagina herbouwt de lijst bij elke wijziging,
     dus dit loopt elke tick over de nieuwe rijen (gemarkeerd met _clph). */
  function cartRows() {
    $$('.col-r .item').forEach(function (it) {
      var nb = $('.nm b', it); if (nb && !nb.title) nb.title = txt(nb);
      var img = $('.plate img', it); if (!img || img._clph) return; img._clph = true;
      var ob = $('.it-open[data-info]', it), e = ob && loadP() ? entById(ob.getAttribute('data-info')) : null;
      if (!e || e.nm !== 'SHOP_EXTRA') return;
      var cu = h3Build(e) ? cutUrl(e.c.h) : null;
      if (cu) { img._clo0 = img.getAttribute('src'); img.onerror = function () { img.onerror = null; img.src = img._clo0; }; img.src = cu; }
    });
  }
  function photoTint(tile, img) {
    try {
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var c = document.createElement('canvas'); c.width = c.height = 8; var x = c.getContext('2d'); x.drawImage(im, 0, 0, 8, 8);
          var d = x.getImageData(0, 0, 1, 1).data, e = x.getImageData(7, 7, 1, 1).data;
          tile.style.setProperty('--clpc', 'rgb(' + Math.round((d[0] + e[0]) / 2) + ',' + Math.round((d[1] + e[1]) / 2) + ',' + Math.round((d[2] + e[2]) / 2) + ')');
        } catch (er) { /* CORS: vaste tint */ }
      };
      im.src = img.currentSrc || img.src;
    } catch (e) { /* negeren */ }
  }
  function h3Enter(tile) {
    if (tile === H3.tile) return;
    if (H3.tile || H3.rel) { cancelAnimationFrame(H3.raf); H3.gen++; H3.tile = null; h3Release(); }
    if (RMQ.matches || H3.fail || tile._cl3 === false || performance.now() - H3.lastScroll < 150) return;
    var e = h3Ent(norm(txt($('.t-title', tile)))), p = e && h3Build(e), plate = $('.plate', tile);
    if (!p || !plate || !h3Init()) return;
    var g = ++H3.gen; H3.tile = tile; H3.done = 0; H3.tEnter = performance.now();
    var inst = H3.inst, el = H3.el || (H3.el = document.createElement('div'));
    el.className = 'cl-h3d'; plate.appendChild(el); plate.classList.add('cl-h3host'); H3.rel = { tile: tile, plate: plate, el: el };
    /* geen eigen instap van de viewer: met follow() slaat hij enterPose over (schaal .82 naar 1, 63 graden draai, bounce)
       en toont hij de rustpose zonder zweven; wij sturen de hoek zelf */
    H3.F.rx = H3.F.ry = 0; H3.tx = H3.ty = H3.cx = H3.cy = H3.wob = 0;
    try { inst.follow(function () { return H3.F; }); inst.still(false); inst.pause(false); } catch (er) { /* negeren */ }
    var W = plate.clientWidth, Hh = plate.clientHeight, key = h3Key(p, W), fail = function () { H3.fail = true; H3.tile = null; h3Release(); };
    var go = function (rect) {
      inst.show(p, el, rect).then(function (ok) {
        if (g !== H3.gen) return;
        if (!ok || !inst.owns(el)) { H3.tile = null; h3Release(); return; }
        h3Loop(g);
        /* geen crossfade: de foto blijft volledig zichtbaar tot het live canvas echt getekend is (opacity 1), dan in
           hetzelfde frame foto weg en enkel het canvas. Blijft pollen zolang deze hover loopt. */
        var chk = function () {
          if (g !== H3.gen || H3.tile !== tile) return;
          var cv = el.querySelector('canvas');
          if (cv && cv.style.opacity === '1') {
            tile.classList.add('cl-3dact');
            var ms = Math.round(performance.now() - H3.tEnter); H3.ms.push(ms); if (H3.ms.length > 50) H3.ms.shift();
            if (!CLEAN_PROD && window.console && console.debug) console.debug('[clean3d] ms tot 3D', ms, '(gem. ' + Math.round(H3.ms.reduce(function (a, b) { return a + b; }, 0) / H3.ms.length) + ', n=' + H3.ms.length + ', rect ' + (key in H3.rect ? 'vooraf' : 'nu gemeten') + ')');
            return;
          }
          requestAnimationFrame(chk);
        };
        chk();
      }, fail);
    };
    h3Neighbors(tile);
    if (key in H3.rect) { go(H3.rect[key]); return; }
    /* kader = exact het fotokader (.plate img: 10% marge, 80% x 80%, contain): eerst de projectie van het model meten,
       dan opnieuw tonen in een rechthoek met die verhouding, zo vult het model het kader zonder uit te rekken */
    inst.show(p, el, null).then(function (ok) {
      if (g !== H3.gen) return;
      if (!ok || !inst.owns(el)) { H3.tile = null; h3Release(); return; }
      var d = null; try { d = inst.debugFrame && inst.debugFrame(); } catch (er3) { d = null; }
      var bw = W * .8, bh = Hh * .8, rect = { x: W * .1, y: Hh * .1, w: bw, h: bh };
      if (d && d.proj && d.proj.w > 4 && d.proj.h > 4) {
        var k = Math.min(bw / d.proj.w, bh / d.proj.h), w = d.proj.w * k, h = d.proj.h * k;
        rect = { x: (W - w) / 2, y: (Hh - h) / 2, w: w, h: h };
      }
      H3.rect[key] = rect; go(rect);
    }, fail);
  }
  /* rustige draai: 9 graden heen en terug, 2,2 s, cosinus-ease (start in rust met snelheid 0, geen sprong); de muis kantelt
     hooguit 3 graden mee, gefilterd (lerp .08 per frame). Terug bij weggaan: ease-in-out in 0,6 s, dan canvas weg en de foto terug. */
  function h3Loop(g) {
    var A = 9, MAXT = 3, F = H3.F;
    H3.mode = 'play'; H3.t0 = performance.now();
    var step = function (now) {
      if (g !== H3.gen && H3.mode !== 'back') return;
      var k, wob;
      if (H3.mode === 'play') {
        k = Math.min(1, (now - H3.t0) / 2200); wob = A * (1 - Math.cos(2 * Math.PI * k)) / 2;
      } else {
        k = Math.min(1, (now - H3.t1) / 600); var e = k * k * (3 - 2 * k); wob = H3.from * (1 - e); H3.tx = H3.ty = 0;
      }
      H3.wob = wob;
      H3.cx += (H3.tx - H3.cx) * .08; H3.cy += (H3.ty - H3.cy) * .08;
      F.ry = wob + H3.cx; F.rx = H3.cy;
      if (H3.mode === 'back' && k >= 1) { H3.mode = 'play'; if (H3.rel) h3Release(); return; }
      H3.raf = requestAnimationFrame(step);
    };
    H3.raf = requestAnimationFrame(step);
  }
  function h3Leave() {
    var tile = H3.tile; if (!tile) return;
    H3.tile = null; if (!H3.inst || !H3.rel) return;
    /* gen blijft gelijk zodat de terugkeer-lus doorloopt; een nieuwe hover verhoogt gen en breekt hem af via h3Enter */
    cancelAnimationFrame(H3.raf);
    H3.mode = 'back'; H3.t1 = performance.now(); H3.from = H3.wob;
    var g = H3.gen; H3.raf = 0;
    var step = function (now) {
      if (g !== H3.gen) return;
      var k = Math.min(1, (now - H3.t1) / 600), e = k * k * (3 - 2 * k), wob = H3.from * (1 - e);
      H3.cx += (0 - H3.cx) * .08; H3.cy += (0 - H3.cy) * .08;
      H3.F.ry = wob + H3.cx; H3.F.rx = H3.cy; H3.wob = wob;
      if (k < 1) { H3.raf = requestAnimationFrame(step); return; }
      H3.mode = 'play'; h3Release();
    };
    H3.raf = requestAnimationFrame(step);
  }
  document.addEventListener('pointerover', function (e) {
    if (!HOVER_3D || !S.on || e.pointerType !== 'mouse' || !desk() || mode() !== 'all') return;
    var t = e.target.closest && e.target.closest('#gGrid .tile'); if (t) h3Enter(t);
  }, { passive: true });
  document.addEventListener('pointerout', function (e) {
    if (!HOVER_3D || !H3.tile || e.pointerType !== 'mouse') return;
    var t = e.target.closest && e.target.closest('#gGrid .tile');
    if (t && t === H3.tile && !t.contains(e.relatedTarget)) h3Leave();
  }, { passive: true });
  document.addEventListener('pointermove', function (e) {
    if (!HOVER_3D) return;
    if (S.on && e.pointerType === 'mouse') H3.lastMove = performance.now();
    if (!H3.tile || !H3.inst || !H3.el || e.pointerType !== 'mouse') return;
    var r = H3.el.getBoundingClientRect(); if (r.width < 5) return;
    var px = (e.clientX - r.left) / r.width - .5, py = (e.clientY - r.top) / r.height - .5;
    H3.tx = Math.max(-3, Math.min(3, px * 6)); H3.ty = Math.max(-3, Math.min(3, -py * 6));
  }, { passive: true });
  document.addEventListener('scroll', function (e) { if (HOVER_3D && gsEvt(e) && mode() === 'all') { H3.lastScroll = performance.now(); if (H3.tile) h3Leave(); } }, true);

  /* ---------- productweergave: het 3D-model volgt zacht de muis ----------
     De pagina toont het model in de productweergave met de globale viewer window.Stage3D (Studio) in follow-modus met
     een vaste rustpose (REST) of, vanuit de feed, met de feed-tilt (tiltFollow, met zweefbeweging). Wij zetten er via
     dezelfde follow()-hook onze eigen hoek op (geen paginacode gewijzigd): yaw max 6 graden, pitch max 3 graden,
     lerp .06 per frame, terug naar rust met ease-in-out in 0,6 s als de muis het beeld of het venster verlaat.
     Geen continue draai. Enkel muis op desktop, niet bij reduced motion. Staat het model op de reserve-instantie
     (die is niet bereikbaar), dan blijft het gedrag van de pagina zoals het was. */
  var PF = { raf: 0, F: { ry: 0, rx: 0, dx: 0, dy: 0 }, cx: 0, cy: 0, back: false, t1: 0, fx: 0, fy: 0, px: 0, py: 0, inWin: false, st: null, lastSet: 0 };
  var pfFn = function () { return PF.F; };
  document.addEventListener('pointermove', function (e) { if (e.pointerType === 'mouse') { PF.px = e.clientX; PF.py = e.clientY; PF.inWin = true; } }, { passive: true });
  document.documentElement.addEventListener('mouseleave', function () { PF.inWin = false; });
  window.addEventListener('blur', function () { PF.inWin = false; });
  function pfStage() { return $('#pdpPage .pg-hero .stage'); }
  function pgFollowStart() {
    if (PF.raf || !S.on || !desk() || RMQ.matches || !document.body.classList.contains('pg-open')) return;
    PF.cx = PF.cy = 0; PF.back = false; PF.raf = requestAnimationFrame(pgFollowStep);
  }
  function pgFollowStop() {
    cancelAnimationFrame(PF.raf); PF.raf = 0;
    var S3 = window.Stage3D;
    try { if (S3 && PF.st && S3.owns(PF.st)) S3.follow(function () { return { ry: 0, rx: 0, dx: 0, dy: 0 }; }); } catch (e) { /* negeren */ }
    PF.st = null; PF.F.ry = PF.F.rx = 0;
  }
  function pgFollowStep(now) {
    PF.raf = 0;
    if (!S.on || !desk() || RMQ.matches || !document.body.classList.contains('pg-open')) { pgFollowStop(); return; }
    var S3 = window.Stage3D, st = pfStage();
    if (S3 && st && S3.owns(st)) {
      if (PF.st !== st || now - PF.lastSet > 300) { try { S3.follow(pfFn); } catch (e) { /* negeren */ } PF.st = st; PF.lastSet = now; }
      /* productpagina-ontwerp 10 okt: de stage is enkel het vak rond het product; de muis volgen over het hele lavendel vlak (.pdh-stage) */
      var zone = (st.closest && st.closest('.pdh-stage')) || st;
      var r = zone.getBoundingClientRect(), inside = PF.inWin && r.width > 4 && r.height > 4 && PF.px >= r.left && PF.px <= r.right && PF.py >= r.top && PF.py <= r.bottom;
      if (inside) {
        PF.back = false;
        var nx = Math.max(-.5, Math.min(.5, (PF.px - r.left) / r.width - .5)), ny = Math.max(-.5, Math.min(.5, (PF.py - r.top) / r.height - .5));
        PF.cx += (nx * 2 * 6 - PF.cx) * .06; PF.cy += (-ny * 2 * 3 - PF.cy) * .06;
      } else {
        if (!PF.back) { PF.back = true; PF.t1 = now; PF.fx = PF.cx; PF.fy = PF.cy; }
        var k = Math.min(1, (now - PF.t1) / 600), e2 = k * k * (3 - 2 * k);
        PF.cx = PF.fx * (1 - e2); PF.cy = PF.fy * (1 - e2);
      }
      PF.F.ry = PF.cx; PF.F.rx = PF.cy;
    } else { PF.st = null; PF.cx = PF.cy = 0; }
    PF.raf = requestAnimationFrame(pgFollowStep);
  }

  /* ---------- Rip Lab (de builder): positie in de feed ----------
     De feed is een rij schermen (keuzescherm, builder, dan de producten) met scrollpositie als index; schermen
     verbergen zou die index breken. Dus: Rip Lab zet de feed op het builderscherm en vergrendelt het scrollen. */
  function feedEl2() { return $('#feed'); }
  function labTop() { var sc = $('#feed .scene[data-kind="start"]'); return sc ? sc.offsetTop : null; }
  function feedPos(force) {
    var f = feedEl2(); if (!f || !desk() || mode() !== 'feed') { if (document.body.classList.contains('cl-lab')) document.body.classList.remove('cl-lab'); return; }
    var want = labTop();
    /* Chase zoeken leeft ook in de feedweergave, maar is geen Rip Lab: de feed blijft op de builder staan (verborgen), zonder de Rip Lab-klasse */
    document.body.classList.toggle('cl-lab', want != null && S.ft !== 'chase');
    /* rlw-pagescroll (Rip Lab-wizard stap 3): de pagina scrolt zelf, de scene niet terugzetten (CLEAN-PATCH-rlw-pagescroll.md) */
    if (document.documentElement.classList.contains('rlw-pagescroll')) return;
    /* cl-flow: #feed is geen scrollvak meer (enkel de Rip Lab-scene staat erin, het venster scrolt), dus niets terugzetten */
    if (flowOn()) return;
    var cur = f.scrollTop;
    if (Math.abs(cur - want) > 2) f.scrollTop = want;
  }
  function feedUnlock() { document.body.classList.remove('cl-lab'); }

  /* ---------- Chase zoeken: host voor window.CWChase (versie-b-src/src/chase.js, binnen app.js) ----------
     De modus leeft in de feedweergave van de pagina (zoals Samenstellen, S.ft = 'chase'); de feed zelf is dan onzichtbaar (body.cl-chase, css) en
     de host (#cl-chase-host, een keer op body aangemaakt) ligt in het middenvlak onder de schakelaar. chase.js tekent er de Finder in en houdt
     zijn eigen toestand bij; hier enkel aan en uit. Desktop wacht bij het opstarten op het herstel uit de hash (S.hMode is dan gezet), zodat er niets
     flitst; daarna blijft de host staan tijdens een hashwissel (bv. terug van de productpagina naar #chase). */
  var CH = { host: null };
  function chWant() { return S.on && mode() !== 'all' && S.ft === 'chase' && (!desk() || S.hashDone || !!S.hMode) && !!(window.CWChase && window.CWChase.mount); }
  function chSync(off) {
    if (!document.body) return;
    var on = !off && chWant(), bc = document.body.classList;
    if (bc.contains('cl-chase') !== on) bc.toggle('cl-chase', on);
    if (on) {
      if (!CH.host || !CH.host.isConnected) { CH.host = document.createElement('div'); CH.host.id = 'cl-chase-host'; CH.host.className = 'cl-chase-host';
        /* 16 okt: de host hoort VOOR de footer-groep van het thema in de flow (anders stond de footer bovenaan, voor de inhoud) */
        var ftg = document.querySelector('.shopify-section-group-footer-group'); if (ftg && ftg.parentNode) ftg.parentNode.insertBefore(CH.host, ftg); else document.body.appendChild(CH.host); }
      if (CH.host.hidden || !window.CWChase.active()) { CH.host.hidden = false; window.CWChase.mount(CH.host); }
    } else if (CH.host && !CH.host.hidden) {
      CH.host.hidden = true;
      if (window.CWChase) window.CWChase.unmount();
    }
  }
  window.addEventListener('cw:chase-ready', function () { chSync(); });

  /* ---------- hash: de gekozen tab en filterstand in de URL ----------
     #samenstellen = Samenstellen (alias #riplab, #budget), #chase = Chase zoeken, #shop = Shop (#alle, #feed en #cardix vallen terug op Shop en worden herschreven), met de filterstand erachter:
     #shop/<franchise>/<groep>/<subtype>/<taal>, ontbrekende delen weggelaten (bv. #alle/pokemon/packs/booster-packs/en).
     Segmenten worden herkend op inhoud (franchise, groep, subtype, taal), dus weglaten geeft geen verwarring.
     Schrijven met history.replaceState; kiest de bezoeker zelf een andere manier (Bladeren, Samenstellen, Chase zoeken), dan pushState, zodat Terug en
     Vooruit tussen de manieren werken (S.hMode = de manier van de laatst geschreven of toegepaste hash). Hashes van de pagina zelf (#budget, #p=...) blijven ongemoeid. */
  var slug = function (x) { return norm(x).normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); };
  /* ook de franse en engelse labels (app.js PD_LANGS), zodat /fr en /en dezelfde taalcode in de hash schrijven en herkennen */
  var LSLUG = { engels: 'en', japans: 'jp', chinees: 'cn', koreaans: 'kr', duits: 'de', frans: 'fr',
    anglais: 'en', english: 'en', japonais: 'jp', japanese: 'jp', chinois: 'cn', chinese: 'cn', coreen: 'kr', korean: 'kr', allemand: 'de', german: 'de', francais: 'fr', french: 'fr' };
  var langSlug = function (k) { var l = slug(lab(k)); return LSLUG[l] || l || slug(k); };
  /* franchise-segment: herkend op het (vertaalde) label en op de interne sleutel (data-gfr), zodat /fr, /en en collectielinks dezelfde hash aankunnen */
  var frSegIs = function (it, x) { return slug(it.l) === x || slug(it.k) === x; };
  var frSegOf = function (it, seg) { return seg.indexOf(slug(it.l)) > -1 ? slug(it.l) : seg.indexOf(slug(it.k)) > -1 ? slug(it.k) : ''; };
  /* ---------- collectielinks (11 okt, Andrea: later wordt de Studio de shoppagina voor collections/all en alle collecties) ----------
     /collections/<handle> (ook met /fr/ of /en/ ervoor) of ?c=<handle> (om nu al te testen op /pages/rip-studio) wordt bij het opstarten een #shop-hash
     met dezelfde filters als de shoppagina (cw-shop.liquid, _revFrSlug, _revLangSlug en _revCatSlug; schema in scripts/create-collections.js):
     <franchise>[-<categorie>][-<taal>]. 'all' of een onbekende handle: #shop zonder filter. Enkel zonder eigen hash of deeplink. */
  var COLL_FR = { 'pokemon': 'Pokemon', 'one-piece': 'One Piece', 'other-tcg': 'Other TCG', 'mystery': 'Mystery', 'accessoires': 'Accessoires' };
  var COLL_LANG = { engels: 'en', english: 'en', japans: 'jp', japanese: 'jp', chinees: 'cn', chinese: 'cn', koreaans: 'kr', korean: 'kr' };
  var COLL_CAT = { 'booster-packs': 'Booster Packs', 'blister-packs': 'Blisters', 'blisters': 'Blisters', 'booster-bundles': 'Booster Bundles', 'booster-boxen': 'Booster Boxen',
    'etb': 'Elite Trainer Boxen (ETB)', 'elite-trainer-boxes': 'Elite Trainer Boxen (ETB)', 'tins': 'Tins', 'vintage': 'Vintage', 'collection-boxen': 'Collection Boxen',
    'upc': 'Ultra Premium Collection', 'ultra-premium-collection': 'Ultra Premium Collection', 'devil-fruits': 'Devil Fruits', 'double-packs': 'Double Packs',
    'sleeved-boosters': 'Sleeved Boosters', 'boxes': 'Mystery Boxes', 'packs': 'Mystery Packs', 'slabs': 'Mystery Slabs' };
  /* Other TCG in het live menu: other-tcg-<spel>[-booster-boxen|-booster-packs]. In de Studio is het spel zelf de categorie (een filter per categorie),
     dus het soort (boxen of packs) valt daar weg */
  var COLL_GAME = { 'disney-lorcana': 'Disney Lorcana', 'dragon-ball-super': 'Dragon Ball Super', 'riftbound': 'Riftbound', 'yu-gi-oh': 'Yu-Gi-Oh' };
  /* menulinks die geen filter zijn maar een selectie: als zoekopdracht */
  var COLL_Q = { '30th-celebration': '30th Celebration' };
  function collHandle() {
    var m = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/collections\/([a-z0-9-]+)\/?$/i.exec(location.pathname);
    if (m) return m[1].toLowerCase();
    var c = /[?&]c=([a-z0-9-]+)/i.exec(location.search); return c ? c[1].toLowerCase() : '';
  }
  function collHash(hArg) {
    var h = hArg || collHandle(); if (!h) return '';
    if (COLL_Q[h]) return '#shop?q=' + encodeURIComponent(COLL_Q[h]);
    var segs = [], rest = h, fr = Object.keys(COLL_FR).sort(function (a, b) { return b.length - a.length; }).filter(function (k) { return rest === k || rest.indexOf(k + '-') === 0; })[0];
    if (!fr) return '#shop';
    segs.push(slug(COLL_FR[fr])); rest = rest.slice(fr.length + 1);
    var lg = Object.keys(COLL_LANG).filter(function (k) { return rest === k || rest.slice(-(k.length + 1)) === '-' + k; })[0];
    if (lg) rest = rest === lg ? '' : rest.slice(0, rest.length - lg.length - 1);
    var gm = fr === 'other-tcg' && Object.keys(COLL_GAME).filter(function (k) { return rest === k || rest.indexOf(k + '-') === 0; })[0];
    if (gm) segs.push(slug(COLL_GAME[gm]));
    else if (rest && COLL_CAT[rest]) segs.push(slug(COLL_CAT[rest]));
    if (lg) segs.push(COLL_LANG[lg]);
    return '#shop/' + segs.join('/');
  }
  function parseHash(h) {
    if (!h || h === '#') return null;
    var qv = '', qi2 = h.indexOf('?q=');
    if (qi2 > -1) { try { qv = decodeURIComponent(h.slice(qi2 + 3)); } catch (e) { qv = ''; } h = h.slice(0, qi2); }
    var m = /^#(feed|cardix|samenstellen|riplab|budget|alle|shop|chase)(?:\/(.*))?$/.exec(h);
    if (!m) return { t: 'foreign' };
    if (m[1] === 'samenstellen' || m[1] === 'riplab' || m[1] === 'budget') return { t: 'lab' }; /* #samenstellen is de naam (15 okt); #riplab en #budget blijven werken als alias en worden herschreven */
    if (m[1] === 'chase') return { t: 'chase' };
    return { t: 'all', q: qv, seg: (m[2] || '').split('/').filter(Boolean) };
  }
  /* ---------- echte filteradressen (15 okt, Andrea: tot de lancering dezelfde namen als de live site) ----------
     De shop zet zijn filters in de query, met de parameternamen en waarden van de live collectiepagina (cw-shop.liquid, CWSH_URL_KEYS):
     ?collection=<handle>&franchise=Pokemon&category=Booster+Packs&card_language=Engels&q=<zoekterm>#shop. collection is het handle zoals in
     /collections/<handle> (franchise of all); groep bestaat enkel in de Studio (een groep zonder categorie, bv. groep=packs).
     Intern blijft de vorm #shop/<franchise>/<groep>/<categorie>/<taal>?q= de sleutel (parseHash, hashWant, hashApply): qHash leest de query naar
     die vorm, urlOf schrijft een interne hash als echt adres. Een oude hash (#shop/pokemon/packs/en) werkt nog en wordt bij de volgende schrijfbeurt herschreven. */
  var SHOPQ = ['collection', 'franchise', 'category', 'card_language', 'q', 'groep', 'c'];
  var LIVE_LANG = { en: 'Engels', jp: 'Japans', cn: 'Chinees', kr: 'Koreaans', de: 'Duits', fr: 'Frans' };
  function qHash(search, hash) {
    if (hash && !/^#(shop|alle)?$/.test(hash)) return '';
    var sp; try { sp = new URLSearchParams(search || ''); } catch (e) { return ''; }
    if (!SHOPQ.some(function (k) { return k !== 'c' && sp.has(k); })) return '';
    var segs = [], fr = sp.get('franchise'), col = (sp.get('collection') || '').toLowerCase(), cat = sp.get('category'), lg = sp.get('card_language'), gr = sp.get('groep'), q = sp.get('q');
    if (fr) segs.push(slug(fr));
    else if (col && col !== 'all') { var ch = parseHash(collHash(col)); if (ch && ch.t === 'all') { segs = ch.seg.slice(); if (!q && ch.q) q = ch.q; } }
    if (gr) segs.push(slug(gr));
    if (cat) segs.push(slug(cat));
    if (lg) { var ls = slug(lg); segs.push(LSLUG[ls] || COLL_LANG[ls] || ls); }
    return '#shop' + (segs.length ? '/' + segs.join('/') : '') + (q ? '?q=' + encodeURIComponent(q) : '');
  }
  /* de interne hash van het huidige adres: de shopquery als de hash leeg of #shop is, anders de hash zelf */
  /* ---------- echte adressen per tab (16 okt): /pages/shop (Shop), /pages/samenstellen (Samenstellen), /pages/chase-zoeken (Chase zoeken) ----------
     Eén Shopify-template op drie pagina's; ook met taalprefix (/fr/pages/..., /en/pages/...). /pages/rip-studio (en elk ander pad, bv. /collections/<handle>)
     blijft werken en toont Shop. Het pad bepaalt de beginmodus (pathHash, en het voorscript in de head van pack.js); de hash blijft de interne sleutel
     (#samenstellen, #chase/..., #shop) zodat hashWant, hashApply, mbHash en chase.js ongewijzigd blijven. pathOf(t) = het pad van de manier t (all, lab, chase):
     zelfde taalprefix, Shop op de eigen pagina laten staan (rip-studio blijft rip-studio zolang je in Shop blijft) en anders /pages/shop. */
  var PG_RE = /^((?:\/[a-z]{2}(?:-[a-z]{2})?)?)\/pages\/([^\/?#]+)\/?$/i;
  /* 16 okt (Andrea): korte adressen zonder /pages/ (/build, /en/build, /fr/composer, ...); de layout (CL_PAD) zet ze in de adresbalk */
  var PG_SHORT_RE = /^((?:\/[a-z]{2}(?:-[a-z]{2})?)?)\/(samenstellen|chase-zoeken|build|find-a-chase|composer|trouver-une-chase)\/?$/i;
  var LANGPRE_RE = /^(\/[a-z]{2}(?:-[a-z]{2})?)(?=\/(?:pages|collections)\/)/i;
  /* 16 okt (Andrea: "de urls moeten vertaald worden"): vertaalde paginahandles (Shopify-vertaling van de pagina's, translationsRegister) */
  var PG_SLUGS = { lab: { nl: 'samenstellen', en: 'build', fr: 'composer' }, chase: { nl: 'chase-zoeken', en: 'find-a-chase', fr: 'trouver-une-chase' } };
  function slugKind(x) { x = String(x || '').toLowerCase(); return Object.keys(PG_SLUGS).filter(function (k) { var o = PG_SLUGS[k]; return Object.keys(o).some(function (l) { return o[l] === x; }); })[0] || ''; }
  function preLang(pre) { var l = String(pre || '').replace('/', '').slice(0, 2).toLowerCase(); return l === 'en' || l === 'fr' ? l : 'nl'; }
  function pathOf(t) {
    var p = location.pathname, m = PG_RE.exec(p) || PG_SHORT_RE.exec(p), cur = m ? m[2].toLowerCase() : '';
    var pre = m ? m[1] : (LANGPRE_RE.exec(p) || [''])[0];
    if (t === 'lab' || t === 'chase') return pre + '/' + PG_SLUGS[t][preLang(pre)]; /* kort adres */
    if (t === 'all' && (slugKind(cur) || cur === 'shop')) return pre + '/collections/all'; /* 16 okt: Shop = /collections/all */
    if (PROD_RE.test(p)) { var lp = /^(\/[a-z]{2}(?:-[a-z]{2})?)(?=\/products\/)/i.exec(p); return (lp ? lp[1] : '') + (t === 'lab' || t === 'chase' ? '/' + PG_SLUGS[t][preLang(lp ? lp[1] : '')] : '/collections/all'); } /* 22 okt: vanaf een productadres */
    return p;
  }
  window.cwPathOf = pathOf;
  /* de manier waar het pad voor staat als hash ('' op elk ander pad) */
  /* 16 okt (Andrea: schone adressen): ook de Shop-pagina's (/pages/shop, /pages/rip-studio) staan voor een manier, zodat een kaal adres zonder hash werkt */
  var PG_SHOP = { shop: 1, 'rip-studio': 1 };
  function slugOfPath(p) { var m = PG_RE.exec(p || '') || PG_SHORT_RE.exec(p || ''); return m ? m[2].toLowerCase() : ''; }
  var COLL_ALL_RE = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/collections\/[a-z0-9-]+\/?$/i; /* 16 okt: /collections/all en elke collectie (templateSuffix cw-rip-studio) zijn de Shop */
  /* 22 okt (Andrea: productadres /products/<handle> in de adresbalk): een open product staat op zijn echte productadres; voor deze laag is dat
     een productlink (#p=, foreign): niets schrijven, en een shopadres maken vanaf dat pad gaat naar /collections/all */
  var PROD_RE = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/products\/([^\/?#]+)\/?$/i;
  function pathHash(p) { p = p || location.pathname; var pm = PROD_RE.exec(p); if (pm) return '#p=' + pm[1]; if (COLL_ALL_RE.test(p) || /^(?:\/[a-z]{2})?\/live(?:\/full)?\/?$/i.test(p)) return '#shop'; /* 16 okt: /live = streamscherm boven de Shop */ var s = slugOfPath(p), k = slugKind(s); return k === 'lab' ? '#samenstellen' : k === 'chase' ? '#chase' : PG_SHOP[s] ? '#shop' : ''; }
  /* zonder hash volgt de manier het pad (bv. na het sluiten van een productpagina, dat de hash weghaalt); een shopquery telt enkel op een Shop-pad */
  function locHash() { var ph = pathHash(); return ((!ph || ph === '#shop') && qHash(location.search, location.hash)) || location.hash || ph; }
  /* interne hash naar het echte adres: shopparameters uit de segmenten (franchise, groep, categorie, taal; zelfde herkenning als hashApply),
     andere parameters (utm_*, ?p=, ...) blijven staan; Samenstellen en Chase zoeken houden hun hash en krijgen geen shopparameters */
  function urlOf(want) {
    var sp = new URLSearchParams(location.search), pr = parseHash(want), h = want;
    SHOPQ.forEach(function (k) { sp.delete(k); });
    if (pr && pr.t === 'all') {
      h = '#shop';
      var fr = '', gr = '', cat = '', lg = '', cands = [];
      GROUPS.forEach(function (g) { cands = cands.concat(g.cats); });
      Object.keys(COLL_CAT).forEach(function (k) { cands.push(COLL_CAT[k]); });
      if (S.sub) cands.unshift(S.sub);
      if (S.M && S.M.cc) cands = Object.keys(S.M.cc).concat(cands);
      $$('#gChain [data-gcat]').forEach(function (e) { cands.push(e.getAttribute('data-gcat')); });
      pr.seg.forEach(function (x) {
        var f = Object.keys(COLL_FR).filter(function (k) { return k === x || slug(COLL_FR[k]) === x; })[0];
        if (f && !fr) { fr = COLL_FR[f]; return; }
        /* vertaald of hernoemd label (Andere TCG, Autres TCG): via de pil van de pagina, de sleutel is de live waarde */
        var fi = !fr && readGrid().fr.filter(function (i) { return i.k !== 'all' && frSegIs(i, x); })[0];
        if (fi) { fr = fi.k; return; }
        if (GROUPS.some(function (g) { return g.k === x; })) { gr = x; return; }
        if (LIVE_LANG[x]) { lg = LIVE_LANG[x]; return; }
        if (S.lang && langSlug(S.lang) === x) { lg = S.lang; return; }
        var c = cands.filter(function (k) { return k && slug(k) === x; })[0]; if (c) cat = c;
      });
      var hk = fr ? Object.keys(COLL_FR).filter(function (k) { return COLL_FR[k] === fr; })[0] : '';
      if (hk) sp.set('collection', hk); /* zonder franchise geen ?collection=all: kaal adres */
      if (fr) sp.set('franchise', fr);
      if (cat) sp.set('category', cat); else if (gr) sp.set('groep', gr);
      if (lg) sp.set('card_language', lg);
      if (pr.q) sp.set('q', pr.q);
    }
    var qs = sp.toString();
    var path = pr && (pr.t === 'all' || pr.t === 'lab' || pr.t === 'chase') ? pathOf(pr.t) : location.pathname;
    /* de hash weglaten als het pad die manier al zegt (#shop op /pages/shop, #samenstellen op /pages/samenstellen, #chase op /pages/chase-zoeken);
       diepere hashes (#chase/..., #p=...) blijven staan */
    if (h && h === pathHash(path)) h = '';
    /* 16 okt: op het adres van het streamscherm (/live, /fr/live, /en/live; app.js sfLiveUrl) geen #shop erachter */
    if (h === '#shop' && /^(?:\/[a-z]{2})?\/live(?:\/full)?\/?$/i.test(path)) h = '';
    return path + (qs ? '?' + qs : '') + h;
  }
  var locUrl = function () { return location.pathname + location.search + location.hash; };
  function hashWant() {
    if (mode() === 'all') {
      var parts = [];
      if (S.fr && S.fr !== 'all') { var it = readGrid().fr.filter(function (x) { return x.k === S.fr; })[0]; if (it) parts.push(slug(it.l)); }
      if (S.grp) parts.push(S.grp);
      if (S.sub) parts.push(slug(S.sub));
      if (S.lang) parts.push(langSlug(S.lang));
      return '#shop' + (parts.length ? '/' + parts.join('/') : '') + (S.q ? '?q=' + encodeURIComponent(S.q) : '');
    }
    /* Chase zoeken schrijft zelf de stap in de hash (#chase/<franchise>/<set>/<kaart>, snelfilter, zoekterm; chase.js chsHash, desktop en gsm, 16 okt):
       een diepe chase-hash laten staan; bij het kiezen van de modus de stap van chase.js (CWChase.hash), anders de start */
    if (S.ft === 'chase') {
      if (/^#chase(?:\/|$)/.test(location.hash)) return location.hash;
      var cw = window.CWChase; try { if (cw && cw.hash && cw.active()) return cw.hash(); } catch (e) { /* negeren */ }
      return '#chase';
    }
    return '#samenstellen';
  }
  /* history.state voor een entry van de Clean-laag: zonder het volgnummer en de stappen van Chase zoeken (chs, chsPrev, chsBelow; versie-b-src/src/chase.js),
     anders zou een #shop- of #chase-entry zich voordoen als een chase-stap */
  function hState() {
    var st = history.state; if (!st || typeof st !== 'object' || !('chs' in st || 'chsPrev' in st || 'chsBelow' in st)) return st;
    var o = {}; Object.keys(st).forEach(function (k) { if (k !== 'chs' && k !== 'chsPrev' && k !== 'chsBelow') o[k] = st[k]; }); return Object.keys(o).length ? o : null;
  }
  /* de manier als hash-type (zelfde namen als parseHash: all, lab, chase) */
  function modeT() { var v = curView(); return v === 'grid' ? 'all' : v; }
  /* Terug en Vooruit tussen de manieren (16 okt, audit): na een popstate volgt de weergave het adres, nooit andersom. Tot de getoonde manier
     overeenkomt met de manier in het adres (hashApply, mbHashApply) schrijven hashSync en mbHash niets; anders draaide een tick tussen popstate en
     hashchange de stap terug (replaceState naar #samenstellen) of overschreef hij de entry met de Shop-URL. S.popAt = tijdstip van de laatste
     popstate, 0 zodra de weergave gevolgd is of de bezoeker zelf een manier kiest (onClick, de modusbalk). */
  S.popAt = 0;
  window.addEventListener('popstate', function () { S.popAt = performance.now(); }, true);
  /* de manier in het adres (all, lab, chase; '' = onbekend) en of we nog op de weergave wachten na een popstate */
  function urlMode(pr) { return pr ? pr.t : (desk() ? '' : 'all'); }
  function popHold(urlT, mt) {
    if (!S.popAt || !urlT) return false;
    if (performance.now() - S.popAt > 3000) { S.popAt = 0; return false; } /* vangnet: nooit langer dan 3 s de URL bevriezen */
    if (urlT !== mt) return true;
    S.popAt = 0; return false;
  }
  function hashSync() {
    if (!S.hashDone || document.body.classList.contains('pg-open') || $('#pdpSheet.on')) return;
    /* 19 okt (Andrea: "vanuit Samenstellen of Chase zoeken blijft de adresbalk op dat pad"): zolang het streamscherm open is, is het adres /live of
       /live/full (app.js sfLiveUrl); dan niets schrijven, anders zette deze lus (elke 250 ms) /samenstellen of /chase-zoeken terug */
    var sfo = document.getElementById('streamFull'); if ((sfo && sfo.classList.contains('on')) || /^(?:\/[a-z]{2})?\/live(?:\/full)?\/?$/i.test(location.pathname)) return; /* ook voor het scherm open is (opstart via /live of na de Twitch-login) */
    /* productlink bij het opstarten: de pagina haalt #p= even weg voor ze het product opent (openDeeplink, 700 ms); dan niets schrijven,
       anders verving #samenstellen de entry en verdween de shopquery (16 okt) */
    if (S.fgGrid && !S.fgSeen) return;
    var h = locHash(), pr = parseHash(h);
    if (pr && pr.t === 'foreign') return;
    var now = performance.now(), inWin = S.restoreUntil && now < S.restoreUntil && !S.userAct;
    /* tijdens het herstelvenster schrijven we niets terug als de pagina de weergave (nog) niet heeft overgenomen */
    if (inWin && S.hp && S.hp.t !== 'foreign' && ((S.hp.t === 'all') !== (mode() === 'all'))) return;
    var mt = modeT(), urlT = urlMode(pr);
    if (popHold(urlT, mt)) return; /* Terug of Vooruit: de weergave volgt nog */
    var want = hashWant(), url = urlOf(want);
    /* enkel op de echte URL vergelijken: hashWant kent groep en categorie, de URL enkel categorie, dus h === want was soms nooit waar
       en dan schreef elke tick (250 ms) opnieuw een replaceState (Safari begrenst history-aanroepen) */
    if (locUrl() === url) { S.hMode = mt; return; }
    /* een nieuwe entry enkel als de manier in het adres verschilt van de getoonde (een moduswissel); filters binnen dezelfde manier: replaceState */
    var push = S.userAct && !inWin && (urlT ? urlT !== mt : S.hMode && S.hMode !== mt);
    try { history[push ? 'pushState' : 'replaceState'](hState(), '', url); } catch (e) { /* negeren */ }
    S.hMode = mt;
  }
  /* de pagina rondt haar opstart soms later af dan wij (feed, Afstemmen-venster): enkele seconden na het herstel blijven we
     controleren of de weergave en de franchise nog kloppen en zetten ze zo nodig opnieuw (stopt zodra de gebruiker zelf klikt) */
  function restoreGuard() {
    var hp = S.hp; if (!S.hashDone || !hp || hp.t === 'foreign' || S.userAct || !S.restoreUntil || performance.now() > S.restoreUntil) return;
    var bad = false;
    if (hp.t === 'all') {
      if (mode() !== 'all') bad = true;
      else {
        var fsIt = readGrid().fr.filter(function (i) { return i.k !== 'all' && hp.seg.some(function (x) { return frSegIs(i, x); }); })[0], on = $('#gFr .g-pill.on');
        if (fsIt && (!on || on.getAttribute('data-gfr') !== fsIt.k)) bad = true;
      }
    } else if (hp.t === 'lab' || hp.t === 'chase') { if (mode() === 'all' || S.ft !== hp.t) bad = true; }
    if (bad) { S.hashDone = false; S.applyT0 = performance.now(); }
  }
  function hashApply() {
    if (S.hp === undefined) S.hp = parseHash(locHash());
    var hp = S.hp, now0 = performance.now(); if (!S.applyT0) S.applyT0 = now0;
    if (!hp || hp.t === 'foreign') { S.hashDone = true; return; }
    if (now0 - S.applyT0 > 8000) { S.hashDone = true; S.restoreUntil = now0; return; }
    var gridBtn = $('.viewseg [data-view="grid"]'), feedBtn = $('.viewseg [data-view="feed"]');
    if (hp.t === 'lab' || hp.t === 'chase') {
      S.ft = hp.t; S.hMode = hp.t;
      if (mode() === 'all' && feedBtn) feedBtn.click();
      S.hashDone = true; S.restoreUntil = performance.now() + 3500; S.applyT0 = 0; feedPos(); chSync(); return;
    }
    if (mode() !== 'all') { if (gridBtn) gridBtn.click(); return; }
    if (!$$('#gFr .g-pill').length || !loadP()) return;
    qSet(hp.q || '');
    var seg = hp.seg.slice(), M0 = S.M;
    /* eerst de franchise: de pagina zet daarbij categorie en taal terug */
    var frIt = readGrid().fr.filter(function (x) { return x.k !== 'all' && !!frSegOf(x, seg); })[0];
    if (frIt) { seg.splice(seg.indexOf(frSegOf(frIt, seg)), 1); if (S.fr !== frIt.k) { doGrid('gfr', frIt.k); sync(); } }
    else if (S.fr !== 'all') { doGrid('gfr', S.fr); sync(); }
    var M = S.M || M0, grp = '', sub = '', lg = '';
    /* gsm: daar bouwt sync() geen model (S.M), dan de categorieen en talen rechtstreeks uit de keten van de pagina (#gChain) */
    var ccK = M ? Object.keys(M.cc) : $$('#gChain [data-gcat]').map(function (e) { return e.getAttribute('data-gcat'); });
    var lgK = M ? M.langItems.map(function (i) { return i.k; }) : $$('#gChain [data-glang]').map(function (e) { return e.getAttribute('data-glang'); });
    seg.forEach(function (x) {
      if (GROUPS.some(function (g) { return g.k === x; })) { grp = x; return; }
      var c = ccK.filter(function (k) { return slug(k) === x; })[0]; if (c) { sub = c; return; }
      var l = lgK.filter(function (k) { return k && langSlug(k) === x; })[0]; if (l) lg = l;
    });
    S.grp = grp; S.sub = sub; if (sub && !grp) S.grp = groupOf(sub); S.lang = lg;
    applyReal(); settle(); S.hashDone = true; S.hMode = 'all'; S.restoreUntil = performance.now() + 3500; S.applyT0 = 0;
  }
  window.addEventListener('hashchange', function () {
    if (!S.on) return;
    /* net een andere manier gekozen terwijl de productpagina openstond: de terugsprong van de pagina niet als keuze lezen, de gekozen manier in de URL zetten */
    var hold = S.ftHold; S.ftHold = null;
    if (hold && performance.now() - hold.t < 1500 && mode() !== 'all') {
      S.ft = hold.ft; var w = hashWant();
      try { history.replaceState(hState(), '', urlOf(w)); } catch (e) { /* negeren */ }
      S.hp = parseHash(w); S.hMode = modeT(); S.hashDone = true; feedPos(); chSync(); return;
    }
    /* de hash meteen lezen, niet pas bij de volgende tick: de pagina kan intussen zelf iets anders in de url zetten (setActive na het sluiten
       van een productpagina schreef #budget, en een trage tick las dat dan als Samenstellen; 11 okt) */
    S.hcAt = performance.now(); hashFollow();
  });
  function hashFollow() { S.hp = parseHash(locHash()); S.hashDone = false; if (!desk()) mbHashApply(); }
  /* Terug naar Shop (16 okt, audit): de Shop-entry heeft de shopquery in de zoekstring (?collection=all#shop), Samenstellen en Chase zoeken niet.
     Verschilt meer dan de hash, dan vuurt de browser bij Terug of Vooruit enkel popstate en geen hashchange; dan bleef S.hp op de vorige manier
     en volgde de weergave nooit (URL #shop, scherm Samenstellen). Kwam er na de popstate geen hashchange en toont het adres een andere manier
     dan het scherm, dan hier hetzelfde doen als de hashchange-handler. */
  window.addEventListener('popstate', function () {
    if (!S.on) return;
    var t0 = performance.now();
    setTimeout(function () {
      if (!S.on || (S.hcAt && S.hcAt >= t0)) return; /* de hashchange heeft het al opgepakt */
      var pr = parseHash(locHash()), urlT = urlMode(pr);
      if (!pr || pr.t === 'foreign' || !urlT || urlT === modeT()) return;
      hashFollow();
    }, 0);
  });

  /* ---------- doorlopende pagina (html.cl-flow, 11 okt) ----------
     Zolang Clean aan staat (desktop en gsm, alle modi) staat html.cl-flow: het venster is de scroller, #gScroll, #feed en de host van Chase zoeken
     zijn geen scrollvakken meer (css, blok DOORLOPENDE PAGINA). De schakelaarrij (.cats op desktop, .cl-mbar op gsm) blijft staan in Samenstellen en Chase zoeken.
     In Bladeren schuift de rij wel mee weg (dkSlide, mbSlide, zoals voordien).
     --cl-flow-top op html = de onderrand van wat vast staat in px (Samenstellen en Chase zoeken: desktop col-t + cats-h, gsm hdr + mb-h;
     Bladeren: hdr): de bovenkant voor sticky elementen en voor
     scroll-naar-boven, ook gelezen door Samenstellen (rip-lab-cadeau.js, FLOW_TOP_VAR). Gemeten met een vast meetpuntje (.cl-flowprobe, top
     var(--cl-flow-top0)), bijgewerkt als de header (--hdr in de style van html) of het venster verandert. Wisselt de modus (Bladeren, Samenstellen,
     Chase zoeken), dan gaat het venster naar boven.
     Eén kader voor alle modi op desktop (11 okt, Andrea: "in hetzelfde design als Chase zoeken"): de vaste laag .cl-labframe (wit, rand, radius
     bovenaan, schaduw) begint boven de tabrij, zodat de tabs erin staan, en loopt onderaan door. Samenstellen en Chase zoeken: het kader staat stil
     en de kap (.cl-labcap) bedekt wat onder de vaste rij doorscrolt. Bladeren: het kader schuift mee met de tabrij (dkSlide, --cl-fy) en de
     filterkaart verliest haar eigen kaartlook. Voor Samenstellen (rip-lab-cadeau) op html, in px, gemeten bij resize, headerwijziging en moduswissel:
     --cl-frame-top = bovenkant van het kader, --cl-tabs-bottom = onderkant van de tabrij erin; beide in venstercoordinaten bij scroll 0
     (in Samenstellen en Chase zoeken staan kader en rij vast, dus dat is altijd de plek in het venster). Gsm: geen kader, hdr en hdr + mb-h. */
  var FL = { probe: null, probe2: null, mode: '', mo: null, bo: null };
  function cssLen(expr) {
    if (!FL.probe2 || !FL.probe2.isConnected) {
      FL.probe2 = document.createElement('i'); FL.probe2.className = 'cl-flowprobe'; FL.probe2.setAttribute('aria-hidden', 'true');
      document.body.appendChild(FL.probe2);
    }
    FL.probe2.style.top = expr;
    var v = parseFloat(getComputedStyle(FL.probe2).top);
    return isFinite(v) && v > 0 ? Math.round(v * 10) / 10 : 0;
  }
  function flowTopPx() {
    if (!FL.probe || !FL.probe.isConnected) {
      FL.probe = document.createElement('i'); FL.probe.className = 'cl-flowprobe'; FL.probe.setAttribute('aria-hidden', 'true');
      document.body.appendChild(FL.probe);
    }
    var v = parseFloat(getComputedStyle(FL.probe).top);
    return isFinite(v) && v > 0 ? Math.round(v * 10) / 10 : 0;
  }
  function flowTopSync() {
    if (!S.on || !flowOn() || !document.body) return;
    var de = document.documentElement, set = function (k, v) { if (!v) return false; var s = v + 'px'; if (de.style.getPropertyValue(k) === s) return false; de.style.setProperty(k, s); return true; };
    /* --cl-frame-top en --cl-tabs-bottom gelden bij scroll 0, dus met de aankondigingsbalk nog in beeld (+ ann); --cl-flow-top is de sticky
       bovenkant, die geldt met de ingeklapte kopbalk (--hdr is de ingeklapte stand, zie KOPBALK hieronder) */
    var ann = FL.ann || 0;
    set('--cl-frame-top', cssLen('var(--cl-frame-top0)') + ann);
    set('--cl-tabs-bottom', cssLen('var(--cl-tabs-bottom0)') + ann);
    FL.hdr = cssPx('--hdr');
    if (set('--cl-flow-top', flowTopPx())) { MQS.gt = -1; try { mqsFit(); } catch (er) { /* negeren */ } }
  }
  /* ---------- KOPBALK die meeschuift (11 okt, Andrea: het inklappen van de header bij scrollen voelde laggy) ----------
     De kopbalk krimpt niet meer; de aankondigingsbalk (.cwh-announce-shell, ann px: gemeten, nooit vast) schuift 1:1 met het venster weg.
     Op deze pagina is de header-group vast (layout cw-rip-studio), dus geen sticky: de groep krijgt top -s (inline, !important tegen de layoutregel)
     met s = min(scrollY, ann). Bewust top en geen transform: een transform maakt van de groep de plek van zijn vaste kinderen (gsm-menu
     .cwh-drawer, mini-cart, cart-notification, live-mini, de zoekpanelen), die dan in de kopbalk opgesloten zouden zitten. top verplaatst enkel
     dit ene vaste vak (geen herberekening van de rest van de pagina) en enkel in de eerste ann px.
     --hdr blijft constant op de ingeklapte stand (page-fit.js trekt ann af zolang cl-flow staat), zodat alles wat ervan afhangt (col-t,
     cl-flow-top, sticky balken) een vaste waarde heeft. Wat bij scroll 0 nog onder de volle kopbalk moet staan, schuift met de css-eigenschap
     translate (los van hun eigen transform) ann - s naar beneden: de vaste lagen (tabrij, streamkolom, kader en kap, productlaag, gsm-modusbalk,
     PiP, terugpil). De inhoud in de flow staat ann lager via padding-top op body (--cl-ann, enkel gezet als ann verandert). Per scrollframe dus
     geen variabele op html of body, enkel inline translate op een handvol vaste lagen, en enkel zolang s verandert (de eerste ann px).
     Oude header (krimpt zelf met een overgang): de schaal wordt 0, dan is ann 0 en verschuift er niets; --hdr blijft gelijk (kopbalk min ann). */
  var HS = { s: -1, off: -1, raf: 0, ro: null, shell: null };
  var HS_SEL = '.cats,.col-l,#pdpPage,.cl-mbar,#pip,.pip-tab,.pip-tabx,.pip-close,.back-pill,.toasts,.cws-add-panel';
  function hdrWrap() { return $('#cwh-wrap') || $('#cwhWrap'); }
  function hdrGroup() { var w = hdrWrap(); return w ? (w.closest('.shopify-section-group-header-group') || w) : null; }
  function setTr(el, v) { var t = v ? '0 ' + v + 'px' : ''; if (el._clTr === t) return; el._clTr = t; el.style.translate = t; }
  /* 16 okt: lagen die de pagina later aanmaakt (de productlaag bij het eerste product) krijgen meteen de huidige verschuiving (app.js pgEl) */
  window.CW_CL_TR = function (el) { if (el && HS.off > 0 && S.on && flowOn()) setTr(el, HS.off); };
  function hdrShift(force) {
    var a = FL.ann || 0, s0 = Math.min(Math.max(0, winY()), a), off = a - s0;
    if (s0 === HS.s && off === HS.off && (!force || !off)) return; /* 18 okt (perf): niets verschoven (off 0): geen zoektocht door het document */
    var same = s0 === HS.s && off === HS.off;
    HS.s = s0; HS.off = off; window.__cwHdrS = s0;
    var g = hdrGroup();
    if (g) { var tp = s0 ? (-s0) + 'px' : ''; if (g._clTop !== tp) { g._clTop = tp; if (tp) g.style.setProperty('top', tp, 'important'); else g.style.removeProperty('top'); } }
    (same ? $$c(HS_SEL, 1200) : $$(HS_SEL)).forEach(function (el) { setTr(el, off); });
    /* kader en kap: geen translate maar een inline top (enkel in de eerste ann px, enkel deze twee vaste vakken). Een transform of translate laat
       background-attachment:fixed niet meer tegen het venster werken; de franchisetint van Samenstellen op de kap (css onderaan) liep dan niet
       meer door met de inhoud en toonde de gloed van de verlopen in de strook zelf. */
    (same ? $$c('.cl-labframe', 1200) : $$('.cl-labframe')).forEach(function (el) {
      var tp = off ? 'calc(var(--cl-frame-top0) + ' + off + 'px)' : '';
      if (el._clTr) { el._clTr = ''; el.style.translate = ''; }
      if (el._clTop === tp) return; el._clTop = tp;
      if (tp) el.style.setProperty('top', tp, 'important'); else el.style.removeProperty('top');
    });
  }
  function annSync() {
    var w = hdrWrap(), sh = w ? $('.cwh-announce-shell', w) : null, de = document.documentElement, on = S.on && flowOn();
    /* de waarnemer enkel zolang Clean en cl-flow aan staan (flowStop ruimt hem op; het interval en resize maken hem dan niet opnieuw) */
    if (on && sh && sh !== HS.shell && window.ResizeObserver) { if (HS.ro) HS.ro.disconnect(); HS.shell = sh; HS.ro = new ResizeObserver(annSync); HS.ro.observe(sh); }
    if (!on && HS.ro) { HS.ro.disconnect(); HS.ro = null; HS.shell = null; }
    var a = on && sh ? Math.round(sh.offsetHeight) : 0;
    if (a === (FL.ann || 0)) return;
    FL.ann = a;
    if (a) de.style.setProperty('--cl-ann', a + 'px'); else de.style.removeProperty('--cl-ann');
    if (window.CW_HDR_MEASURE) try { window.CW_HDR_MEASURE(); } catch (er) { /* negeren */ }
    hdrShift(true); flowTopSync();
  }
  window.addEventListener('scroll', function () {
    if (!FL.ann || HS.raf) return;
    HS.raf = requestAnimationFrame(function () { HS.raf = 0; hdrShift(); });
  }, { passive: true });
  /* 16 okt (Andrea): na een product en Terug bleef de grote tabrij soms staan i.p.v. de sticky filterbalk (cl-stuck niet herberekend, de
     IntersectionObserver meldt niets als zijn toestand niet wijzigde). Vangnet: bij scrollen en na Terug de stand zelf nameten. */
  var STK_RAF = 0;
  function stkCheck() {
    STK_RAF = 0;
    if (!S.on || !flowOn() || mode() !== 'all' || document.body.classList.contains('pg-open') || $('#pdpSheet.on')) return;
    var al = $('.cl-all'); if (!al) return;
    var ar = al.getBoundingClientRect(); if (ar.height > 0) setStuck(ar.bottom <= gsRootTop() + stkOff());
  }
  window.addEventListener('scroll', function () { if (!STK_RAF) STK_RAF = requestAnimationFrame(stkCheck); }, { passive: true });
  window.addEventListener('popstate', function () { [60, 300, 900].forEach(function (d) { setTimeout(function () { try { hdrShift(true); stkSync(); stkCheck(); } catch (er) { /* negeren */ } }, d); }); });
  /* Kader tot de footer (16 okt, Samenstellen en Chase zoeken op desktop, niet Shop): het vaste kader (.cl-labframe, niet de kap) loopt normaal 48 px onder
     het venster door. Komt de footer van het thema (.shopify-section-group-footer-group) omhoog, dan eindigt het kader 24 px onder de bovenkant van de
     footer (verborgen onder de footer, z 59), zodat er geen kaderstrook onder of naast de footer blijft. Bij scroll 0 en zolang de footer buiten beeld
     staat verandert er niets (geen inline bottom). De kap is de strook van de tabrij; wordt de footer daarover geschoven, dan ligt de footer erboven.
     Geen eigen observer: scroll, resize, de bestaande modus-waarnemer (flowModeCheck) en een ResizeObserver op body (hoogte van scene of host). */
  var FE = { raf: 0, v: null, ro: null };
  function footEnd() {
    var lf = S.lf, v = null;
    if (!lf) { FE.v = null; return; }
    if (lf.parentNode && S.on && flowOn() && desk() && !document.body.classList.contains('mode-grid') && (document.body.classList.contains('cl-lab') || document.body.classList.contains('cl-chase'))) {
      var g = document.querySelector('.shopify-section-group-footer-group');
      if (g && g.offsetHeight > 0) {
        var ft = g.getBoundingClientRect().top, vh = window.innerHeight;
        /* 16 okt (Andrea): het kader eindigt zichtbaar (afgeronde onderkant) 32 px boven de footer, met witruimte ertussen;
           de footer-groep krijgt daarvoor 64 px marge boven (pack.js) */
        if (ft - 32 < vh + 48) v = Math.round(vh - ft + 32);
      }
    }
    if (v === FE.v) return; FE.v = v;
    if (v === null) { lf.style.removeProperty('bottom'); lf.style.removeProperty('visibility'); return; }
    lf.style.setProperty('bottom', v + 'px', 'important');
    /* helemaal onder de footer weggeschoven: geen streepje (rand) laten staan */
    lf.style.visibility = (window.innerHeight - v) - lf.getBoundingClientRect().top < 6 ? 'hidden' : '';
  }
  function footEndLater() { if (FE.raf) return; FE.raf = requestAnimationFrame(function () { FE.raf = 0; footEnd(); }); }
  window.addEventListener('scroll', footEndLater, { passive: true });
  window.addEventListener('resize', footEndLater);
  if (window.ResizeObserver && !FE.ro) { FE.ro = new ResizeObserver(footEndLater); FE.ro.observe(document.documentElement); }
  function flowMode() { var b = document.body.classList; return b.contains('mode-grid') ? 'grid' : b.contains('cl-chase') ? 'chase' : 'feed'; }
  function flowModeCheck() {
    if (!S.on || !flowOn()) { FL.mode = ''; return; }
    footEndLater();
    var m = flowMode(); if (m === FL.mode) return;
    var was = FL.mode; FL.mode = m;
    flowTopSync(); /* Bladeren: enkel de kopbalk staat vast, elders ook de schakelaarrij */
    /* naar Bladeren niet: setView('grid') zet zelf gridTo(0) en restoreSnapshot (Terug na 3D) zet daarna de bewaarde plek */
    if (was && m !== 'grid' && winY() > 0) window.scrollTo(0, 0);
  }
  function flowStart() {
    var de = document.documentElement;
    de.classList.add('cl-flow'); FL.mode = '';
    annSync(); if (window.CW_HDR_MEASURE) try { window.CW_HDR_MEASURE(); } catch (er) { /* negeren */ }
    flowTopSync(); flowModeCheck();
    if (!window.MutationObserver) return;
    /* body-klassen (mode-grid, cl-chase): moduswissel; style van html: page-fit.js zet daar --hdr */
    if (!FL.bo) { FL.bo = new MutationObserver(flowModeCheck); FL.bo.observe(document.body, { attributes: true, attributeFilter: ['class'] }); }
    if (!FL.mo) { FL.mo = new MutationObserver(flowTopSync); FL.mo.observe(de, { attributes: true, attributeFilter: ['style'] }); }
  }
  function flowStop() {
    if (FL.bo) { FL.bo.disconnect(); FL.bo = null; } if (FL.mo) { FL.mo.disconnect(); FL.mo = null; }
    var de = document.documentElement; de.classList.remove('cl-flow'); FL.mode = '';
    ['--cl-flow-top', '--cl-frame-top', '--cl-tabs-bottom', '--cl-ann'].forEach(function (k) { de.style.removeProperty(k); });
    FL.ann = 0; if (HS.ro) { HS.ro.disconnect(); HS.ro = null; HS.shell = null; } hdrShift(true); window.__cwHdrS = 0; footEnd();
    if (window.CW_HDR_MEASURE) try { window.CW_HDR_MEASURE(); } catch (er) { /* negeren */ }
    if (S.lf) S.lf.style.removeProperty('--cl-fy'); DK.fy = 0; DK.fyEl = null;
    var pe = $('#pdpPage'); if (pe) pe.style.removeProperty('transform'); DK.py = 0; DK.pyEl = null;
  }
  window.addEventListener('resize', function () { annSync(); flowTopSync(); hdrShift(true); });

  /* ---------- aan en uit ---------- */
  function fireResize() { try { window.dispatchEvent(new Event('resize')); } catch (e) { /* negeren */ } }
  function teardown() {
    clearInterval(S.timer); S.timer = null; clearTimeout(S.t2); clearTimeout(S.autoT);
    if (S.gridMO) { S.gridMO.disconnect(); S.gridMO = null; } if (MQ.mo) { MQ.mo.disconnect(); MQ.mo = null; } mqCountBack(); MQ.el = null; MQ.sig = ''; MQ.set = null; $$('#gFr').forEach(function (f) { f._mq = false; if (f.parentNode) f.parentNode.classList.remove('cl-end'); }); S.hideSet = null;
    $$('.cl-fabx,.cl-fabtab').forEach(function (n) { n.remove(); }); document.body.classList.remove('cl-fabhid', 'cl-fabout');
    twStop(true); $$('.cl-tawrap').forEach(function (n) { n.remove(); });
    $$('.cl-cdx,#clTa,.cl-stk,.cl-stkcov').forEach(function (n) { n.remove(); }); if (S.stkIO) { S.stkIO.disconnect(); S.stkIO = null; S.stkEl = null; } document.body.classList.remove('cl-stuck'); var ci0 = $('#cin2'); if (ci0) { ci0.removeAttribute('tabindex'); ci0.removeAttribute('aria-hidden'); }
    mqsUnwrap();
    $$('[data-cl-noq],.cl-mq,.cl-pill,.cl-fab,.cl-scrim,.cl-dhead,.cl-mwrap,.cl-bar,.cl-waarop,.cl-all,.cl-startcard,.cl-hits,#hitsPanel,.cl-ai').forEach(function (n) { n.remove(); });
    $$('.cl-hide').forEach(function (n) { n.classList.remove('cl-hide'); });
    $$('#navMenu a').forEach(function (a) { if (a._orig) { a.textContent = a._orig; a._orig = null; } });
    var col = $('.col-r'); if (col) { col.removeAttribute('role'); col.removeAttribute('aria-label'); }
    cartModal(true);
    document.documentElement.classList.remove('cl-on', 'cl-nokader', 'cl-mx', 'cl-m1', 'cl-m2', 'cl-m3', 'cl-m4', 'cl-m5', 'cl-m6', 'cl-m7', 'cl-m8', 'cl-m6a', 'cl-m6b', 'cl-m6c');
    document.body.classList.remove('cl-mx', 'cl-m1', 'cl-m2', 'cl-m3', 'cl-m4', 'cl-m5', 'cl-m6', 'cl-m7', 'cl-m8', 'cl-m6a', 'cl-m6b', 'cl-m6c', 'cl-on', 'cl-cart', 'cl-auto', 'cl-v1', 'cl-v2', 'cl-v3', 'cl-vA', 'cl-vB', 'cl-vC', 'cl-vD', 'cl-vE', 'cl-lab', 'cl-addopen', 'cl-lstart', 'cl-lshow', 'cl-c1', 'cl-c2', 'cl-c3', 'cl-c4', 'cl-c5', 'cl-kies', 'cl-bold', 'cl-brl');
    var pe = $('#clPop'); if (pe) pe.remove(); S.pop = null; S.popA = null;
    document.documentElement.classList.remove('cl-colk'); S.colSt = ''; S.colT0 = 0; S.colRestore = null;
    (function () { var tb = $('#colLTab'); if (tb) { tb.classList.remove('off', 'err'); var tl = $('.lbl', tb); if (tl) tl.textContent = 'LIVE'; } })();
    $$('.cl-fhead').forEach(function (n) { n.remove(); });
    ctlBack(); (function () { var fp = $('#gFilterPanel'); if (fp && fp._clP) { fp._clP.insertBefore(fp, fp._clN || null); fp._clP = null; fp.style.cssText = ''; } $$('.cl-pv').forEach(function (n) { n.remove(); }); })(); pgFollowStop(); $$('[data-cl-sortbtn],.cl-gfind').forEach(function (n) { n.remove(); });
    feedUnlock(); chSync(true); flowStop(); H3.tile = null; cancelAnimationFrame(H3.raf); h3Release(); cardRestore(); if (H3.mh) { H3.mh.remove(); H3.mh = null; } H3.mbusy = false; H3.rect = {}; $$('#gGrid .tile').forEach(function (t) { t._clm = false; }); if (H3.io) { H3.io.disconnect(); H3.io = null; } H3.warm = false; H3.pfn = 0;
    $$('#gGrid .tile .cl-3dh').forEach(function (n) { n.remove(); }); $$('#gGrid .tile').forEach(function (t) { t._cl3 = undefined; });
    clearHide(); S.q = ''; S.qt = []; S.fr = 'all'; S.grp = ''; S.sub = ''; S.lang = '';
    S.pillH = ''; S.pillU = null; S.units = null;
  }
  function tick() {
    if (!S.on || document.hidden || !desk()) return;
    try { avInit(); flowTopSync(); annSync(); hdrShift(true); ensure(); sync(); syncPill(); watchCart(); syncFab(); taSync(); twCheck(); stkSync(); colSync(); feedPos(); pgFollowStart(); if (!S.hashDone) hashApply(); else { restoreGuard(); if (S.hashDone) hashSync(); }
    fgSync(); if (S.hashDone) { feedPos(); if (!S.ready && readyOk()) markReady(); } chSync(); if (mode() === 'all') { var dg = $('#gGrid.g-dense'); if (dg) { var dr = $('#gCard [data-gdense="0"]'); if (dr) dr.click(); } gridChrome(); h3Badges(); /* 3D-label ook zonder hover: 3D zie je bij klikken op het product */ cardStyle(); if (HOVER_3D) { h3Warm(); h3Pump(); } }
    ripStyle(); labFrame(); mPlace(); var inLab = document.body.classList.contains('cl-lab'); if (inLab || S.labWas) { labStartSync(); addSync(); fitFew(); hitsSync(); } S.labWas = inLab; cartRows(); } catch (err) { if (!CLEAN_PROD && window.console) console.warn('[clean]', err); }
  }
  /* html.cl-ready: pas als de eerste opbouw klaar is en de gekozen weergave staat, toont de prod-CSS de middenkolom (tot dan staat hij
     op opacity 0 !important; het vangnet als dit script faalt is een inline timer in de head van de pagina die html.cl-ready na 6 s zet).
     Klaar = gekozen weergave staat, de herstelde filters (franchise, groep, taal, zoekterm) zijn toegepast en de tegels zijn gefilterd. */
  function readyOk() {
    var hp = S.hp, tm = performance.now() - (S.bootT || 0);
    if (tm > 5000) return true; /* niet eindeloos wachten */
    if (!hp || hp.t === 'foreign') return true;
    if (hp.t === 'all') {
      if (mode() !== 'all' || !$('#gGrid .tile')) return false;
      var fs = hp.seg.filter(function (x) { return readGrid().fr.some(function (i) { return i.k !== 'all' && slug(i.l) === x; }); })[0], on = $('#gFr .g-pill.on');
      var cur = on ? slug(on.firstChild && on.firstChild.nodeType === 3 ? on.firstChild.textContent : txt(on)) : '';
      if (fs && cur !== fs) return false;
      if (hp.q && S.q !== String(hp.q).trim()) return false;
      if (S.hideSet === undefined) return false;
      return true;
    }
    if (hp.t === 'lab') return mode() !== 'all' && document.body.classList.contains('cl-lab');
    if (hp.t === 'chase') return mode() !== 'all' && S.ft === 'chase';
    return mode() !== 'all';
  }
  function markReady() { S.ready = true; document.documentElement.classList.add('cl-ready'); }
  function apply(on, boot) {
    teardown(); S.on = !!on; save(S.on); updateSw();
    if (!S.on) { markReady(); fireResize(); return; }
    if (!boot) S.hashDone = true;
    document.documentElement.classList.add('cl-on');
    /* proef zonder kader (11 okt) teruggedraaid: Andrea vond het kader mooier. Opnieuw proberen: document.documentElement.classList.add('cl-nokader'); */
    document.body.classList.add('cl-on'); vClass();
    flowStart(); /* doorlopende pagina: html.cl-flow en --cl-flow-top, zie flowStart */
    /* onder 1100 px doet Clean niets (tick stopt): de middenkolom meteen vrijgeven, nooit op het 6 s-vangnet wachten */
    if (!desk() && !(S.hp && S.hp.t === 'all' && mode() !== 'all') && !(boot && S.hp && S.hp.t === 'chase')) markReady(); /* gsm met Shop als doel: pas vrijgeven na de wissel (boot-poll hieronder), geen flits van Rip Lab */
    else if (!desk() && boot && S.hp && S.hp.t === 'all') S.gridWait = true; /* ook de resize van fireResize hieronder geeft dan nog niet vrij */
    /* gsm met #chase of #chase/<pad> (15 okt): de pagina start in de feed met de startscene (Samenstellen); pas vrijgeven als de Chase-host staat (boot-poll) */
    if (!desk() && boot && S.hp && S.hp.t === 'chase') S.chaseWait = true;
    buildChrome();
    syncPill(); /* ook op gsm, waar tick() stilstaat: de pil toont meteen de stand van het mandje */
    tick();
    S.timer = setInterval(tick, 250);
    fireResize();
  }

  document.addEventListener('input', function (e) {
    var q = e.target && e.target.closest && e.target.closest('[data-cl-q]'); if (!q) return;
    clearTimeout(S.qT); S.qT = setTimeout(function () { setQ(q.value); }, 160);
  });
  document.addEventListener('keydown', function (e) {
    var q = e.target && e.target.closest && e.target.closest('[data-cl-q]');
    if (q && e.key === 'Escape') { var inS = !!q.closest('.cl-stk'); if (q.value || S.q) { q.value = ''; clearTimeout(S.qT); setQ(''); e.stopPropagation(); } if (inS) { stkSearchClose(true); e.stopPropagation(); } }
  }, true);
  function stkSearchClose(focusBtn) {
    var sk = $('.cl-stk'); if (!sk) return;
    sk.classList.remove('s-open'); var sb = $('[data-cl-stks]', sk); if (sb) { sb.setAttribute('aria-expanded', 'false'); if (focusBtn) try { sb.focus(); } catch (e) { /* negeren */ } }
  }
  function setQ(v) {
    v = String(v || '').trim();
    if (v === S.q) return;
    qSet(v);
    if (!desk()) { mqSync(); return; } /* gsm: Clean-tick staat stil, het zoekveld van kaart 2 filtert zelf, zie mqApply */
    sync(); settle();
  }
  document.addEventListener('click', onClick);
  document.addEventListener('pointerdown', function (e) {
    if (S.on && cartOpen() && e.target.closest && e.target.closest('.col-r')) stickCart();
  });
  document.addEventListener('focusin', function (e) {
    if (S.on && cartOpen() && e.target.closest && e.target.closest('.col-r')) stickCart();
  });
  /* Escape: staat er een Clean-paneel of dropdown open, dan sluit het bovenste en stoppen we de gebeurtenis in de capture-fase, zodat de
     Escape-afhandeling van de pagina (Shop terug naar de feed, CARDIX, enz.) niet meeloopt. Volgorde: dropdown, Filters-paneel, zoekveld in de balk,
     CARDIX, mandjelade. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !S.on) return;
    var hit = false, fb = $('#gFiltersBtn'), stk = $('.cl-stk'), lm = $('[data-cl-langmenu]');
    if (S.pop) { var pa0 = S.popA; closePop(); hit = true; if (pa0 && pa0.isConnected) { var pb0 = pa0.tagName === 'BUTTON' ? pa0 : (pa0.querySelector ? pa0.querySelector('button') : null); if (pb0) try { pb0.focus(); } catch (er) { /* negeren */ } } }
    else if (lm && !lm.hidden) { closeLangMenu(); hit = true; }
    else if (fb && fb.getAttribute('aria-expanded') === 'true' && $('#gFilterPanel.open')) { fb.click(); hit = true; try { (stkOn() ? $('[data-cl-stkf]') : fb).focus(); } catch (er2) { /* negeren */ } }
    else if (stk && stk.classList.contains('s-open')) { var qs = $('[data-cl-q]', stk); if (qs) qs.value = ''; clearTimeout(S.qT); if (S.q) setQ(''); stkSearchClose(true); hit = true; }
    else if (cdxOpen()) { closeCardix(); var fb2 = $('.cl-fab'); if (fb2) try { fb2.focus(); } catch (er3) { /* negeren */ } hit = true; }
    else if (cartOpen() && !$('.sheet.on, .ov.on, .cw-confirm-ov')) { closeCart(); var pl = $('.cl-pill'); if (pl) try { pl.focus(); } catch (er4) { /* negeren */ } hit = true; }
    if (hit) { e.stopImmediatePropagation(); e.preventDefault(); }
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && S.on) S.cdxWas = cdxOpen(); }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && S.on && S.cdxWas) { S.cdxWas = false; cdxFinish(); cdxOut(); var fb1 = $('.cl-fab'); if (fb1) try { fb1.focus(); } catch (er) { /* negeren */ } }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && S.on) { var pa = S.popA; closeLangMenu(); closePop(); if (pa && pa.isConnected) { var pb2 = pa.tagName === 'BUTTON' ? pa : (pa.querySelector ? pa.querySelector('button') : null); if (pb2) try { pb2.focus(); } catch (er2) { /* negeren */ } } }
    if (S.on && S.pop && (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Home' || e.key === 'End')) {
      var its = $$('#clPop button'); if (its.length) {
        e.preventDefault();
        var ix = its.indexOf(document.activeElement);
        ix = e.key === 'Home' ? 0 : e.key === 'End' ? its.length - 1 : e.key === 'ArrowDown' ? (ix + 1) % its.length : (ix <= 0 ? its.length - 1 : ix - 1);
        its[ix].focus();
      }
    }
    if (S.on && S.pop && e.key === 'Tab') closePop();
    /* C2: pijltjes links en rechts tussen de groep-tabs */
    if (S.on && (e.key === 'ArrowLeft' || e.key === 'ArrowRight') && document.activeElement && document.activeElement.closest) {
      var th = document.activeElement.closest('[data-cl-cseg2]');
      if (th) { var tb = $$('[data-cl-ctab]', th), ti = tb.indexOf(document.activeElement); if (ti > -1 && tb.length > 1) { e.preventDefault(); tb[(ti + (e.key === 'ArrowRight' ? 1 : tb.length - 1)) % tb.length].focus(); } }
    }
    if (e.key !== 'Escape' || !S.on || !cartOpen()) return;
    if ($('.sheet.on, .ov.on, .cw-confirm-ov')) return; /* eerst het bovenste venster, dat regelt de pagina zelf */
    closeCart();
    var p = $('.cl-pill'); if (p) try { p.focus(); } catch (er) { /* negeren */ }
  });
  document.addEventListener('scroll', function (e) { if (S.on && e.target && e.target.id === 'feed') feedPos(); }, true);
  /* pijltjestoetsen binnen de wissel: focus naar de vorige of volgende optie (Enter of spatie kiest) */
  document.addEventListener('keydown', function (e) {
    if (!S.on || (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight' && e.key !== 'Home' && e.key !== 'End') || !e.target.closest) return;
    var seg = e.target.closest('.cl-mseg'); if (!seg) return;
    var bs = $$('button', seg).filter(function (b) { return !b.hidden; }), i = bs.indexOf(e.target.closest('button')); if (i < 0) return;
    var j = e.key === 'Home' ? 0 : e.key === 'End' ? bs.length - 1 : (i + (e.key === 'ArrowRight' ? 1 : -1) + bs.length) % bs.length;
    e.preventDefault(); bs[j].focus();
  });
  /* de kader volgt de modus in hetzelfde frame: na elke klik (de pagina wisselt in zijn eigen handler), hashchange en popstate meteen opnieuw bepalen */
  ['click', 'hashchange', 'popstate'].forEach(function (ev) { (ev === 'click' ? document : window).addEventListener(ev, function () { if (!S.on) return; feedPos(); requestAnimationFrame(function () { feedPos(); chSync(); }); }, ev === 'click'); });
  document.addEventListener('scroll', function (e) { if (S.on) placeFP(); if (S.keep && gsEvt(e)) restoreScroll(); }, true);
  /* 17 okt (Andrea: gsm, Terug-knop op een product sprong de Shop naar boven): stkSync zet na het sluiten S.gTop terug, maar op gsm draait tick() niet,
     dus S.gTop was de stand van lang geleden (vaak 0). Nu bij elke scroll van het raster bijhouden zolang er geen product openstaat. */
  document.addEventListener('scroll', function (e) { if (!S.on || !gsEvt(e) || mode() !== 'all' || document.body.classList.contains('pg-open') || $('#pdpSheet.on')) return; S.gTop = gsTop(); }, { capture: true, passive: true });
  document.addEventListener('scroll', function (e) { if (S.on && S.pop && gsEvt(e) && mode() === 'all') closePop(); }, true);
  /* niet zolang de boot-poll op gsm nog naar Shop wisselt (S.gridWait): een resize (werkbalk van iOS) zou anders Samenstellen even tonen */
  window.addEventListener('resize', function () { if (S.on && !desk() && !S.ready && !S.gridWait && !S.chaseWait) markReady(); if (S.on && !desk() && !mqOn() && (S.hideSet || S.hiding)) { S.hideSet = null; clearHide(); } if (S.on) { S.stkTW = 0; var sk0 = $('.cl-stk'); if (sk0) sk0.classList.remove('cl-stk-c'); sync(); placePop(); placeFP(); } });

  /* ---------- modus 8, onder 1100 px: dezelfde wissel als vaste balk bovenaan, net onder de kopbalk (.cl-mbar) ----------
     Staat los van Clean aan/uit en van tick(): eigen opbouw, eigen klikken, eigen poll (400 ms, alleen onder 1100 px en met zichtbaar tabblad).
     Stuurt exact dezelfde echte weergaven aan als op desktop: Shop = de originele knop [data-view="grid"], Rip Lab en Chase zoeken = [data-view="feed"],
     daarna de feed op de builderscene (Rip Lab) of de host van Chase zoeken (chSync). Kiest de bezoeker een andere manier, dan schrijft mbHash de hash
     (pushState), zodat Terug en Vooruit ook hier tussen de manieren werken (mbHashApply). De balk reserveert zijn plaats via html.cl-mb (--mb-h, zie css):
     --top-h groeit met de balkhoogte, dus de categorierij, de scenes, het raster, de productpagina en de PiP schuiven mee omlaag. De mandjebalk
     onderaan is weg: het mandje is de pil rechtsboven in de kopbalk (openCartM, css). De originele weergavewissel bovenaan is dan verborgen. */
  var MB = { el: null, t: 0, cur: '' };
  var mbSmall = function () { return window.matchMedia && window.matchMedia('(max-width:1099px)').matches; };
  var mbReduce = function () { return window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches; };
  /* deeplink (?p= of #p=): na het sluiten van de productpagina eenmalig naar Bladeren, niet in Samenstellen landen */
  function fgSync() {
    if (!S.fgGrid) return;
    if (S.userAct || MB.touched) { S.fgGrid = false; return; }
    if (document.body.classList.contains('pg-open') || $('#pdpSheet.on')) { S.fgSeen = true; return; }
    if (!S.fgSeen) return;
    S.fgGrid = false;
    if (mode() !== 'all') { var gb = $('.viewseg [data-view="grid"]'); if (gb) gb.click(); }
  }
  function mbCur() { return shownView(); }
  /* Bladeren (onder 1100 px): de modusbalk blijft staan (sticky, 16 okt), enkel zonder cl-flow scrolt ze mee weg; in Rip Lab blijft ze altijd staan */
  function mbSlide() {
    var el = MB.el; if (!el) return;
    var sc = $('#gScroll'), h = el.offsetHeight, y = 0;
    if (!h) return; /* balk verborgen (productpagina open, desktop): laatste stand bewaren */
    /* 16 okt (Andrea: "de modusbalk moet ook sticky zijn op gsm"): met cl-flow (Clean aan) blijft de balk in Bladeren staan, net als in Samenstellen
       en Chase zoeken; de zoekrij (.cl-mqs, sinds 16 okt enkel filterknop + zoekveld) plakt eronder (css: --cl-flow-top in Bladeren = hdr + mb-h). Zonder cl-flow
       scrolt ze nog mee weg met #gScroll zoals voordien. */
    if (h && mbSmall() && mode() === 'all' && sc && !flowOn()) y = Math.max(0, Math.min(gsTop(), h));
    if (MB.y === y && MB.h === h) return;
    MB.y = y; MB.h = h;
    el.style.transform = y ? 'translate3d(0,' + (-y) + 'px,0)' : '';
    el.style.visibility = y && y >= h ? 'hidden' : '';
  }
  /* 18 okt (Andrea, iPhone: de modusbalk bleef soms midden in het scherm hangen): de balk staat op top: var(--hdr) plus de verschuiving van de
     aankondigingsbalk (hdrShift). Na een programmatische scroll, het toetsenbord (visualViewport) of een gesloten blad kon die stand achterlopen op de
     echte kop. Controle: ligt de bovenrand van de balk niet exact op de onderrand van de kop, dan eerst --hdr en hdrShift opnieuw, en wat dan nog
     verschilt corrigeert margin-top (los van top en translate, die de rest van de laag beheert). */
  function mbFix() {
    var el = MB.el, hw = hdrWrap(); if (!el || !hw || !el.offsetHeight || !mbSmall()) return;
    var want = Math.max(0, Math.round(hw.getBoundingClientRect().bottom)), r = el.getBoundingClientRect();
    if (Math.abs(r.top - want) <= 1.5) return;
    try { if (window.CW_HDR_MEASURE) window.CW_HDR_MEASURE(); hdrShift(true); } catch (e) { /* negeren */ }
    r = el.getBoundingClientRect(); var d = want - r.top;
    if (Math.abs(d) > 1.5) { var m0 = parseFloat(el.style.marginTop) || 0; el.style.marginTop = Math.round(m0 + d) + 'px'; }
  }
  var mbFixSoon = function () { if (MB.fixRaf) return; MB.fixRaf = requestAnimationFrame(function () { MB.fixRaf = 0; mbFix(); }); };
  if (window.visualViewport) { window.visualViewport.addEventListener('resize', mbFixSoon); window.visualViewport.addEventListener('scroll', mbFixSoon); }
  window.addEventListener('scroll', function () { clearTimeout(MB.fixT); MB.fixT = setTimeout(mbFix, 120); }, { passive: true });
  ['touchend', 'focusout', 'resize', 'pageshow'].forEach(function (ev) { window.addEventListener(ev, function () { setTimeout(mbFix, 60); setTimeout(mbFix, 400); }, { passive: true }); });
  window.CW_MB_FIX = mbFix;
  function mbSync() {
    var el = MB.el; if (!el) return;
    mbSlide(); mbFix();
    var c = mbCur();
    if (c !== MB.cur) {
      MB.cur = c;
      $$('button', el).forEach(function (b) { var on = b.getAttribute('data-cl-mv') === c; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      el.style.setProperty('--i', c === 'grid' ? 0 : c === 'lab' ? 1 : 2);
    }
    $$('button', el).forEach(function (b) {
      var v = b.getAttribute('data-cl-mv'), t = $('.cl-t', b), want = v === 'live' ? MODI.live.m[lang()] : modiK(v);
      if (t && t.textContent !== want) t.textContent = want;
      if (v !== 'live') { var al = modiN(v) + (v === 'lab' && $('.cl-new', b) ? ', ' + DSL.nw[lang()] : ''); if (b.getAttribute('aria-label') !== al) b.setAttribute('aria-label', al); }
      if (v === 'live' && b.getAttribute('aria-label') !== MODI.live.a[lang()]) { b.setAttribute('aria-label', MODI.live.a[lang()]); b.title = MODI.live.a[lang()]; }
    });
    avInit(); liveSync(); fgSync(); chSync(); mbHash();
    var fa = $('.cl-fabm'); if (fa) { var ex = cdxOpen() ? 'true' : 'false'; if (fa.getAttribute('aria-expanded') !== ex) fa.setAttribute('aria-expanded', ex); }
    if (el.getAttribute('aria-label') !== modiG()) el.setAttribute('aria-label', modiG());
  }
  function mbPlace(smooth) {
    var f = $('#feed'); if (!f) return;
    /* cl-flow: #feed scrolt niet meer, de Rip Lab-scene staat bovenaan de pagina (het venster gaat bij een moduswissel al naar boven, flowMode) */
    if (flowOn()) return;
    var want = labTop();
    if (want == null) return;
    if (smooth && !mbReduce() && f.scrollTo) { try { f.scrollTo({ top: want, behavior: 'smooth' }); return; } catch (er) { /* terugval hieronder */ } }
    f.scrollTop = want;
  }
  function mbGo(v) {
    var wasGrid = mode() === 'all'; MB.touched = true;
    if (v !== 'grid') S.ft = v;
    var vb = $('.viewseg [data-view="' + (v === 'grid' ? 'grid' : 'feed') + '"]');
    if (vb) vb.click();
    mbSlide(); mbSync();
    if (v !== 'lab') { setTimeout(mbSync, 60); return; }
    /* na de wissel kan de pagina de feed nog opbouwen: de plek meerdere keren vastleggen (herhaalbaar, zonder effect als hij al klopt) */
    [0, 120, 360].forEach(function (d) { setTimeout(function () { mbPlace(!wasGrid && d === 0); mbSync(); }, d); });
  }

  /* hash onder 1100 px: de gekozen manier in de URL (#shop met filterstand blijft staan, #riplab, #chase). Push enkel na een eigen keuze van de bezoeker
     en als de manier verandert (MB.hMode = de manier van de laatst geschreven hash), anders replaceState; productpagina en deeplinks (#p=) blijven ongemoeid. */
  /* gsm: de interne shophash uit de toestand van het raster van de pagina (#gFr, #gChain), zelfde vorm als hashWant */
  function mbGridHash() {
    var parts = [], fo = $('#gFr .g-pill.on'), co = $('#gChain [data-gcat][aria-selected="true"]'), lo = $('#gChain [data-glang][aria-selected="true"]');
    if (fo) parts.push(slug(fo.getAttribute('data-gfr')));
    if (co) parts.push(slug(co.getAttribute('data-gcat')));
    if (lo) parts.push(langSlug(lo.getAttribute('data-glang')));
    return '#shop' + (parts.length ? '/' + parts.join('/') : '') + (S.q ? '?q=' + encodeURIComponent(S.q) : '');
  }
  function mbHash() {
    if (desk() || !S.on || document.body.classList.contains('pg-open') || $('#pdpSheet.on')) return;
    if (S.fgGrid && !S.fgSeen) return; /* productlink bij het opstarten: zie hashSync (16 okt) */
    if (!S.ready) return; /* 16 okt: pas na het opstarten; tot dan stond de gsm-pagina even in Samenstellen en schreef dit /pages/samenstellen in het adres */
    var pr = parseHash(locHash()); if (pr && pr.t === 'foreign') return;
    /* opstart met #chase/<pad> (15 okt): zolang chase.js de stap nog niet heeft hersteld (S.chaseWait) de diepe hash niet overschrijven, ook niet
       met #samenstellen van de tussenstand (de pagina start in de feed); anders landt een refresh op de chase-start */
    if (S.chaseWait && pr && pr.t === 'chase') return;
    /* Chase zoeken schrijft zelf een hash per stap (#chase/...; ook op desktop, zie hashWant): die laten staan */
    /* Shop: de filterstand van het raster zelf (franchise, categorie, taal en zoekterm van de pagina; de Clean-tick staat hier stil), als echte
       filterparameters (urlOf). Niet tijdens de opstart (wissel naar Shop, filters uit het adres nog niet gezet), anders gaan die verloren. */
    var mt = modeT(), urlT = urlMode(pr);
    if (popHold(urlT, mt)) return; /* Terug of Vooruit: mbHashApply zet de weergave nog om (MB.touched komt dan ook uit mbGo, geen eigen keuze) */
    if (mt === 'all' && (S.gridWait || S.mfBusy)) return;
    var want = mt === 'all' ? mbGridHash() : mt === 'chase' ? (pr && pr.t === 'chase' ? location.hash : '#chase') : '#samenstellen';
    var url = urlOf(want);
    if (locUrl() === url) { MB.hMode = mt; return; }
    var push = (MB.touched || S.userAct) && urlT !== mt;
    try { history[push ? 'pushState' : 'replaceState'](hState(), '', url); } catch (e) { /* negeren */ }
    MB.hMode = mt;
  }
  /* Terug of Vooruit onder 1100 px: de manier uit de hash toepassen (geen hash = Bladeren) */
  /* gsm: de filters uit een #shop-hash of collectielink (S.hp.seg, S.hp.q) ook hier toepassen. De Clean-tick staat onder 1100 px stil, dus hashApply
     hier zelf een paar keer draaien tot de franchise, categorie en taal staan (max 4 s; stopt zodra de bezoeker zelf iets doet) */
  function mbFiltApply() {
    var hp = S.hp; if (desk() || !S.on || !hp || hp.t !== 'all' || (!hp.seg.length && !hp.q)) return;
    S.hashDone = false; S.applyT0 = 0; S.mfBusy = true; /* mbHash schrijft het adres pas als de filters staan */
    var n = 0, iv = setInterval(function () {
      n++;
      if (desk()) { clearInterval(iv); S.applyT0 = 0; S.mfBusy = false; return; } /* naar desktop gedraaid: tick maakt het herstel zelf af */
      if (MB.touched || S.userAct || n > 20) { clearInterval(iv); S.hashDone = true; S.applyT0 = 0; S.mfBusy = false; return; }
      try { hashApply(); } catch (er) { /* negeren */ }
      if (S.hashDone) { clearInterval(iv); S.mfBusy = false; try { mbHash(); } catch (er) { /* negeren */ } }
    }, 200);
  }
  function mbHashApply() {
    if (!MB.el || document.body.classList.contains('pg-open')) return;
    var pr = parseHash(locHash()); if (pr && pr.t === 'foreign') return;
    var want = !pr || pr.t === 'all' ? 'grid' : pr.t;
    MB.hMode = !pr ? 'all' : pr.t;
    if (want !== mbCur()) mbGo(want);
  }

  /* ---------- gsm en tablet, Bladeren: kaart 2 (filterknop + zoekveld) zoals cardworld.be/collections/all ----------
     Onder 1100 px staat de Clean-tick stil en bestaat het desktop-zoekveld niet. Kaart 2 (.cl-mq) komt na #gCard; de filterknop klikt de Filters-knop van de
     pagina door (die is in de kaart verborgen); het zoekveld hergebruikt de zoekstate van desktop (S.q / S.qt, qSet, qOk, hideNew, .cl-noq), dus dezelfde treffers,
     "Geen resultaten" en "Zoekopdracht wissen". mqSync draait op de gsm-poll (400 ms) en na elke klik. */
  var MQ = { el: null, mo: null, sig: '', cnt: 0, set: null, pc: null, pl: null };
  var mqL = { f: { nl: 'Filters', fr: 'Filtres', en: 'Filters' }, c: { nl: 'Zoekopdracht wissen', fr: 'Efface la recherche', en: 'Clear search' },
    n: { nl: 'Geen resultaten voor', fr: 'Aucun résultat pour', en: 'No results for' }, u1: { nl: 'product', fr: 'produit', en: 'product' }, u: { nl: 'producten', fr: 'produits', en: 'products' } };
  var mqOn = function () { return !desk() && mode() === 'all' && !!S.qt.length && !!loadP(); };
  function mqInit() {
    if (MQ.el && MQ.el.isConnected) return;
    var gc = $('#gCard'); if (!gc || !gc.parentNode) return;
    var el = document.createElement('div'); el.className = 'cl-mq cl-scope'; el.setAttribute('data-cl-mq', '');
    el.innerHTML = '<button type="button" class="cl-mqf" data-cl-mqf aria-haspopup="true" aria-controls="gFilterPanel" aria-expanded="false" aria-label="' + esc(mqL.f[lang()]) + '"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg><span class="cl-mqb" data-cl-mqb hidden></span></button>' +
      '<div class="cl-swrap"><div class="cl-sinner"><svg class="cl-sic" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>' +
      '<input type="search" class="cl-sinput" data-cl-q placeholder="' + esc(shopPh()) + '" autocomplete="off" autocorrect="off" enterkeyhint="search" aria-label="' + esc(shopPh()) + '">' +
      '<span class="cl-mqn" data-cl-mqn aria-hidden="true"></span>' +
      '<button type="button" class="cl-sclear" data-cl-sclear aria-label="' + esc(mqL.c[lang()]) + '"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg></button></div></div>';
    gc.parentNode.insertBefore(el, gc.nextSibling);
    MQ.el = el;
    /* nieuwe of herordende tegels (lui bijladen, franchise-/sorteerwissel van de pagina): meteen verbergen, nog voor het tekenen */
    var gd = $('#gGrid');
    if (gd && window.MutationObserver && !MQ.mo) {
      MQ.mo = new MutationObserver(function () {
        if (desk() || !S.on) return;
        try { if (mqOn()) hideNew(); else if (S.hiding || $('#gGrid .tile.cl-gh')) { S.hideSet = null; clearHide(); } } catch (er) { /* negeren */ }
      });
      MQ.mo.observe(gd, { childList: true });
    }
  }
  /* 10 okt (Andrea): kaart 1 + kaart 2 in een plakkende wikkel (.cl-mqs). Bij het scrollen blijft de franchiserij (met keten en actieve filters) samen met de
     zoekkaart bovenaan staan; de kop van kaart 1 scrolt weg. --cl-gtop = afstand wikkelbovenkant tot franchiserij, --cl-sh = hoogte van de geplakte strook (op
     #gScroll, voor sticky top en scroll-padding). Gemeten met een ResizeObserver, nooit per scrollframe. De klasse .cl-mqs-on (witte strook) volgt uit een
     IntersectionObserver op een meetpuntje (.cl-mqs-s) dat op de natuurlijke plek van de wikkel staat. app.js verplaatst #gCard niet en zoekt hem op id. */
  var MQS = { el: null, s: null, ro: null, io: null, gt: -1, raf: 0 };
  function mqsWrap() {
    var gc = $('#gCard'), mq = MQ.el, sc = $('#gScroll'); if (!gc || !mq || !sc || !gc.parentNode || !window.ResizeObserver || !window.IntersectionObserver) return;
    if (MQS.el && MQS.el.isConnected && gc.parentNode === MQS.el && mq.parentNode === MQS.el) return;
    if (!MQS.el || !MQS.el.isConnected || !MQS.s || !MQS.s.isConnected) {
      MQS.el = document.createElement('div'); MQS.el.className = 'cl-mqs';
      MQS.s = document.createElement('div'); MQS.s.className = 'cl-mqs-s'; MQS.s.setAttribute('aria-hidden', 'true');
      gc.parentNode.insertBefore(MQS.s, gc); gc.parentNode.insertBefore(MQS.el, gc);
    }
    if (gc.parentNode !== MQS.el) MQS.el.appendChild(gc);
    if (mq.parentNode !== MQS.el) MQS.el.appendChild(mq);
    if (MQS.ro) MQS.ro.disconnect();
    MQS.ro = new ResizeObserver(function () { cancelAnimationFrame(MQS.raf); MQS.raf = requestAnimationFrame(mqsFit); });
    MQS.ro.observe(gc); MQS.ro.observe(mq); MQS.ro.observe(MQS.el);
    MQS.gt = -1; mqsFit();
  }
  function mqsFit() {
    /* 16 okt (Andrea: "veel te druk en veel te hoog"): de wikkel plakt nu op de zoekkaart (.cl-mq), niet meer op de franchiserij. Franchisetabs,
       Kies categorie/taal en Wis filters scrollen gewoon mee weg achter de modusbalk; geplakt blijven enkel modusbalk en de rij filterknop + zoekveld.
       --cl-gtop = afstand wikkelbovenkant tot de zoekkaart, de rest (strook, rootMargin, --cl-sh) rekent daar vanzelf mee. */
    var w = MQS.el, sc = $('#gScroll'), row = MQ.el;
    if (!w || !w.isConnected || !sc || !row || !row.offsetParent || row.offsetParent !== w) return;
    /* geplakte afstand tot de bovenrand: 8 px (16 okt, Andrea: compacter; was 14 px met cl-flow), gelijk aan de css van .cl-mqs */
    var gap = 8, gt = row.offsetTop, sh = w.offsetHeight - gt + gap + 6;
    if (!(gt > 0) || !(sh > 0)) return;
    if (sc.style.getPropertyValue('--cl-gtop') !== gt + 'px') sc.style.setProperty('--cl-gtop', gt + 'px');
    if (sc.style.getPropertyValue('--cl-sh') !== sh + 'px') sc.style.setProperty('--cl-sh', sh + 'px');
    /* cl-flow: het venster is de scroller; --cl-sh ook op html voor de scroll-padding van het venster, en de root van de waarnemer is het venster
       met de bovenrand op de sticky bovenkant (--cl-flow-top, de onderrand van de vaste modusbalk) */
    var fl = flowOn(), ft = fl ? flowTopPx() : 0, de = document.documentElement;
    if (fl && de.style.getPropertyValue('--cl-sh') !== sh + 'px') de.style.setProperty('--cl-sh', sh + 'px');
    var key = gt + '|' + (fl ? 'f' + ft : 'g');
    if (key === MQS.gt && MQS.io) return;
    MQS.gt = key;
    if (MQS.io) MQS.io.disconnect();
    /* de wikkel plakt zodra haar bovenkant 8 - gt boven de scrollerrand komt; het puntje is dan uit beeld (rootMargin vergroot de root naar boven) */
    MQS.io = new IntersectionObserver(function (es) {
      var e = es[es.length - 1]; if (e && MQS.el) MQS.el.classList.toggle('cl-mqs-on', !e.isIntersecting && e.boundingClientRect.top < (e.rootBounds ? e.rootBounds.top : 0));
    }, { root: fl ? null : sc, rootMargin: (gt - gap - ft) + 'px 0px 0px 0px', threshold: 0 });
    MQS.io.observe(MQS.s);
  }
  function mqsUnwrap() {
    if (MQS.ro) { MQS.ro.disconnect(); MQS.ro = null; } if (MQS.io) { MQS.io.disconnect(); MQS.io = null; } cancelAnimationFrame(MQS.raf);
    var w = MQS.el, gc = $('#gCard'), sc = $('#gScroll');
    if (w && w.parentNode) { var mq = MQ.el; if (gc && gc.parentNode === w) w.parentNode.insertBefore(gc, w); if (mq && mq.parentNode === w) w.parentNode.insertBefore(mq, w); w.remove(); }
    if (MQS.s) { MQS.s.remove(); } MQS.el = null; MQS.s = null; MQS.gt = -1;
    if (sc) { sc.style.removeProperty('--cl-gtop'); sc.style.removeProperty('--cl-sh'); }
    document.documentElement.style.removeProperty('--cl-sh');
  }
  function mqEnd() {
    var f = $('#gFr'), rw = f && f.parentNode; if (!rw) return;
    if (!f._mq) { f._mq = true; f.addEventListener('scroll', mqEnd, { passive: true }); }
    rw.classList.toggle('cl-end', f.scrollWidth - f.clientWidth - f.scrollLeft <= 4);
  }
  /* zoeken op gsm: tegels verbergen die niet bij de zoekterm passen (zelfde regel als desktop, sync), teller en melding "Geen resultaten" */
  function mqApply() {
    var nq = $('[data-cl-noq]'), ce = $('#gCount'), cl = $('#gCountL');
    if (!mqOn()) {
      if (S.hideSet || S.hiding) { S.hideSet = null; clearHide(); }
      MQ.sig = ''; MQ.set = null; if (nq) nq.hidden = true;
      mqCountBack();
      return;
    }
    var P = loadP(), on = $('#gFr .g-pill.on'), fr = on ? on.getAttribute('data-gfr') : 'all', real = readReal();
    var sig = S.q + '|' + fr + '|' + (real ? real.cat + '|' + real.lang : '');
    if (sig !== MQ.sig || S.hideSet !== MQ.set) {
      var set = null, allowed = {}, cnt = 0;
      if (real && real.cat) { set = {}; set[real.cat] = 1; }
      P.forEach(function (p) { if ((fr === 'all' || p.sfr === fr) && (!set || inCats(p, set)) && (!real || !real.lang || p.slang === real.lang) && qOk(p)) { allowed[p.t] = 1; cnt++; } });
      MQ.sig = sig; MQ.cnt = cnt; MQ.set = allowed; S.moreN = 0; S.hideSet = allowed; S.hiding = true; hideNew();
    }
    /* de paneelfilters van de pagina (prijs, beschikbaarheid) kent allowed niet: lege uitkomst en teller halen we uit de DOM */
    var vis = $$('#gGrid .tile:not(.cl-gh)').length, more = $('#gMore:not([hidden])');
    var nqOn = !MQ.cnt || (!vis && (!more || (S.moreN || 0) >= 12));
    var shown = !more ? vis : MQ.cnt; if (nqOn) shown = 0;
    if (ce) {
      if (ce.textContent !== String(shown)) { MQ.pc = ce.textContent; ce.textContent = shown; }
      if (cl) { var ul = shown === 1 ? mqL.u1[lang()] : mqL.u[lang()]; if (cl.textContent !== ul) { MQ.pl = cl.textContent; cl.textContent = ul; } }
    }
    var gg = $('#gGrid');
    if (nqOn && !nq && gg) { nq = document.createElement('div'); nq.className = 'cl-noq cl-scope'; nq.setAttribute('data-cl-noq', ''); nq.setAttribute('role', 'status'); gg.parentNode.insertBefore(nq, gg); }
    if (nq) {
      nq.hidden = !nqOn;
      if (nqOn) { var nh = '<p>' + esc(mqL.n[lang()]) + ' \u201c' + esc(S.q) + '\u201d</p><button type="button" class="cl-noqx" data-cl-noqx>' + esc(mqL.c[lang()]) + '</button> <button type="button" class="cl-noqx cl-noqp" data-cl-noqp>' + esc(DSL.pk[lang()]) + '</button>'; if (nq._h !== nh) { nq._h = nh; nq.innerHTML = nh; } }
    }
  }
  /* lege zoekterm: teller en label terug naar wat de pagina zelf had gezet (de pagina schrijft ze bij elke render opnieuw) */
  function mqCountBack() {
    var ce = $('#gCount'), cl = $('#gCountL');
    if (MQ.pc !== null && ce) ce.textContent = MQ.pc; if (MQ.pl !== null && cl) cl.textContent = MQ.pl;
    MQ.pc = null; MQ.pl = null;
  }
  /* 16 okt (Andrea): de franchiserij op gsm in de tabvorm van desktop (css), met "Alles" vooraan zoals op desktop. De pagina zelf heeft geen Alles-pil
     (de actieve pil nog eens aantikken = uit), dus Clean zet een eigen knop vooraan in #gFr. Geen .g-pill en geen data-gfr: readGrid, mqApply, de hash
     en de klikhandler van de pagina tellen hem niet mee. De pagina herschrijft #gFr bij elke filterwissel (innerHTML): een MutationObserver (enkel
     childList van #gFr zelf) zet de knop meteen terug, nog voor het tekenen. Tik = de actieve franchisepil van de pagina aanklikken (= Alles). */
  var MQA = { fr: null, mo: null };
  function mqAll() {
    var fr = $('#gFr'); if (!fr || desk() || !S.on) return;
    if (MQA.fr !== fr) {
      if (MQA.mo) MQA.mo.disconnect();
      MQA.fr = fr; MQA.mo = window.MutationObserver ? new MutationObserver(function () { try { mqAll(); } catch (er) { /* negeren */ } }) : null;
      if (MQA.mo) MQA.mo.observe(fr, { childList: true });
    }
    var b = $('[data-cl-gfa]', fr);
    if (!b) {
      b = document.createElement('button'); b.type = 'button'; b.className = 'cl-gfa'; b.setAttribute('data-cl-gfa', '');
      b.innerHTML = '<span class="cl-gfal"></span><span class="n"></span>';
    }
    if (fr.firstChild !== b) fr.insertBefore(b, fr.firstChild);
    var ps = $$('.g-pill', fr), on = !ps.some(function (p) { return p.classList.contains('on'); });
    var n = ps.reduce(function (a, p) { return a + (+txt($('.n', p)) || 0); }, 0), l = LB('all');
    var bl = $('.cl-gfal', b), bn = $('.n', b);
    if (bl && bl.textContent !== l) bl.textContent = l;
    if (bn && bn.textContent !== String(n)) bn.textContent = String(n);
    if (b.classList.contains('on') !== on) b.classList.toggle('on', on);
    if (b.getAttribute('aria-pressed') !== String(on)) b.setAttribute('aria-pressed', String(on));
  }
  document.addEventListener('click', function (e) {
    var b = S.on && e.target && e.target.closest && e.target.closest('[data-cl-gfa]'); if (!b) return;
    var on = $('#gFr .g-pill.on'); if (on) on.click();
    try { mqAll(); } catch (er) { /* negeren */ }
  });
  function mqSync() {
    if (!S.on || desk() || !document.body) return;
    mqInit(); var el = MQ.el; if (!el) return;
    try { mqsWrap(); } catch (er) { /* negeren */ }
    try { mqAll(); } catch (er) { /* negeren */ }
    var q = $('[data-cl-q]', el);
    if (q && document.activeElement !== q && q.value !== S.q) q.value = S.q;
    /* placeholder volgt de gekozen franchise: "Zoek One Piece" / "Rechercher One Piece" / "Search One Piece", anders "Zoek in de shop" */
    var onp = $('#gFr .g-pill.on'), fcn = onp && onp.firstChild, fl = onp ? (fcn && fcn.nodeType === 3 ? fcn.textContent : txt(onp)).trim() : '';
    if (fl) fl = andere(fl); /* Other TCG en Pokémon in de taal van de pagina (LBL.oth) */
    var ph = fl ? { nl: 'Zoek ', fr: 'Rechercher ', en: 'Search ' }[lang()] + fl : shopPh();
    if (q && q.placeholder !== ph) { q.placeholder = ph; q.setAttribute('aria-label', ph); }
    var fb = $('#gFiltersBtn'), mf = $('[data-cl-mqf]', el), bd = $('[data-cl-mqb]', el);
    if (mf && fb) {
      var ex = fb.getAttribute('aria-expanded') === 'true' ? 'true' : 'false'; if (mf.getAttribute('aria-expanded') !== ex) mf.setAttribute('aria-expanded', ex);
      var fc = $('#gFCount'), n = fc && !fc.hidden ? txt(fc) : '';
      if (bd && bd.textContent !== n) bd.textContent = n;
      if (bd && bd.hidden !== !n) bd.hidden = !n;
      var al = mqL.f[lang()] + (n ? ' (' + n + ')' : ''); if (mf.getAttribute('aria-label') !== al) mf.setAttribute('aria-label', al);
      mf.classList.toggle('on', !!n);
    }
    /* 11 okt (Andrea): de kop van kaart 1 (teller, titel, sortering) is op gsm weg (css); het aantal staat klein in de zoekbalk, sorteren in het filterpaneel */
    var gcn = $('#gCount'), mqn = $('[data-cl-mqn]', el), nn = gcn ? txt(gcn).trim() : '';
    if (mqn) { var nt = nn ? nn + ' ' + (nn === '1' ? mqL.u1 : mqL.u)[lang()] : ''; if (mqn.textContent !== nt) mqn.textContent = nt; }
    try { mqSortSync(); } catch (er) { /* negeren */ }
    if (mode() === 'all') { mqApply(); mqEnd(); }
  }
  var MQSORT = { nl: 'Sorteren', fr: 'Trier', en: 'Sort' };
  function mqSortSync() {
    var fp = $('#gFilterPanel'), sel = $('#gSort'); if (!fp || !sel) return;
    var sec = $('.cl-sortsec', fp);
    if (!sec) {
      sec = document.createElement('details'); sec.className = 'gf-sec cl-sortsec'; sec.open = true;
      sec.innerHTML = '<summary><span></span><svg class="ic sm chev"><use href="#i-down"></use></svg></summary><div class="gf-body" data-cl-sorts></div>';
      fp.insertBefore(sec, fp.firstChild);
    }
    var sm = $('summary span', sec); if (sm && sm.textContent !== MQSORT[lang()]) sm.textContent = MQSORT[lang()];
    var body = $('[data-cl-sorts]', sec), sig = [].map.call(sel.options, function (o) { return o.value + ':' + o.text; }).join('|') + '#' + sel.value;
    if (body._sig === sig) return; body._sig = sig;
    body.innerHTML = [].map.call(sel.options, function (o) {
      var on = o.value === sel.value; return '<button type="button" class="g-pill' + (on ? ' on' : '') + '" data-cl-sort="' + esc(o.value) + '" aria-pressed="' + on + '">' + esc(o.text) + '</button>';
    }).join('');
  }
  document.addEventListener('click', function (e) {
    var so = S.on && e.target && e.target.closest && e.target.closest('[data-cl-sort]'); if (!so) return;
    var sel = $('#gSort'); if (!sel) return;
    sel.value = so.getAttribute('data-cl-sort'); sel.dispatchEvent(new Event('change', { bubbles: true }));
    try { mqSortSync(); } catch (er) { /* negeren */ }
  });
  document.addEventListener('click', function (e) {
    var b = S.on && e.target && e.target.closest && e.target.closest('[data-cl-mqf]'); if (!b) return;
    var fb = $('#gFiltersBtn'); if (fb) fb.click();
    try { mqSync(); } catch (er) { /* negeren */ }
  });
  /* Enter/Zoek op het schermtoetsenbord: meteen toepassen en het toetsenbord sluiten */
  document.addEventListener('keydown', function (e) {
    var q = e.key === 'Enter' && e.target && e.target.closest && e.target.closest('.cl-mq [data-cl-q]'); if (!q) return;
    clearTimeout(S.qT); setQ(q.value); try { q.blur(); } catch (er) { /* negeren */ }
  });

  /* ---------- desktop (>= 1100 px), Bladeren: de tabrij (.cats) scrolt gewoon mee weg met het raster (Andrea: niet sticky) ----------
     Zelfde aanpak als mbSlide: translate3d volgens #gScroll.scrollTop, max de hoogte van de rij + haar afstand tot de kopbalk, daarna visibility:hidden (niet klikbaar
     boven de tegels). Het raster begint op desktop al direct onder de kopbalk (.gridview top var(--hdr), padding-top in #gScroll), dus er blijft geen lege band en de
     vaste filterbalk (.cl-stk, top hdr + 8) verschijnt pas als de rij al weg is. Rip Lab: rij blijft op haar plek.
     Open productpagina (desktop): de rij volgt de scroller van de pagina (#pdpPage .pg-scroll) en scrolt ook mee weg; na het sluiten van de pagina
     (klik of Escape) wordt de stand na ca. 80 ms herberekend, zodat de rij niet tot de trage poll (300 ms) verschoven blijft. */
  var DK = { y: -1, on: false, g: 0, fy: 0, py: 0 };
  window.CW_CL_DK = function () { try { dkSlide(); } catch (er) { /* negeren */ } };
  function dkSlide() {
    var el = $('.cats'); if (!el) return;
    var sc = $('#gScroll'), gv = $('.gridview'), y = 0, h = 0;
    /* 16 okt (Andrea): tijdens de sluitanimatie (pg-closing, app.js) telt de pagina al als dicht, zodat de tabrij meteen naar haar plek in
       Bladeren glijdt (css-overgang op pg-closing) en niet tot het einde op de plek van de productpagina blijft staan */
    var closing = document.body.classList.contains('pg-closing');
    var pgOpen = document.body.classList.contains('pg-open') && !closing, open = pgOpen || !!$('#pdpSheet.on');
    /* Bladeren: de tabrij scrolt mee weg (ook met cl-flow, dan met de scrollpositie van het venster; gv.offsetTop is daar de kopbalk) */
    if (desk() && !open && mode() === 'all' && sc && gv && flowOn()) {
      /* cl-flow: de rij staat bij scroll 0 ann px lager (translate, hdrShift) en schuift daarna 1:1 weg tot onder de ingeklapte kopbalk */
      h = el.offsetTop + el.offsetHeight - (FL.hdr || cssPx('--hdr'));
      if (h > 0) y = Math.max(0, Math.min(gsTop() - (FL.ann || 0), h));
    } else if (desk() && !open && mode() === 'all' && sc && gv) {
      h = el.offsetTop + el.offsetHeight - gv.offsetTop; /* fixed: offsetTop is de afstand tot de bovenrand van het venster, zonder transform */
      if (h > 0) y = Math.max(0, Math.min(gsTop(), h));
    } else if (desk() && pgOpen && !$('#pdpSheet.on')) {
      /* 11 okt (Andrea): ook op de productpagina scrolt de tabrij mee weg (niet sticky); de scroller is dan #pdpPage .pg-scroll.
         De rij schuift tot ze onder de kopbalk (var(--hdr)) verdwenen is; de kaart van de productpagina blijft op zijn plek. */
      var ps = $('#pdpPage .pg-scroll');
      if (ps) {
        if (!DK.probe || !DK.probe.isConnected) { DK.probe = document.createElement('i'); DK.probe.setAttribute('aria-hidden', 'true'); DK.probe.style.cssText = 'position:fixed;left:0;top:var(--hdr);width:0;height:0;pointer-events:none;visibility:hidden'; document.body.appendChild(DK.probe); }
        h = el.offsetTop + el.offsetHeight - DK.probe.getBoundingClientRect().top;
        if (h > 0) y = Math.max(0, Math.min(ps.scrollTop, h));
      }
    }
    /* cl-flow: het kader (Clean, vaste laag) schuift in Bladeren mee met de tabrij, zodat de rij binnen het kader blijft; bij een open
       productpagina blijft het waar het was (de pagina eronder staat vast), in de andere modi staat het stil. --cl-fy staat op het kader zelf
       (S.lf), zodat een scrollframe niets herberekent buiten die laag; y komt hierboven uit gsTop(), met cl-flow dus de vensterscroll */
    /* cl-flow, open productpagina: de productlaag schuift even ver mee omhoog als de tabrij wegschuift (inline transform op #pdpPage, geen
       variabele die door de hele productpagina erft), zodat haar
       Terug-balk zonder kier onder de kopbalk aansluit en er geen lege strook op de plek van de rij blijft */
    var pgEl = $('#pdpPage'), py = closing ? DK.py : flowOn() && S.on && desk() && pgOpen && !$('#pdpSheet.on') ? y : 0;
    if (pgEl && (py !== DK.py || DK.pyEl !== pgEl)) {
      DK.py = py; DK.pyEl = pgEl;
      if (py) pgEl.style.transform = 'translate3d(0,' + (-py) + 'px,0)'; else pgEl.style.removeProperty('transform');
    }
    /* open productpagina (pg-open): het kader volgt dezelfde y als de tabrij (die volgt de scroller van de pagina, bij het openen dus 0). Eerder bleef het kader op de
       oude stand (DK.fy) staan terwijl de rij terugsprong naar y = 0: de rij stond dan boven het kader en er bleef een lege lavendel strook staan.
       Enkel bij het blad (#pdpSheet.on) volgt de rij niets en blijft het kader waar het was. */
    var fy = flowOn() && S.on && desk() && mode() === 'all' ? (open && !(pgOpen && !$('#pdpSheet.on')) ? DK.fy : y) : 0, lf = S.lf;
    if (lf && (fy !== DK.fy || DK.fyEl !== lf)) {
      DK.fy = fy; DK.fyEl = lf;
      if (fy) lf.style.setProperty('--cl-fy', fy + 'px'); else lf.style.removeProperty('--cl-fy');
    }
    if (DK.y === y) return;
    DK.y = y;
    el.style.transform = y ? 'translate3d(0,' + (-y) + 'px,0)' : '';
    el.style.visibility = y && h && y >= h ? 'hidden' : '';
  }
  function dkInit() {
    if (DK.on) return; DK.on = true;
    document.addEventListener('scroll', function (e) { var tg = e.target; if (tg && (gsEvt(e) || (tg.classList && tg.classList.contains('pg-scroll')))) { cancelAnimationFrame(DK.g); DK.g = requestAnimationFrame(dkSlide); } }, true);
    window.addEventListener('resize', function () { DK.y = -1; dkSlide(); });
    var dkAfter = function () { clearTimeout(DK.t2); DK.t2 = setTimeout(function () { DK.y = -1; try { dkSlide(); } catch (er) { /* negeren */ } }, 80); };
    document.addEventListener('click', dkAfter, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') dkAfter(); }, true);
    /* modus- en productwissels veranderen de scrollpositie niet: trage poll (alleen desktop, zichtbaar tabblad), vergelijkt enkel een getal */
    setInterval(function () { if (!document.hidden && desk()) { try { dkSlide(); } catch (er) { /* negeren */ } } }, 300);
    dkSlide();
  }

  function mbInit() {
    if (MB.el || !document.body) return;
    var el = document.createElement('nav');
    el.className = 'cl-mbar'; el.setAttribute('role', 'group'); el.setAttribute('aria-label', modiG());
    var mb = function (v, icn) {
      return '<button type="button" data-cl-mv="' + v + '" aria-pressed="false" aria-label="' + esc(modiN(v)) + '"><span class="cl-it" aria-hidden="true">' + ic(icn) + '</span><span class="cl-t" aria-hidden="true">' + esc(modiK(v)) + '</span></button>';
    };
    el.innerHTML = '<span class="cl-mbi" aria-hidden="true"></span>' + mb('grid', 'grid') + mb('lab', 'layers') + mb('chase', 'chase') +
      '<button type="button" class="cl-mlive" data-cl-mv="live" hidden aria-label="' + esc(MODI.live.a[lang()]) + '" title="' + esc(MODI.live.a[lang()]) + '"><span class="cl-it cl-rd" aria-hidden="true"><i></i></span><span class="cl-t">' + esc(MODI.live.m[lang()]) + '</span></button>';
    document.body.appendChild(el);
    /* vaste ingang naar de zwevende CARDIX-chat (de mandjebalk met CARDIX-knop en de zoekbalkknop bestaan hier niet meer) */
    if (!$('.cl-fabm')) {
      var fm = document.createElement('button'); fm.type = 'button'; fm.className = 'cl-fabm'; fm.setAttribute('data-cl-fabm', '');
      fm.setAttribute('aria-label', tt('cdx')); fm.title = tt('cdx'); fm.setAttribute('aria-expanded', 'false');
      var fs0 = $('#cdkBarBtn .cdx-av') || $('#cdkTabR .cdx-av') || $('.cdx-av[data-cdx]');
      fm.innerHTML = '<span class="cdx-av">' + (fs0 ? fs0.innerHTML : '') + '</span>';
      fm.addEventListener('click', function () { var t = $('#cdkTabR') || $('#cdkBarBtn'); if (t) t.click(); });
      document.body.appendChild(fm);
    }
    document.documentElement.classList.add('cl-mb');
    MB.el = el;
    el.addEventListener('click', function (e) { var b = e.target.closest && e.target.closest('[data-cl-mv]'); if (b && b.getAttribute('data-cl-mv') !== 'live') { S.popAt = 0; mbGo(b.getAttribute('data-cl-mv')); } });
    el.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight' && e.key !== 'Home' && e.key !== 'End') return;
      var bs = $$('button', el).filter(function (b) { return !b.hidden; }), i = bs.indexOf(e.target.closest('button')); if (i < 0) return;
      var j = e.key === 'Home' ? 0 : e.key === 'End' ? bs.length - 1 : (i + (e.key === 'ArrowRight' ? 1 : -1) + bs.length) % bs.length;
      e.preventDefault(); bs[j].focus();
    });
    document.addEventListener('scroll', function (e) { if (MB.el && gsEvt(e)) { cancelAnimationFrame(MB.g); MB.g = requestAnimationFrame(mbSlide); return; } if (MB.el && e.target && e.target.id === 'feed') { cancelAnimationFrame(MB.t); MB.t = requestAnimationFrame(mbSync); } }, true);
    document.addEventListener('click', function () { if (MB.el) setTimeout(function () { mbSync(); try { dkSlide(); } catch (er) { /* negeren */ } try { mqSync(); } catch (er) { /* negeren */ } }, 80); }, true);
    setInterval(function () { if (document.hidden || !mbSmall() || document.documentElement.classList.contains('cw-sf-mob')) return; /* niet meten achter het streamscherm */ try { flowTopSync(); annSync(); hdrShift(true); mbSync(); demoPlace(); mqSync(); if (S.on) syncPill(); if (S.on && mode() === 'all') h3Badges(); /* 17 okt: 3D-label ook op gsm (tick() staat daar stil) */ } catch (er) { /* negeren */ } }, 400);
    mbSync();
  }

  /* ---------- Ontdekken (17 okt): wissel naar een manier, tabuitleg, label "Nieuw", eenmalige tip, meten ----------
     goMode(v) stuurt de echte tab aan (desktop .cl-mseg, gsm mbGo); staat er een productpagina open, dan sluit hij die eerst (pageCloseAll) en wacht kort op de
     terugsprong. window.cwGoMode is de ingang voor app.js (budgetkaart, link op de productpagina). Meten: geen trackfunctie in de bronnen, dus een window-event
     'cw:track' (detail { name, ... }) en window.CW_RS_TRACK(name, data) als die bestaat (zelfde als cwDiscTrack in app.js). Geen externe dienst. */
  var DSL = {
    pk: { nl: 'Stel een pakket samen', fr: 'Compose un colis', en: 'Build a package' },
    nw: { nl: 'Nieuw', fr: 'Nouveau', en: 'New' },
    tn: { nl: 'Nieuw:', fr: 'Nouveau :', en: 'New:' },
    tt: { nl: 'geef je budget, wij stellen je pakket samen.', fr: 'donne ton budget, on compose ton colis.', en: 'give us your budget and we put your package together.' },
    go: { nl: 'Probeer het', fr: 'Essaie', en: 'Try it' },
    gom: { nl: 'Probeer', fr: 'Essaie', en: 'Try' },
    mt: { nl: 'Nieuw: Samenstellen', fr: 'Nouveau : Composer', en: 'New: Build' },
    ms: { nl: 'Geef je budget, wij stellen je pakket samen', fr: 'Donne ton budget, on compose ton colis', en: 'Give us your budget and we put your package together' }
  };
  var DS = { opened: false, visits: 0, tipDone: false, el: null, scrollMax: 0, filt: 0, sig: null, ms: 0, last: 0, cartAny: false, t0: 0, shown: false, timer: 0 };
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* negeren */ } }
  function dsTrack(name, data) {
    try {
      var d = { name: name }; if (data) for (var k in data) d[k] = data[k];
      if (typeof window.CW_RS_TRACK === 'function') window.CW_RS_TRACK(name, data || {});
      window.dispatchEvent(new CustomEvent('cw:track', { detail: d }));
    } catch (e) { /* negeren */ }
  }
  function goMode(v) {
    if (v !== 'grid' && v !== 'lab' && v !== 'chase') return false;
    var go = function () {
      S.popAt = 0;
      if (MB.el && mbSmall()) { mbGo(v); return; }
      var b = $('.cl-mseg [data-cl-view="' + v + '"]');
      if (b) { b.click(); return; }
      if (v !== 'grid') S.ft = v;
      var vb = $('.viewseg [data-view="' + (v === 'grid' ? 'grid' : 'feed') + '"]'); if (vb) vb.click();
    };
    if (document.body.classList.contains('pg-open') && typeof window.pageCloseAll === 'function') {
      if (mode() !== 'all') S.ftHold = { ft: v, t: performance.now() };
      window.pageCloseAll(); setTimeout(go, 450); return true;
    }
    go(); return true;
  }
  window.cwGoMode = goMode;
  /* de budgetkaart in het raster verdwijnt bij een zoekopdracht of een categorie-, groep- of taalfilter (de pagina regelt de rest zelf) */
  function dsOff() { document.body.classList.toggle('cl-bt-off', !!((S.qt && S.qt.length) || S.grp || S.sub || S.lang)); }
  /* label "Nieuw" op Samenstellen: tot de bezoeker het 1 keer opende of na 5 bezoeken (localStorage-teller) */
  function dsBadge() {
    document.body.classList.toggle('cl-nudge', !DS.opened);
    $$c('.cl-mseg [data-cl-view="lab"], .cl-mbar [data-cl-mv="lab"]', 1500).forEach(function (b) {
      var sh = $('.cl-sheen', b), gl = $('.cl-glow', b);
      if (DS.opened) { [sh, gl].forEach(function (x) { if (x && !x._out) { x._out = 1; x.classList.add('cl-fx-out'); setTimeout(function () { x.remove(); }, 600); } }); return; }
      if (!sh) { sh = document.createElement('span'); sh.className = 'cl-sheen'; sh.setAttribute('aria-hidden', 'true'); sh.innerHTML = '<i></i>'; b.appendChild(sh); }
      if (!gl && b.closest('.cl-mseg')) { gl = document.createElement('span'); gl.className = 'cl-glow'; gl.setAttribute('aria-hidden', 'true'); b.insertBefore(gl, b.firstChild); }
    });
    var on = !DS.opened && DS.visits <= 5, w = DSL.nw[lang()];
    /* gouden pil (variant 3, ook 12/13/14) in modus 8: het label staat inline achter de naam in .cl-tx in plaats van over de rand van de knop */
    var inl = document.documentElement.classList.contains('cl-mbv-3') && document.body.classList.contains('cl-m8');
    $$c('.cl-mseg [data-cl-view="lab"], .cl-mbar [data-cl-mv="lab"]', 1500).forEach(function (b) {
      var n = $('.cl-new', b);
      /* 16 okt (Andrea: "een echte mooie animatie dat die verdwijnt"): de badge veert op, spat in goud uiteen en sluit de ruimte zacht */
      if (!on) { if (n && !n._out) { n._out = 1; if (window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches) n.remove(); else { n.style.maxWidth = n.offsetWidth + 'px'; n.classList.add('cl-new-out'); setTimeout(function () { n.remove(); }, 700); } } return; }
      var host = b.closest('.cl-mbar') ? ($('.cl-it', b) || b) : ((inl && $('.cl-tx', b)) || b);
      if (!n) { n = document.createElement('span'); n.className = 'cl-new'; n.setAttribute('aria-hidden', 'true'); }
      if (n.parentNode !== host) host.appendChild(n);
      if (n.textContent !== w) n.textContent = w;
    });
  }
  function dsBlocked() {
    return document.body.classList.contains('pg-open') || !!$('#pdpSheet.on') || cartOpen() || !!$('#ripSheet.on') || cdxOpen();
  }
  function dsTipEl() {
    if (DS.el) return DS.el;
    var el = document.createElement('div');
    el.className = 'cl-tip'; el.setAttribute('role', 'status'); el.hidden = true;
    el.innerHTML = '<span class="cl-tip-ic" aria-hidden="true">' + ic('layers') + '</span><span class="cl-tip-m"><b data-cl-tipmt></b><span data-cl-tipms></span></span><span class="cl-tip-t"><b data-cl-tipn></b> <span data-cl-tipt></span></span><span class="cl-tip-a"><button type="button" class="cl-tip-go" data-cl-tipgo></button>' +
      '<button type="button" class="cl-tip-x" data-cl-tipx><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></span>';
    document.body.appendChild(el); DS.el = el;
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-cl-tipgo]')) { dsTrack('disc_tip_click'); dsTipEnd(); goMode('lab'); }
      else if (e.target.closest('[data-cl-tipx]')) { dsTrack('disc_tip_close'); dsTipEnd(); }
    });
    return el;
  }
  /* de tip is gedaan (geklikt, gesloten of Samenstellen al geopend): nooit meer tonen */
  function dsTipEnd() { DS.tipDone = true; lsSet('cw-disc-tip', '1'); dsTipHide(); }
  /* gsm: de kaart schuift omlaag (260 ms) voor hij verdwijnt; desktop meteen weg */
  function dsTipHide() {
    var el = DS.el; if (!el || el.hidden || el._out) return;
    if (desk() || (window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches)) { el.hidden = true; return; }
    el._out = true; el.classList.add('out');
    setTimeout(function () { el.hidden = true; el.classList.remove('out'); el._out = false; }, 260);
  }
  /* de zichtbare knop van Samenstellen: bovenaan de tab links in .cl-mseg, in de sticky balk het icoon rechts (.cl-stk-v); geen van beide zichtbaar = tijdelijk verborgen */
  function dsLabBtn() {
    var c = $$('.cl-mseg [data-cl-view="lab"], .cl-stk-v [data-cl-view="lab"]');
    for (var i = 0; i < c.length; i++) {
      var b = c[i], r = b.getBoundingClientRect();
      if (!r.width || !r.height || r.bottom < 0 || r.top > innerHeight - 40 || r.right < 0 || r.left > innerWidth) continue;
      var cs = getComputedStyle(b); if (cs.visibility === 'hidden' || cs.display === 'none') continue;
      for (var n = b, ok = true; n && n !== document.body; n = n.parentElement) { var ns = getComputedStyle(n); if (ns.display === 'none' || ns.visibility === 'hidden' || ns.opacity === '0') { ok = false; break; } }
      if (ok) return r;
    }
    return null;
  }
  function dsTipPlace(el) {
    if (!desk()) { el.style.left = ''; el.style.top = ''; el.style.visibility = ''; return; }
    var r = dsLabBtn();
    if (!r) { el.style.visibility = 'hidden'; return; }
    el.style.visibility = '';
    /* 16 okt (Andrea): altijd naar rechts uitklappen vanaf de knop (de clamp hieronder houdt hem in beeld) */
    var w = el.offsetWidth, c = r.left + r.width / 2, left = c - 24;
    left = Math.max(12, Math.min(innerWidth - w - 12, left));
    el.style.left = Math.round(left) + 'px'; el.style.top = Math.round(r.bottom + 12) + 'px';
    el.style.setProperty('--ax', Math.max(18, Math.min(w - 18, Math.round(c - left))) + 'px');
  }
  function dsTipSync(want) {
    var el = DS.el;
    if (!want || DS.tipDone) { dsTipHide(); return; }
    el = dsTipEl(); if (el._out) return;
    var l = lang(), n = $('[data-cl-tipn]', el), t = $('[data-cl-tipt]', el), g = $('[data-cl-tipgo]', el), x = $('[data-cl-tipx]', el);
    if (n.textContent !== DSL.tn[l]) n.textContent = DSL.tn[l];
    if (t.textContent !== DSL.tt[l]) t.textContent = DSL.tt[l];
    var gw = desk() ? DSL.go[l] : DSL.gom[l]; if (g.textContent !== gw) g.textContent = gw;
    var mt = $('[data-cl-tipmt]', el), ms = $('[data-cl-tipms]', el);
    if (mt.textContent !== DSL.mt[l]) mt.textContent = DSL.mt[l];
    if (ms.textContent !== DSL.ms[l]) ms.textContent = DSL.ms[l];
    if (x.getAttribute('aria-label') !== tt('close')) x.setAttribute('aria-label', tt('close'));
    if (el.hidden) el.hidden = false;
    dsTipPlace(el);
    if (!DS.shown) { DS.shown = true; dsTrack('disc_tip_show'); }
  }
  function dsTick() {
    if (!document.body) return;
    var now = performance.now(), dt = DS.last ? Math.min(1000, now - DS.last) : 0; DS.last = now;
    dsOff(); dsBadge();
    /* 16 okt: enkel echt geopend tellen (klik op de tab of binnenkomen via #samenstellen). Op gsm staat de pagina bij het opstarten even
       in Samenstellen voor Clean naar Shop wisselt; dat telde mee, waardoor een nieuwe bezoeker meteen geen label, animatie of tip kreeg. */
    if (!DS.opened && shownView() === 'lab' && S.ready && (S.userAct || MB.touched || (S.hp && S.hp.t === 'lab'))) { DS.opened = true; lsSet('cw-disc-opened', '1'); dsBadge(); }
    if (DS.opened && !DS.tipDone) dsTipEnd();
    if (DS.tipDone) { dsTipHide(); return; }
    if (readCart().u > 0) DS.cartAny = true;
    var grid = mode() === 'all' && shownView() === 'grid' && !document.hidden, free = grid && !dsBlocked();
    if (free) {
      var y = gsTop(); if (y > DS.scrollMax) DS.scrollMax = y;
      DS.ms += dt;
      var sig = mbGridHash().split('?')[0] + '|' + (S.grp || '') + '|' + (S.sub || '') + '|' + (S.lang || '');
      if (DS.sig === null || now - DS.t0 < 3000) DS.sig = sig; /* de eerste 3 s zijn het opstarten van de pagina, geen keuze van de bezoeker */
      else if (sig !== DS.sig) { DS.sig = sig; DS.filt++; }
    }
    var sigl = DS.scrollMax >= 800 || DS.filt >= 2 || (DS.ms >= 25000 && !DS.cartAny);
    dsTipSync(!!(DS.shown ? free : free && sigl));
  }
  function dsInit() {
    if (DS.timer) return;
    DS.t0 = performance.now();
    DS.opened = lsGet('cw-disc-opened') === '1'; DS.tipDone = lsGet('cw-disc-tip') === '1';
    var v = parseInt(lsGet('cw-disc-visits') || '0', 10) || 0, counted = false;
    try { counted = sessionStorage.getItem('cw-disc-vc') === '1'; } catch (e) { counted = false; }
    if (!counted) { v++; lsSet('cw-disc-visits', String(v)); try { sessionStorage.setItem('cw-disc-vc', '1'); } catch (e) { /* negeren */ } }
    DS.visits = v;
    DS.timer = setInterval(function () { try { dsTick(); } catch (e) { /* negeren */ } }, 300);
    window.addEventListener('resize', function () { if (DS.el && !DS.el.hidden) dsTipPlace(DS.el); });
    var pl = 0; document.addEventListener('scroll', function () { if (pl || !DS.el || DS.el.hidden) return; pl = requestAnimationFrame(function () { pl = 0; if (DS.el && !DS.el.hidden) dsTipPlace(DS.el); }); }, true);
  }

  /* ---------- MODUSBALK VARIANTEN (16 okt, proef voor de eigenaar): ?mb=1 tot ?mb=11 ----------
     Met de parameter krijgt html de klassen cl-mbv en cl-mbv-<n>; de stijl staat in het blok "MODUSBALK VARIANTEN 16 okt" in clean-inject.prod.css.
     Enkel uiterlijk: markup, indicator (.cl-ind, .cl-mbi) en logica van de balk blijven zoals ze zijn. De keuze blijft per tabblad bewaard
     (sessionStorage cl-mbv), zodat ze blijft staan als het adres binnen de pagina wisselt. Rechtsonder een klein paneel (1 tot 11 en Uit) dat
     wisselt zonder herladen; het schrijft enkel de parameter mb in het adres (replaceState met dezelfde history.state), pad en hash blijven
     ongemoeid, zodat hashSync en urlOf (die andere parameters laten staan) niets merken. Zonder parameter en zonder bewaarde keuze: niets.
     Ronde 3 (16 okt): 12, 13 en 14 zijn uitwerkingen van variant 3 en krijgen er ook cl-mbv-3 bij (ze erven al zijn regels). 12 zet een titel links
     en een live-pil rechts in de rij (mbvSync hieronder, mee in sync()), 13 en 14 zijn enkel css. De head zet dezelfde klassen al voor de eerste paint
     (CL_MBV in pack.js, zelfde bereik: max hier = CL_MBV_MAX daar, pack.js controleert dat); classList voegt niets dubbel toe. Uit haalt alle
     klassen weg en wist de bewaarde keuze. */
  var MBV = { n: 0, max: 14, key: 'cl-mbv', el: null, lk: '' };
  var MBV_NAAM = { 12: 'De ruimte gebruiken', 13: 'Alles in een kader', 14: 'Filters als ronde pil' };
  function mbvFonts() {
    /* de drie extra lettertypes enkel in de proef laden (Anton en Outfit heeft de pagina al) */
    if (document.getElementById('cl-mbv-fonts')) return;
    var l = document.createElement('link'); l.id = 'cl-mbv-fonts'; l.rel = 'stylesheet';
    l.href = 'https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,500..800&family=Space+Grotesk:wght@500..700&family=Unbounded:wght@500..700&display=swap';
    (document.head || document.documentElement).appendChild(l);
  }
  /* 16 okt (Andrea: "zet dit over naar de echte pagina"): variant 12 is de standaard voor iedereen. Zonder ?mb en zonder bewaarde keuze geldt 12,
     zonder paneel en zonder iets te bewaren; ?mb=N (ook 0 = de oude balk) blijft het testpaneel tonen. */
  var MBV_STD = 12;
  function mbvApply(n, stil) {
    var de = document.documentElement;
    for (var i = 1; i <= MBV.max; i++) de.classList.remove('cl-mbv-' + i);
    MBV.n = n;
    if (n) { de.classList.add('cl-mbv', 'cl-mbv-' + n); if (n >= 12) de.classList.add('cl-mbv-3'); mbvFonts(); } else de.classList.remove('cl-mbv');
    if (!stil) { try { if (n) sessionStorage.setItem(MBV.key, String(n)); else sessionStorage.removeItem(MBV.key); } catch (e) { /* negeren */ } }
    if (MBV.el) $$('button[data-mbv]', MBV.el).forEach(function (b) { var on = +b.getAttribute('data-mbv') === n; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    /* geen eigen poll meer: mbvSync draait mee met sync() (de bestaande tick van Clean); hier enkel meteen bij het wisselen */
    try { mbvSync(); } catch (e) { /* negeren */ }
  }
  /* ---- variant 12 "De ruimte gebruiken" (enkel desktop): titel links en een live-knop rechts in de rij van de modusbalk ----
     .cl-mbvt (titel: naam van de modus in Anton, in Shop met het aantal producten uit #gCount/#gCountL eronder) en .cl-mbvr staan in .cl-bar
     rond .cl-mwrap. 16 okt (Andrea): Filters en Aanbevolen blijven op hun eigen plek (geen verhuizing meer); rechts staat nu een live-pil die de
     titel links in gewicht spiegelt, in alle drie de modi. Status = liveStatus() (body.cw-liveq-known / cw-is-offline uit de bestaande stream-poll),
     bijgewerkt bij elke sync-tick, dus geen eigen poll. Live: diep paarse pil met rode pulserende stip, "Nu live", klik = het grote streamscherm
     (window.cwOpenStream, anders de LIVE-ingang van de kopbalk). Anders: rustige witte pil met grijze stip, "Live Rip & Ship" en twee kleine
     links naar Twitch en TikTok. De oude live-cel ([data-cl-live]) verbergt de css in deze variant, zodat er geen twee live-knoppen staan. */
  var MBV_LT = {
    nl: { lt: 'Nu live', ls: 'Kijk mee en bestel mee', ot: 'Live Rip & Ship', os: 'Volg ons op TikTok en Twitch', tw: 'Volg ons op Twitch', tt: 'Volg ons op TikTok' },
    fr: { lt: 'En direct', ls: 'Regarde et commande en direct', ot: 'Live Rip & Ship', os: 'Suis-nous sur TikTok et Twitch', tw: 'Suis-nous sur Twitch', tt: 'Suis-nous sur TikTok' },
    en: { lt: 'Live now', ls: 'Watch and order live', ot: 'Live Rip & Ship', os: 'Follow us on TikTok and Twitch', tw: 'Follow us on Twitch', tt: 'Follow us on TikTok' }
  };
  var MBV_TW = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M4.3 3 3 6.4v13.3h4.6V22h2.6l2.4-2.3h3.7l5-5V3H4.3zm15.6 10.8-2.9 2.9h-4.6l-2.4 2.4v-2.4H6.1V4.8h13.8v9zM17 7.9v5h-1.7v-5H17zm-4.6 0v5h-1.7v-5h1.7z"/></svg>';
  var MBV_TT = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M16.6 3c.3 2.3 1.6 3.8 3.9 4v2.7c-1.4.1-2.6-.3-3.9-1.1v5.3c0 6.3-6.9 8.3-9.7 3.8-1.8-3-.7-8.2 5.1-8.4v2.8c-.4.1-.9.2-1.3.3-1.3.4-2 1.3-1.8 2.8.4 2.7 5.4 3.5 5-1.8V3h2.7z"/></svg>';
  function mbvLive(r) {
    var on = liveStatus() === 'live', l = lang(), T = MBV_LT[l] || MBV_LT.nl, k = (on ? 'live' : 'off') + '|' + l;
    if (MBV.lk === k && r.firstChild) return;
    MBV.lk = k;
    if (on) {
      r.innerHTML = '<button type="button" class="cl-mbvl cl-mbvl-on" aria-haspopup="dialog" aria-label="' + esc(T.lt + ', ' + T.ls) + '">' +
        '<i class="cl-mbvl-d" aria-hidden="true"></i><span class="cl-mbvl-x"><span class="cl-mbvl-t">' + esc(T.lt) + '</span><span class="cl-mbvl-s">' + esc(T.ls) + '</span></span></button>';
    } else {
      r.innerHTML = '<div class="cl-mbvl cl-mbvl-off"><i class="cl-mbvl-d" aria-hidden="true"></i><span class="cl-mbvl-x"><span class="cl-mbvl-t">' + esc(T.ot) + '</span><span class="cl-mbvl-s">' + esc(T.os) + '</span></span>' +
        '<span class="cl-mbvl-ic"><a class="cl-mbvl-tt" href="https://www.tiktok.com/@cardworld.be_nl" target="_blank" rel="noopener" aria-label="' + esc(T.tt) + '" title="TikTok">' + MBV_TT + '</a>' +
        '<a class="cl-mbvl-tw" href="https://www.twitch.tv/cardworldbe" target="_blank" rel="noopener" aria-label="' + esc(T.tw) + '" title="Twitch">' + MBV_TW + '</a></span></div>';
    }
  }
  function mbvSync() {
    var bar = $('.cats .cl-bar'), w = bar && $('.cl-mwrap', bar);
    if (!(MBV.n === 12 && S.on && desk() && w)) {
      $$('.cl-mbvt,.cl-mbvr').forEach(function (x) { x.remove(); });
      MBV.lk = '';
      return;
    }
    var t = $('.cl-mbvt', bar), r = $('.cl-mbvr', bar);
    if (!t) { t = document.createElement('div'); t.className = 'cl-mbvt'; t.setAttribute('aria-hidden', 'true'); t.innerHTML = '<span class="cl-mbvt-p"><span class="cl-mbvt-t"></span><span class="cl-mbvt-n"></span></span>'; }
    if (t.nextElementSibling !== w) bar.insertBefore(t, w);
    if (!r) {
      r = document.createElement('div'); r.className = 'cl-mbvr'; MBV.lk = '';
      /* klik op de live-pil: het grote streamscherm, zoals de bestaande LIVE-knop */
      r.addEventListener('click', function (e) {
        if (!(e.target.closest && e.target.closest('.cl-mbvl-on'))) return;
        if (typeof window.cwOpenStream === 'function') { window.cwOpenStream(); return; }
        var h = $('#cwhLive') || $('#colLTab'); if (h) h.click();
      });
    }
    if (w.nextElementSibling !== r) bar.insertBefore(r, w.nextSibling);
    /* titel: Shop met het aantal producten, Samenstellen en Chase zoeken enkel de naam */
    /* 16 okt (Andrea): links de slogan in plaats van de paginanaam (de actieve tab toont de pagina al), zonder producttelling */
    var MBV_SLOGAN = { nl: 'De #1 TCG winkel in de Benelux \u26A1\uFE0F', fr: 'La boutique TCG n\u00B01 du Benelux \u26A1\uFE0F', en: 'The #1 TCG store in the Benelux \u26A1\uFE0F' };
    var nm = MBV_SLOGAN[(document.documentElement.lang || 'nl').slice(0, 2)] || MBV_SLOGAN.nl, cnt = '';
    var t1 = $('.cl-mbvt-t', t), t2 = $('.cl-mbvt-n', t);
    if (t1.textContent !== nm) t1.textContent = nm;
    if (t2.textContent !== cnt) t2.textContent = cnt;
    t2.hidden = !cnt;
    mbvLive(r);
  }
  function mbvUrl(n) {
    /* enkel de parameter mb bijwerken; pad, andere parameters en hash blijven exact zoals ze zijn */
    try {
      var sp = new URLSearchParams(location.search); sp.set('mb', String(n));
      var qs = sp.toString(), url = location.pathname + (qs ? '?' + qs : '') + location.hash;
      if (url !== location.pathname + location.search + location.hash) history.replaceState(history.state, '', url);
    } catch (e) { /* negeren */ }
  }
  function mbvPanel() {
    if (MBV.el || !document.body) return;
    var el = document.createElement('div'); el.className = 'cl-mbvp'; el.setAttribute('role', 'group'); el.setAttribute('aria-label', 'Modusbalk varianten');
    var h = '<span class="cl-mbvp-l">Modusbalk</span><div class="cl-mbvp-g">';
    for (var i = 1; i <= MBV.max; i++) h += '<button type="button" data-mbv="' + i + '" aria-pressed="false"' + (MBV_NAAM[i] ? ' title="' + esc(i + ': ' + MBV_NAAM[i]) + '"' : '') + '>' + i + '</button>';
    el.innerHTML = h + '<button type="button" class="cl-mbvp-x" data-mbv="0" aria-pressed="false">Uit</button></div>';
    el.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-mbv]'); if (!b) return;
      var n = parseInt(b.getAttribute('data-mbv'), 10) || 0; mbvApply(n); mbvUrl(n);
    });
    document.body.appendChild(el); MBV.el = el; mbvApply(MBV.n);
  }
  function mbvInit() {
    var p = null, n = 0;
    try { p = new URLSearchParams(location.search).get('mb'); } catch (e) { p = null; }
    if (p !== null) { n = parseInt(p, 10); if (!(n >= 1 && n <= MBV.max)) n = 0; }
    else { var s = null; try { s = sessionStorage.getItem(MBV.key); } catch (e) { s = null; } n = parseInt(s || '0', 10); if (!(n >= 1 && n <= MBV.max)) { mbvApply(MBV_STD, true); return; } }
    /* parameter aanwezig (ook mb=0) of een bewaarde variant: toepassen en het paneel tonen */
    mbvApply(n);
    if (document.body) mbvPanel(); else document.addEventListener('DOMContentLoaded', mbvPanel);
  }

  /* start: pas als de pagina is opgebouwd (korte poll, stopt zodra .cats en de feed er zijn) */
  function boot() {
    try { mbvInit(); } catch (e) { /* negeren */ }
    dsInit();
    if (!CLEAN_PROD) buildSwitch();
    S.v = getV(); S.cv = getCV(); S.kies = getKies(); S.m = getM(); S.m6v = getMap(); updateV(); updateCV(); updateK(); updateM();
    /* de pagina wist zelf de hash bij het opstarten: de oorspronkelijke URL uit de navigatiegegevens lezen */
    var h0 = location.hash, navNoHash = false;
    /* na een taalwissel (CL_TAAL in pack.js) staat het herstelde adres in window.CW_RS_TAAL: dat geldt als oorspronkelijke URL */
    try { var nv = performance.getEntriesByType('navigation')[0]; if (window.CW_RS_TAAL) nv = { name: String(window.CW_RS_TAAL) }; if (nv && nv.name) { if (nv.name.indexOf('#') > -1) h0 = nv.name.slice(nv.name.indexOf('#')); else { navNoHash = true; h0 = ''; } } } catch (e) { /* negeren */ }
    /* 16 okt (Andrea: Shop is altijd de standaard): zonder hash in de oorspronkelijke URL niet de #budget lezen die de pagina intussen zelf schreef,
       anders landde gsm in Samenstellen; een expliciete hash (#samenstellen, #chase, #p=) gaat wel voor */
    /* collectielink (/collections/<handle> of ?c=) zonder eigen hash: die filters gaan voor. De pagina zet zelf al #budget of #riplab voor wij opstarten,
       dus kijken we naar de oorspronkelijke URL (navigatiegegevens) en niet naar location.hash */
    var ch0 = navNoHash ? collHash() : '';
    /* echte filteradressen (?collection=...&card_language=Engels#shop, zie qHash): de query van de oorspronkelijke URL gaat voor */
    var s0 = location.search; try { if (nv && nv.name) s0 = new URL(nv.name).search; } catch (e) { /* negeren */ }
    /* 16 okt (advertentielink /samenstellen?franchise=onepiece&budget=...): op een Samenstellen- of Chase-adres (CW_RS_PAD) zijn franchise= en
       andere shopparameters geen shopfilters; anders sprong de pagina naar /collections/all */
    var q0 = window.CW_RS_PAD ? '' : qHash(s0, navNoHash ? '' : h0); if (q0) ch0 = q0;
    S.hp = parseHash(ch0 || h0); S.bootT = performance.now();
    /* deeplink ?p=<handle> (query) of #p=<id>: de pagina opent zelf dat product, wij herstellen of schrijven niets */
    if (/[?&]p=/.test(location.search) || /^#p=/.test(h0) || window.CW_RS_PDP) { S.hp = { t: 'foreign' }; S.fgGrid = true; } /* 22 okt: ook /products/<handle> (CW_RS_PDP) */
    /* 10 okt (Andrea): zonder hash of deeplink opent de pagina altijd in Bladeren (Shop), ook als de vorige keer Rip Lab was */
    if (!S.hp) S.hp = parseHash(collHash() || pathHash() || '#shop');
    var saved = getSaved(), tries = 0;
    var w = setInterval(function () {
      tries++;
      if (($('.cats') && $('#feed .scene')) || tries > 60) {
        clearInterval(w); S.hashDone = !saved; apply(saved, true);
        try { mbInit(); vpSync(); mqSync(); } catch (er) { /* negeren */ }
        try { dkInit(); } catch (er) { /* negeren */ }
        /* gsm: tick() stilstaat, dus de beginmodus Bladeren zetten we hier (tenzij de bezoeker al zelf een modus koos); vangnet 6 s via de inline timer van de pagina */
        /* gsm met #chase of #riplab: die manier meteen kiezen (de pagina start in de feedweergave) */
        if (!desk() && S.on && S.hp && (S.hp.t === 'chase' || S.hp.t === 'lab')) { S.ft = S.hp.t; MB.hMode = S.hp.t; if (mode() === 'all') { var fb0 = $('.viewseg [data-view="feed"]'); if (fb0) fb0.click(); } try { mbSync(); } catch (er) { /* negeren */ } }
        /* gsm, Chase zoeken als doel: vrijgeven zodra de host gemount en zichtbaar is (chase.js kan later laden, dan cw:chase-ready); max 4 s */
        if (S.chaseWait) {
          var ct0 = 0, cp = setInterval(function () {
            ct0++; try { chSync(); } catch (er) { /* negeren */ }
            var hs = CH.host, okC = document.body.classList.contains('cl-chase') && hs && !hs.hidden && hs.isConnected && !!$('.chs-finder', hs) && window.CWChase.active();
            if (okC || desk() || !S.on || MB.touched || S.userAct || S.ft !== 'chase' || ct0 > 40) { clearInterval(cp); S.chaseWait = false; if (!S.ready) markReady(); }
          }, 50);
        }
        if (S.gridWait && !(!desk() && S.on && S.hp && S.hp.t === 'all' && mode() !== 'all')) { S.gridWait = false; if (!S.ready) markReady(); }
        if (!desk() && S.on && S.hp && S.hp.t === 'all' && mode() !== 'all') {
          S.gridWait = true;
          var gt0 = 0, gp = setInterval(function () {
            gt0++;
            if (mode() === 'all' || MB.touched || S.userAct || !S.hp || S.hp.t !== 'all' || gt0 > 40) { clearInterval(gp); S.gridWait = false; markReady(); mbFiltApply(); return; }
            var gb = $('.viewseg [data-view="grid"]'); if (gb) gb.click();
          }, 100);
        } else if (!desk() && S.on && S.hp && S.hp.t === 'all') mbFiltApply();
        /* desktop en gsm wisselen (draaien, venster smaller, DevTools): de verhuisde stukken terugzetten, zie vpSync */
        var dq = window.matchMedia && window.matchMedia('(min-width:1100px)');
        if (dq) { var vf = function () { try { vpSync(); } catch (er2) { /* negeren */ } }; if (dq.addEventListener) dq.addEventListener('change', vf); else if (dq.addListener) dq.addListener(vf); }
      }
    }, 150);
    updateSw();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* 18 okt (Andrea: de live-kolom verdween half in de footer op korte pagina's): de vaste linkerkolom (#colL, desktop) stopt boven de footer. Zodra de
   footer in beeld komt, schuift de kolom met margin-top mee omhoog (transform en translate zijn al in gebruik voor verbergen en de kopbalk), zodat
   de onderkant altijd 16 px boven de footer blijft, net zoals de inhoud rechts gewoon eindigt. */
(function () {
  'use strict';
  var raf = 0, last = null;
  function run() {
    raf = 0;
    var col = document.getElementById('colL'), ft = document.querySelector('.shopify-section-group-footer-group');
    if (!col || !ft) return;
    if (!window.matchMedia('(min-width:1100px)').matches || getComputedStyle(col).position !== 'fixed') { if (last) { col.style.marginTop = col.style.marginBottom = ''; last = null; } return; }
    /* de kolom heeft top en bottom: margin-top negatief en margin-bottom positief verschuift hem als geheel (zelfde hoogte) */
    var cur = parseFloat(col.style.marginBottom) || 0, r = col.getBoundingClientRect(), base = r.bottom + cur, top = ft.getBoundingClientRect().top;
    var sh = Math.min(0, Math.round(top - 16 - base)), v = sh ? sh + 'px' : '';
    if (v !== (last || '')) { col.style.marginTop = v; col.style.marginBottom = sh ? (-sh) + 'px' : ''; last = v || null; }
  }
  function soon() { if (!raf) raf = requestAnimationFrame(run); }
  addEventListener('scroll', soon, { passive: true }); document.addEventListener('scroll', soon, { capture: true, passive: true });
  addEventListener('resize', soon); setInterval(soon, 500);
})();
